// Generated TypeScript Language Constants
// Generated from Google Sheets: 16RKqPVZ_k0yWRz76Igiu95KjKEcHezZky8oeYFGL6sY
// Sheet: Frontend
// Total entries: 272

import { SectionName } from 'modules/home/constants';
import {
  AGE_BAND,
  AGE_BAND_LABEL,
} from 'modules/benefitsWellness/constants/BenefitConstants';

// Constant declarations
export const WATCH_OPEN_ENROLLMENT_MEETING = 'WATCH_OPEN_ENROLLMENT_MEETING';
export const OPEN_ENROLLMENT_MEETING = 'OPEN_ENROLLMENT_MEETING';
export const HOME = 'HOME';
export const EXPLORE_YOUR_BENEFITS_GUIDE = 'EXPLORE_YOUR_BENEFITS_GUIDE';
export const BENEFITS_GUIDE = 'BENEFITS_GUIDE';
export const LEARN_ABOUT_YOUR_BENEFITS = 'LEARN_ABOUT_YOUR_BENEFITS';

export const NEW_HIRE_CHECKLIST = 'NEW_HIRE_CHECKLIST';
export const HOW_INSURANCE_WORKS = 'HOW_INSURANCE_WORKS';
export const DATES_AND_ELIGIBILITY = 'DATES_AND_ELIGIBILITY';
export const BENEFITS_WELLNESS = 'BENEFITS_WELLNESS';
export const TAX_ADVANTAGED_ACCTS = 'TAX_ADVANTAGED_ACCTS';
export const FOUR_O_ONE_K = 'FOUR_O_ONE_K';
export const HOLIDAYS_TIME_OFF = 'HOLIDAYS_TIME_OFF';
export const FAMILY_LEAVE = 'FAMILY_LEAVE';
export const ADDITIONAL_PERKS = 'ADDITIONAL_PERKS';
export const RESOURCES = 'RESOURCES';
export const DISCLOSURES = 'DISCLOSURES';
export const TELEHEALTH_RX_DELIVERY = 'TELEHEALTH_RX_DELIVERY';
export const LIFE_AND_DISABILITY = 'LIFE_AND_DISABILITY';
export const VOLUNTARY_BENEFITS = 'VOLUNTARY_BENEFITS';
export const VOLUNTARY = 'VOLUNTARY';
export const WORKSITE = 'WORKSITE';
export const WELLBEING = 'WELLBEING';
export const COMMUTER_GENERIC = 'COMMUTER_GENERIC';
export const CUSTOM_PAGES = 'CUSTOM_PAGES';
export const STATUS = 'STATUS';

// Empty state and error messages
export const ITS_QUIET_IN_HERE = 'ITS_QUIET_IN_HERE';
export const NO_DISCLOSURES_MESSAGE = 'NO_DISCLOSURES_MESSAGE';
export const NO_PLANS_CONTACT_ADMIN = 'NO_PLANS_CONTACT_ADMIN';
export const PAGE_NO_LONGER_AVAILABLE = 'PAGE_NO_LONGER_AVAILABLE';
export const CONTACT_SYSTEM_ADMINISTRATOR = 'CONTACT_SYSTEM_ADMINISTRATOR';
export const BENEFITS_GUIDE_UNDERGOING_UPDATES =
  'BENEFITS_GUIDE_UNDERGOING_UPDATES';
export const CHECK_BACK_LATER_CONTACT_ADMIN = 'CHECK_BACK_LATER_CONTACT_ADMIN';
export const BENEFITS_GUIDE_NO_LONGER_AVAILABLE =
  'BENEFITS_GUIDE_NO_LONGER_AVAILABLE';
export const NO_ACCESS_CONTACT_BROKER = 'NO_ACCESS_CONTACT_BROKER';
export const BENEFIT_GUIDE_NO_LONGER_AVAILABLE =
  'BENEFIT_GUIDE_NO_LONGER_AVAILABLE';
export const VIEW = 'VIEW';
export const PREVIEW = 'PREVIEW';
export const HOW_DOES_A_DEDUCTIBLE_WORK = 'HOW_DOES_A_DEDUCTIBLE_WORK';
export const WHAT_COUNTS_TOWARDS_A_DEDUCTIBLE =
  'WHAT_COUNTS_TOWARDS_A_DEDUCTIBLE';
export const WHAT_IS_COINSURANCE = 'WHAT_IS_COINSURANCE';
export const WHAT_COUNTS_TOWARDS_AN_OUT_OF_POCKET_LIMIT =
  'WHAT_COUNTS_TOWARDS_AN_OUT_OF_POCKET_LIMIT';
export const WHAT_IS_IN_NETWORK_VS_OUT_OF_NETWORK =
  'WHAT_IS_IN_NETWORK_VS_OUT_OF_NETWORK';
export const WHAT_HAPPENS_IF_I_GO_OUT_OF_NETWORK =
  'WHAT_HAPPENS_IF_I_GO_OUT_OF_NETWORK';
export const CHANGING_MEDICAL_CARRIERS = 'CHANGING_MEDICAL_CARRIERS';
export const PRIOR_AUTHORIZATION_FOR_PRESCRIPTIONS =
  'PRIOR_AUTHORIZATION_FOR_PRESCRIPTIONS';
export const IMPORTANT_DATES = 'IMPORTANT_DATES';
export const PLAN_EFFECTIVE_DATES = 'PLAN_EFFECTIVE_DATES';
export const PLAN_EFFECTIVE_DATE = 'PLAN_EFFECTIVE_DATE';
export const EFFECTIVE_FROM = 'EFFECTIVE_FROM';
export const NO_END_DATE = 'NO_END_DATE';
export const OPEN_ENROLLMENT_DATE = 'OPEN_ENROLLMENT_DATE';
export const ELIGIBILITY = 'ELIGIBILITY';
export const RULES = 'RULES';
export const QUALIFYING_LIFE_EVENTS = 'QUALIFYING_LIFE_EVENTS';
export const WAIVER_CREDIT = 'WAIVER_CREDIT';
export const ADD_CONTENT = 'ADD_CONTENT';
export const IN_NETWORK = 'IN_NETWORK';
export const OUT_OF_NETWORK = 'OUT_OF_NETWORK';
export const ADD_BENEFITS_CONSULT = 'ADD_BENEFITS_CONSULT';
export const EMPLOYER_CONSULTATION_CANNOT_BE_ENABLED_BECAUSE_THERE_ARE_TEXT =
  'EMPLOYER_CONSULTATION_CANNOT_BE_ENABLED_BECAUSE_THERE_ARE_TEXT';
export const ENABLE_DISABLE_BENEFITS_CONSULTATION =
  'ENABLE_DISABLE_BENEFITS_CONSULTATION';
export const DISPLAY_BROKER_BENEFITS_CONSULTATION =
  'DISPLAY_BROKER_BENEFITS_CONSULTATION';
export const DISPLAY_EMPLOYER_BENEFITS_CONSULTATION =
  'DISPLAY_EMPLOYER_BENEFITS_CONSULTATION';
export const SETUP_BROKER_CONSULTANTS = 'SETUP_BROKER_CONSULTANTS';
export const SETUP_EMPLOYER_CONSULTANTS = 'SETUP_EMPLOYER_CONSULTANTS';
export const WHO_IS_COVERED = 'WHO_IS_COVERED';
export const JUST_YOU = 'JUST_YOU';
export const YOU_SPOUSE = 'YOU_SPOUSE';
export const YOU_CHILD_REN = 'YOU_CHILD_REN';
export const YOU_FAMILY = 'YOU_FAMILY';
export const FILTER_OPTIONS = 'FILTER_OPTIONS';
export const PLAN_PROVIDERS = 'PLAN_PROVIDERS';
export const PLAN_TYPE = 'PLAN_TYPE';
export const PLAN_NAME = 'PLAN_NAME';
export const YOUR_MONTHLY_COST = 'YOUR_MONTHLY_COST';
export const PLAN_NETWORK = 'PLAN_NETWORK';
export const DENTAL_ANNUAL_MAXIMUM = 'DENTAL_ANNUAL_MAXIMUM';
export const DEDUCTIBLES_AND_OOP_MAXIMUM = 'DEDUCTIBLES_AND_OOP_MAXIMUM';
export const INDIVIDUAL_DEDUCTIBLE = 'INDIVIDUAL_DEDUCTIBLE';
export const FAMILY_DEDUCTIBLE = 'FAMILY_DEDUCTIBLE';
export const DEDUCTIBLE_IND_WITHIN_FAM = 'DEDUCTIBLE_IND_WITHIN_FAM';
export const INDIVIDUAL_OUT_OF_POCKET_MAX = 'INDIVIDUAL_OUT_OF_POCKET_MAX';
export const FAMILY_OUT_OF_POCKET_MAX = 'FAMILY_OUT_OF_POCKET_MAX';
export const OUT_OF_POCKET_MAX_IND_WITHIN_FAM =
  'OUT_OF_POCKET_MAX_IND_WITHIN_FAM';
export const SERVICES = 'SERVICES';
export const RX = 'RX';
export const OFFICE_VISIT = 'OFFICE_VISIT';
export const SPECIALIST_VISIT = 'SPECIALIST_VISIT';
export const PREVENTIVE_CARE = 'PREVENTIVE_CARE';
export const EMERGENCY_ROOM = 'EMERGENCY_ROOM';
export const URGENT_CARE = 'URGENT_CARE';
export const VIRTUAL_CARE = 'VIRTUAL_CARE';
export const DIAGNOSTIC_LAB_X_RAY = 'DIAGNOSTIC_LAB_X_RAY';
export const COMPLEX_IMAGING = 'COMPLEX_IMAGING';
export const HOSPITAL_INPATIENT = 'HOSPITAL_INPATIENT';
export const HOSPITAL_OUTPATIENT = 'HOSPITAL_OUTPATIENT';
export const CHIROPRACTIC_CARE = 'CHIROPRACTIC_CARE';
export const ACUPUNCTURE_CARE = 'ACUPUNCTURE_CARE';
export const MENTAL_HEALTH_INPATIENT = 'MENTAL_HEALTH_INPATIENT';
export const INFERTILITY_TREATMENT = 'INFERTILITY_TREATMENT';
export const MENTAL_HEALTH_OUTPATIENT = 'MENTAL_HEALTH_OUTPATIENT';
export const RETAIL_TIER_1 = 'RETAIL_TIER_1';
export const RETAIL_TIER_2 = 'RETAIL_TIER_2';
export const RETAIL_TIER_3 = 'RETAIL_TIER_3';
export const RETAIL_TIER_4 = 'RETAIL_TIER_4';
export const MAIL_ORDER_TIER_1 = 'MAIL_ORDER_TIER_1';
export const MAIL_ORDER_TIER_2 = 'MAIL_ORDER_TIER_2';
export const MAIL_ORDER_TIER_3 = 'MAIL_ORDER_TIER_3';
export const MAIL_ORDER_TIER_4 = 'MAIL_ORDER_TIER_4';
export const LEGAL_DISCLAIMER_TEXT = 'LEGAL_DISCLAIMER_TEXT';
export const NOT_COVERED = 'NOT_COVERED';
export const PER_SCRIPT = 'PER_SCRIPT';
export const COVERS_YOU = 'COVERS_YOU';
export const PROVIDER_SEARCH = 'PROVIDER_SEARCH';
export const VISITS_MAX = 'VISITS_MAX';
export const PER_PROCEDURE = 'PER_PROCEDURE';
export const LIFETIME_MAX = 'LIFETIME_MAX';
export const COVERED_UP_TO_COMBINED_ANNUAL_MAX =
  'COVERED_UP_TO_COMBINED_ANNUAL_MAX';
export const TELEHEALTH_SERVICES = 'TELEHEALTH_SERVICES';
export const RX_DELIVERY = 'RX_DELIVERY';
export const RX_COUPONS = 'RX_COUPONS';
export const PLAN_RESOURCES = 'PLAN_RESOURCES';
export const ORTHODONTIA_MAXIMUM = 'ORTHODONTIA_MAXIMUM';
export const BASIC_CARE = 'BASIC_CARE';
export const MAJOR_CARE = 'MAJOR_CARE';
export const ENDODONTIC_CARE = 'ENDODONTIC_CARE';
export const PERIODONTIC_CARE = 'PERIODONTIC_CARE';
export const IMPLANTS = 'IMPLANTS';
export const WAITING_PERIOD = 'WAITING_PERIOD';
export const OUT_OF_NETWORK_REIMBURSEMENT = 'OUT_OF_NETWORK_REIMBURSEMENT';
export const EXAM_COPAY = 'EXAM_COPAY';
export const MATERIALS_COPAY = 'MATERIALS_COPAY';
export const EYEGLASS_LENSES_SINGLE = 'EYEGLASS_LENSES_SINGLE';
export const EYEGLASS_LENSES_BIFOCAL = 'EYEGLASS_LENSES_BIFOCAL';
export const EYEGLASS_LENSES_TRIFOCAL = 'EYEGLASS_LENSES_TRIFOCAL';
export const EYEGLASS_LENSES_LENTICULAR = 'EYEGLASS_LENSES_LENTICULAR';
export const FRAMES = 'FRAMES';
export const ELECTIVE_CONTACTS = 'ELECTIVE_CONTACTS';
export const MEDICALLY_NECESSARY_CONTACTS = 'MEDICALLY_NECESSARY_CONTACTS';
export const LASIK = 'LASIK';
export const ALLOWANCE_PER_YEAR = 'ALLOWANCE_PER_YEAR';
export const PER_YEAR = 'PER_YEAR';
export const BENEFIT = 'BENEFIT';
export const BENEFIT_MAXIMUM = 'BENEFIT_MAXIMUM';
export const GUARANTEED_ISSUE = 'GUARANTEED_ISSUE';
export const AGE_REDUCTION_SCHEDULE = 'AGE_REDUCTION_SCHEDULE';
export const ACCELERATED_BENEFIT = 'ACCELERATED_BENEFIT';
export const PORTABILITY = 'PORTABILITY';
export const WAIVER_OF_PREMIUM = 'WAIVER_OF_PREMIUM';
export const VOLUME = 'VOLUME';
export const LIFE_RATE_PER_1000 = 'LIFE_RATE_PER_1000';
export const ADD_RATE_PER_1000 = 'ADD_RATE_PER_1000';
export const PLAN_SUMMARY = 'PLAN_SUMMARY';
export const PORTABILITY_CONVERSION_FORM = 'PORTABILITY_CONVERSION_FORM';
export const COC_FILE = 'COC_FILE';
export const PORTABILITY_VS_CONVERSION = 'PORTABILITY_VS_CONVERSION';
export const VISION = 'VISION';
export const FREQUENCIES = 'FREQUENCIES';
export const EYE_EXAM = 'EYE_EXAM';
export const LENSES = 'LENSES';

export const EMPLOYEE = 'EMPLOYEE';
export const SPOUSE = 'SPOUSE';
export const CHILD = 'CHILD';
export const PLAN_NAME_1 = 'PLAN_NAME_1';
export const EFFECTIVE_DATES = 'EFFECTIVE_DATES';
export const BENEFIT_CLASSES = 'BENEFIT_CLASSES';
export const CARRIER = 'CARRIER';
export const GROUP_ID_POLICY = 'GROUP_ID_POLICY';
export const PRE_EXISTING_CONDITIONS = 'PRE_EXISTING_CONDITIONS';
export const PLAN_INFORMATION = 'PLAN_INFORMATION';
export const PLAN_DESCRIPTION = 'PLAN_DESCRIPTION';
export const CHARACTER_LIMIT = 'CHARACTER_LIMIT';
export const GUARANTEE_ISSUE = 'GUARANTEE_ISSUE';
export const HOSPITAL_ADMISSION = 'HOSPITAL_ADMISSION';
export const HOSPITAL_CONFINEMENT_PER_DAY = 'HOSPITAL_CONFINEMENT_PER_DAY';
export const ICU_ADMISSION = 'ICU_ADMISSION';
export const ICU_CONFINEMENT_PER_DAY = 'ICU_CONFINEMENT_PER_DAY';
export const TOTAL_COST = 'TOTAL_COST';
export const EMPLOYER_CONTRIBUTION_FREQUENCY =
  'EMPLOYER_CONTRIBUTION_FREQUENCY';
export const EMPLOYER_CONTRIBUTION = 'EMPLOYER_CONTRIBUTION';
export const MAX_YEARLY_CONTRIBUTION_MARRIED_FILING_SEPARATELY =
  'MAX_YEARLY_CONTRIBUTION_MARRIED_FILING_SEPARATELY';
export const MAX_YEARLY_CONTRIBUTION_MARRIED_FILING_JOINTLY_OR_SINGLE_TEXT =
  'MAX_YEARLY_CONTRIBUTION_MARRIED_FILING_JOINTLY_OR_SINGLE_TEXT';
export const END_OF_YEAR_POLICY = 'END_OF_YEAR_POLICY';
export const PLAN_DOCUMENT = 'PLAN_DOCUMENT';
export const THINGS_TO_CONSIDER = 'THINGS_TO_CONSIDER';
export const EMPLOYEE_EE_CONTRIBUTION = 'EMPLOYEE_EE_CONTRIBUTION';
export const EMPLOYEE_ES_CONTRIBUTION = 'EMPLOYEE_ES_CONTRIBUTION';
export const EMPLOYEE_EC_CONTRIBUTION = 'EMPLOYEE_EC_CONTRIBUTION';
export const EMPLOYEE_EF_CONTRIBUTION = 'EMPLOYEE_EF_CONTRIBUTION';
export const OTHER = 'OTHER';
export const FOUR_O_ONE_K_MATCH_POLICY = 'FOUR_O_ONE_K_MATCH_POLICY';
export const ANNUAL_MAX_CONTRIBUTION = 'ANNUAL_MAX_CONTRIBUTION';
export const ANNUAL_CATCHUP_CONTRIBUTION_50_OR_OLDER =
  'ANNUAL_CATCHUP_CONTRIBUTION_50_OR_OLDER';
export const ANNUAL_MAX_CATCHUP_CONTRIBUTION =
  'ANNUAL_MAX_CATCHUP_CONTRIBUTION';
export const CATCHUP_CONTRIBUTION_DISCLAIMER =
  'CATCHUP_CONTRIBUTION_DISCLAIMER';
export const FOUR_O_ONE_K_ROLLOVER_FORM = 'FOUR_O_ONE_K_ROLLOVER_FORM';
export const CONTRIBUTIONS = 'CONTRIBUTIONS';
export const ADVANTAGES = 'ADVANTAGES';
export const OVERVIEW = 'OVERVIEW';
export const EXPENSES = 'EXPENSES';
export const CONSIDERATIONS = 'CONSIDERATIONS';
export const CONTACT_SUPPORT_BUTTON = 'CONTACT_SUPPORT_BUTTON';
export const ADD_SUPPORT_BUTTON = 'ADD_SUPPORT_BUTTON';
export const NEED_BENEFITS_ASSISTANCE = 'NEED_BENEFITS_ASSISTANCE';
export const SCHEDULE_BENEFITS_CONSULTATION = 'SCHEDULE_BENEFITS_CONSULTATION';
export const CONSULTATION = 'CONSULTATION';
export const SCHEDULE_A_CONSULTATION = 'SCHEDULE_A_CONSULTATION';
export const ONE_ON_ONE_CONSULTATION = 'ONE_ON_ONE_CONSULTATION';
export const CONSULTATION_WITH_BROKER_REPRESENTATIVE =
  'CONSULTATION_WITH_BROKER_REPRESENTATIVE';
export const CONSULTATION_WITH_YOUR_EMPLOYER =
  'CONSULTATION_WITH_YOUR_EMPLOYER';
export const BROKER_CONSULTATION_DESCRIPTION =
  'BROKER_CONSULTATION_DESCRIPTION';
export const EMPLOYER_CONSULTATION_DESCRIPTION =
  'EMPLOYER_CONSULTATION_DESCRIPTION';
export const BOOK_CONSULTATION = 'BOOK_CONSULTATION';
export const MOVE = 'MOVE';
export const BENEFIT_TOOLTIP = 'BENEFIT_TOOLTIP';
export const MAX_BENEFIT_TOOLTIP = 'MAX_BENEFIT_TOOLTIP';
export const GUARANTEED_ISSUE_TOOLTIP = 'GUARANTEED_ISSUE_TOOLTIP';
export const MAX_WEEKLY_BENEFIT_TOOLTIP = 'MAX_WEEKLY_BENEFIT_TOOLTIP';
export const MAX_MONTHLY_BENEFIT_TOOLTIP = 'MAX_MONTHLY_BENEFIT_TOOLTIP';
export const WAITING_PERIOD_TOOLTIP = 'WAITING_PERIOD_TOOLTIP';
export const MAX_BENEFIT_DURATION_TOOLTIP = 'MAX_BENEFIT_DURATION_TOOLTIP';
export const VOL_BENEFIT_TOOLTIP = 'VOL_BENEFIT_TOOLTIP';
export const VOL_GUARANTEED_ISSUE_TOOLTIP = 'VOL_GUARANTEED_ISSUE_TOOLTIP';
export const SEARCH_INSTRUCTIONS = 'SEARCH_INSTRUCTIONS';
export const NETWORK_NAME_FOR_PLAN = 'NETWORK_NAME_FOR_PLAN';
export const SEARCH_PROVIDERS_ON_WEBSITE = 'SEARCH_PROVIDERS_ON_WEBSITE';
export const ADDITIONAL_INFORMATION = 'ADDITIONAL_INFORMATION';
export const SEARCH_ON_CARRIER_SITE = 'SEARCH_ON_CARRIER_SITE';
export const BACK_TO_EDITING = 'BACK_TO_EDITING';
export const CLOSE = 'CLOSE';

// Auth Error Message Constants
export const AUTH_ERROR_INVALID_DOMAIN = 'AUTH_ERROR_INVALID_DOMAIN';
export const AUTH_ERROR_PLAN_NOT_FOUND = 'AUTH_ERROR_PLAN_NOT_FOUND';
export const AUTH_ERROR_TOKEN_NOT_FOUND = 'AUTH_ERROR_TOKEN_NOT_FOUND';
export const AUTH_ERROR_TOKEN_EXPIRED = 'AUTH_ERROR_TOKEN_EXPIRED';
export const AUTH_ERROR_TOKEN_EXPIRED_RESET = 'AUTH_ERROR_TOKEN_EXPIRED_RESET';
export const AUTH_ERROR_INVALID_EMAIL = 'AUTH_ERROR_INVALID_EMAIL';
export const AUTH_ERROR_LOGIN_EXISTS = 'AUTH_ERROR_LOGIN_EXISTS';
export const AUTH_ERROR_TOKEN_CLAIMED = 'AUTH_ERROR_TOKEN_CLAIMED';
export const AUTH_ERROR_INVALID_CREDENTIALS = 'AUTH_ERROR_INVALID_CREDENTIALS';
export const AUTH_ERROR_LOGIN_COMPROMISED = 'AUTH_ERROR_LOGIN_COMPROMISED';
export const AUTH_ERROR_PERMISSION_DENIED = 'AUTH_ERROR_PERMISSION_DENIED';
export const AUTH_ERROR_INTERNAL_ERROR = 'AUTH_ERROR_INTERNAL_ERROR';
export const AUTH_ERROR_EMPLOYEE_SIGN_ERROR = 'AUTH_ERROR_EMPLOYEE_SIGN_ERROR';
export const AUTH_ERROR_PWDRESET_INFO = 'AUTH_ERROR_PWDRESET_INFO';
export const AUTH_ERROR_INVALID_LOGIN_TYPE = 'AUTH_ERROR_INVALID_LOGIN_TYPE';
export const AUTH_ERROR_UNKNOWN_ERROR = 'AUTH_ERROR_UNKNOWN_ERROR';
export const AUTH_ERROR_SSO_EXISTS = 'AUTH_ERROR_SSO_EXISTS';
export const AUTH_ERROR_EMPLOYEE_NOT_FOUND = 'AUTH_ERROR_EMPLOYEE_NOT_FOUND';
export const AUTH_ERROR_PLAN_NOT_MATCHED = 'AUTH_ERROR_PLAN_NOT_MATCHED';
export const AUTH_ERROR_INACTIVE_USER = 'AUTH_ERROR_INACTIVE_USER';

export const ADDITIONAL_RESOURCES = 'ADDITIONAL_RESOURCES';
export const ADD_ADDITIONAL_RESOURCES = 'ADD_ADDITIONAL_RESOURCES';
export const VIEW_MORE = 'VIEW_MORE';
export const FIRST_TELL_US_WHERE_YOU_RE_LOCATED =
  'FIRST_TELL_US_WHERE_YOU_RE_LOCATED';
export const HOW_MANY_PEOPLE_DO_YOU_WANT_TO_COVER =
  'HOW_MANY_PEOPLE_DO_YOU_WANT_TO_COVER';
export const JUST_YOU_1 = 'JUST_YOU_1';
export const YOU_SPOUSE_PARTNER = 'YOU_SPOUSE_PARTNER';
export const YOU_CHILD_REN_1 = 'YOU_CHILD_REN_1';
export const YOU_FAMILY_1 = 'YOU_FAMILY_1';
export const PARTNER_COVERAGE_IS_DEPENDENT_ON_THE_EMPLOYER =
  'PARTNER_COVERAGE_IS_DEPENDENT_ON_THE_EMPLOYER';
export const ARE_YOU_PLANNING_ON_ANY_OF_THE_FOLLOWING_TEXT =
  'ARE_YOU_PLANNING_ON_ANY_OF_THE_FOLLOWING_TEXT';
export const YOU_CAN_CHOOSE_MORE_THAN_ONE = 'YOU_CAN_CHOOSE_MORE_THAN_ONE';
export const HAVING_A_BABY = 'HAVING_A_BABY';
export const MAJOR_SURGERY_INPATIENT = 'MAJOR_SURGERY_INPATIENT';
export const MINOR_SURGERY_OUTPATIENT = 'MINOR_SURGERY_OUTPATIENT';
export const NONE = 'NONE';
export const HOW_OFTEN_DO_YOU_GO_TO_YOUR_DOCTOR_TEXT =
  'HOW_OFTEN_DO_YOU_GO_TO_YOUR_DOCTOR_TEXT';
export const IF_YOU_ARE_COVERING_YOUR_SPOUSE_OR_CHILD_REN_TEXT =
  'IF_YOU_ARE_COVERING_YOUR_SPOUSE_OR_CHILD_REN_TEXT';
export const PRIMARY_DOCTOR_VISITS_PER_YEAR = 'PRIMARY_DOCTOR_VISITS_PER_YEAR';
export const FREQUENTLY = 'FREQUENTLY';
export const SPECIALIST_VISITS_PER_YEAR = 'SPECIALIST_VISITS_PER_YEAR';
export const WHAT_S_YOUR_PREFERENCE_WHEN_CHOOSING_A_DOCTOR =
  'WHAT_S_YOUR_PREFERENCE_WHEN_CHOOSING_A_DOCTOR';
export const I_USE_IN_NETWORK_PROVIDERS_ONLY =
  'I_USE_IN_NETWORK_PROVIDERS_ONLY';
export const I_USE_OUT_OF_NETWORK_PROVIDERS_ALSO =
  'I_USE_OUT_OF_NETWORK_PROVIDERS_ALSO';
export const IF_YOU_ARE_TAKING_ANY_RECURRING_PRESCRIPTIONS_WHAT_TEXT =
  'IF_YOU_ARE_TAKING_ANY_RECURRING_PRESCRIPTIONS_WHAT_TEXT';
export const ENTER_THE_NUMBER_OF_PRESCRIPTIONS_YOU_TAKE_ANNUALLY_TEXT =
  'ENTER_THE_NUMBER_OF_PRESCRIPTIONS_YOU_TAKE_ANNUALLY_TEXT';
export const LOW_COST = 'LOW_COST';
export const MEDIUM_COST = 'MEDIUM_COST';
export const HIGH_COST = 'HIGH_COST';
export const SPECIALITY_COST = 'SPECIALITY_COST';
export const PER_YEAR_1 = 'PER_YEAR_1';
export const SKIP_I_M_NOT_TAKING_ANY_PRESCRIPTIONS =
  'SKIP_I_M_NOT_TAKING_ANY_PRESCRIPTIONS';
export const VIEW_MY_RECOMMENDATIONS = 'VIEW_MY_RECOMMENDATIONS';
export const MONTHLY_PREMIUM = 'MONTHLY_PREMIUM';
export const PLAN_NETWORK_1 = 'PLAN_NETWORK_1';
export const DEDUCTIBLE = 'DEDUCTIBLE';
export const OUT_OF_POCKET_MAX = 'OUT_OF_POCKET_MAX';
export const OFFICE_VISIT_1 = 'OFFICE_VISIT_1';
export const SPECIALIST_VISIT_1 = 'SPECIALIST_VISIT_1';
export const RETAIL_TIER_1_1 = 'RETAIL_TIER_1_1';
export const RETAIL_TIER_2_1 = 'RETAIL_TIER_2_1';
export const RETAIL_TIER_3_1 = 'RETAIL_TIER_3_1';
export const RETAIL_TIER_4_1 = 'RETAIL_TIER_4_1';
export const RETAIL_TIER_5 = 'RETAIL_TIER_5';
export const HSA_CONTRIBUTION = 'HSA_CONTRIBUTION';
export const HRA_ALLOWANCE = 'HRA_ALLOWANCE';
export const EST_ANNUAL_COST = 'EST_ANNUAL_COST';
export const EST_ANNUAL_COST_BREAKDOWN = 'EST_ANNUAL_COST_BREAKDOWN';
export const ANNUAL_PREMIUM_COST = 'ANNUAL_PREMIUM_COST';
export const ESTIMATED_MEDICAL_COST = 'ESTIMATED_MEDICAL_COST';
export const ESTIMATED_ANNUAL_COST = 'ESTIMATED_ANNUAL_COST';
export const WE_RECOMMEND_THE_PLAN_NAME_FOR_YOU =
  'WE_RECOMMEND_THE_PLAN_NAME_FOR_YOU';
export const THIS_IS_BASED_ON_COVERING_BENEFITS_FOR_YOU_TEXT =
  'THIS_IS_BASED_ON_COVERING_BENEFITS_FOR_YOU_TEXT';
export const WHICH_MEDICAL_PLAN_DO_YOU_HAVE = 'WHICH_MEDICAL_PLAN_DO_YOU_HAVE';
export const MEDICAL = 'MEDICAL';
export const WAIVED = 'WAIVED';
export const MEMBER_ID = 'MEMBER_ID';
export const WHICH_DENTAL_PLAN_DO_YOU_HAVE = 'WHICH_DENTAL_PLAN_DO_YOU_HAVE';
export const DENTAL = 'DENTAL';
export const THE_MEMBER_ID_CAN_BE_FOUND_AFTER_TEXT =
  'THE_MEMBER_ID_CAN_BE_FOUND_AFTER_TEXT';
export const YOUR_EMPLOYER_DOESN_T_OFFER_PLANS_FOR_THIS_BENEFIT_TEXT =
  'YOUR_EMPLOYER_DOESN_T_OFFER_PLANS_FOR_THIS_BENEFIT_TEXT';
export const WHICH_VISION_PLAN_DO_YOU_HAVE = 'WHICH_VISION_PLAN_DO_YOU_HAVE';

export const YOUR_MEDICAL_ID_CARD = 'YOUR_MEDICAL_ID_CARD';
export const VIEWING = 'VIEWING';
export const PLAN_MEMBERS = 'PLAN_MEMBERS';
export const EFFECTIVE_DATE = 'EFFECTIVE_DATE';
export const NAME = 'NAME';
export const PRIMARY_SUBSCRIBER = 'PRIMARY_SUBSCRIBER';
export const GROUP_ID = 'GROUP_ID';
export const PHONE = 'PHONE';
export const ACTIONS = 'ACTIONS';
export const PRINT_ID = 'PRINT_ID';
export const SHOW_BACK_OF_ID_CARD = 'SHOW_BACK_OF_ID_CARD';
export const UPDATE_MY_PLANS = 'UPDATE_MY_PLANS';
export const LOG_OUT = 'LOG_OUT';
export const DENTAL_BENEFITS_ARE_NOT_BEEN_OFFERED_CURRENTLY =
  'DENTAL_BENEFITS_ARE_NOT_BEEN_OFFERED_CURRENTLY';
export const MEMBERS_AND_PROVIDERS = 'MEMBERS_AND_PROVIDERS';
export const NETWORK_PROVIDERS_MUST_CALL_TO_REQUEST_PRIOR_APPROVAL_TEXT =
  'NETWORK_PROVIDERS_MUST_CALL_TO_REQUEST_PRIOR_APPROVAL_TEXT';
export const CARRIER_PHONE = 'CARRIER_PHONE';
export const VISION_BENEFITS_ARE_NOT_BEEN_OFFERED_CURRENTLY =
  'VISION_BENEFITS_ARE_NOT_BEEN_OFFERED_CURRENTLY';
export const YOUR_WAIVER_CREDIT = 'YOUR_WAIVER_CREDIT';
export const PER_PAY_PERIOD = 'PER_PAY_PERIOD';
export const PER_MONTH = 'PER_MONTH';
export const PER_QUARTER = 'PER_QUARTER';
export const PER_YEAR_2 = 'PER_YEAR_2';
export const COMPARE_NOW = 'COMPARE_NOW';
export const CLEAR_COMPARISON = 'CLEAR_COMPARISON';
export const RETAIL_TIER_6 = 'RETAIL_TIER_6';
export const RETAIL_TIER_7 = 'RETAIL_TIER_7';
export const RETAIL_TIER_8 = 'RETAIL_TIER_8';
export const MAIL_ORDER_TIER_5 = 'MAIL_ORDER_TIER_5';
export const MAIL_ORDER_TIER_6 = 'MAIL_ORDER_TIER_6';
export const MAIL_ORDER_TIER_7 = 'MAIL_ORDER_TIER_7';
export const MAIL_ORDER_TIER_8 = 'MAIL_ORDER_TIER_8';
export const DEDUCTIBLES_OOP_MAXIMUM = 'DEDUCTIBLES_OOP_MAXIMUM';
export const DEDUCTIBLES_BENEFIT_MAXIMUMS = 'DEDUCTIBLES_BENEFIT_MAXIMUMS';
export const MAX_YEARLY_CONTRIBUTION_INDIVIDUAL =
  'MAX_YEARLY_CONTRIBUTION_INDIVIDUAL';
export const MAX_YEARLY_CONTRIBUTION_FAMILY = 'MAX_YEARLY_CONTRIBUTION_FAMILY';
export const EMPLOYER_CONTRIBUTIONS_PER_MONTH =
  'EMPLOYER_CONTRIBUTIONS_PER_MONTH';
export const MAX_MONTHLY_CONTRIBUTION = 'MAX_MONTHLY_CONTRIBUTION';
export const YOU_1 = 'YOU_1';
export const YOU_2 = 'YOU_2';
export const YOU_3 = 'YOU_3';
export const YOU_4 = 'YOU_4';
export const YOU_5 = 'YOU_5';
export const YOU_6 = 'YOU_6';
export const YOU_7 = 'YOU_7';
export const YOU_8 = 'YOU_8';

// Login form constants
export const EMAIL_ADDRESS = 'EMAIL_ADDRESS';
export const PASSWORD = 'PASSWORD';
export const PLEASE_ENTER_YOUR_EMAIL = 'PLEASE_ENTER_YOUR_EMAIL';
export const PLEASE_ENTER_YOUR_PASSWORD = 'PLEASE_ENTER_YOUR_PASSWORD';
export const LOG_IN = 'LOG_IN';
export const CONTINUE = 'CONTINUE';

// AUTH_VIEW constants
export const AUTH_LOG_IN = 'AUTH_LOG_IN';
export const AUTH_RESET_PASSWORD = 'AUTH_RESET_PASSWORD';
export const AUTH_REGISTER = 'AUTH_REGISTER';
export const AUTH_CHECK_YOUR_EMAIL = 'AUTH_CHECK_YOUR_EMAIL';
export const AUTH_TROUBLE_LOGGING_IN = 'AUTH_TROUBLE_LOGGING_IN';
export const AUTH_REGISTRATION_SUCCESS = 'AUTH_REGISTRATION_SUCCESS';
export const AUTH_TERMS_AND_CONDITIONS = 'AUTH_TERMS_AND_CONDITIONS';

// PLAN_VIEW constants
export const PLAN_YOUR_BENEFITS_AT_A_GLANCE = 'PLAN_YOUR_BENEFITS_AT_A_GLANCE';
export const PLAN_YOUR_BENEFITS_ARE_ON_THE_WAY =
  'PLAN_YOUR_BENEFITS_ARE_ON_THE_WAY';
export const PLAN_NEXT_YOULL_ENTER_AND_STORE =
  'PLAN_NEXT_YOULL_ENTER_AND_STORE';
export const PLAN_YOUR_BENEFITS_TEAM_IS_WORKING =
  'PLAN_YOUR_BENEFITS_TEAM_IS_WORKING';
export const PLAN_WHICH_MEDICAL_PLAN_DO_YOU_HAVE =
  'PLAN_WHICH_MEDICAL_PLAN_DO_YOU_HAVE';
export const PLAN_MEDICAL = 'PLAN_MEDICAL';
export const PLAN_YOUR_MEDICAL_ID_CARD = 'PLAN_YOUR_MEDICAL_ID_CARD';
export const PLAN_WHICH_DENTAL_PLAN_DO_YOU_HAVE =
  'PLAN_WHICH_DENTAL_PLAN_DO_YOU_HAVE';
export const PLAN_DENTAL = 'PLAN_DENTAL';
export const PLAN_YOUR_DENTAL_ID_CARD = 'PLAN_YOUR_DENTAL_ID_CARD';
export const PLAN_WHICH_VISION_PLAN_DO_YOU_HAVE =
  'PLAN_WHICH_VISION_PLAN_DO_YOU_HAVE';
export const PLAN_VISION = 'PLAN_VISION';
export const PLAN_YOUR_VISION_ID_CARD = 'PLAN_YOUR_VISION_ID_CARD';
export const PLAN_ID_CARD = 'PLAN_ID_CARD';

// Register component constants
export const IMPORTANT_REGISTER_WITH_PRIMARY_EMAIL =
  'IMPORTANT_REGISTER_WITH_PRIMARY_EMAIL';
export const WORK_EMAIL_ADDRESS = 'WORK_EMAIL_ADDRESS';
export const REGISTERING_AS_EMPLOYER_ADMIN = 'REGISTERING_AS_EMPLOYER_ADMIN';
export const INVALID_EMAIL_FORMAT = 'INVALID_EMAIL_FORMAT';
export const PLEASE_ENTER_YOUR_WORK_EMAIL = 'PLEASE_ENTER_YOUR_WORK_EMAIL';
export const EMPLOYERS_WEBSITE = 'EMPLOYERS_WEBSITE';
export const PLEASE_ENTER_EMPLOYERS_DOMAIN = 'PLEASE_ENTER_EMPLOYERS_DOMAIN';
export const PLEASE_INCLUDE_VALID_WEBSITE_EXTENSION =
  'PLEASE_INCLUDE_VALID_WEBSITE_EXTENSION';
export const HTTPS_WWW = 'HTTPS_WWW';
export const PASTE_CODE_FROM_PLANYEAR_EMAIL = 'PASTE_CODE_FROM_PLANYEAR_EMAIL';
export const CODE = 'CODE';
export const PLEASE_ENTER_VERIFICATION_CODE = 'PLEASE_ENTER_VERIFICATION_CODE';
export const FIRST_NAME = 'FIRST_NAME';
export const LAST_NAME = 'LAST_NAME';
export const PLEASE_ENTER_CONFIRMATION_PASSWORD =
  'PLEASE_ENTER_CONFIRMATION_PASSWORD';
export const PASSWORDS_DO_NOT_MATCH = 'PASSWORDS_DO_NOT_MATCH';
export const REGISTER_ACCOUNT = 'REGISTER_ACCOUNT';
export const NEXT = 'NEXT';
export const BACK = 'BACK';
export const CANCEL = 'CANCEL';
export const CREATE_PASSWORD = 'CREATE_PASSWORD';
export const CONFIRM_PASSWORD = 'CONFIRM_PASSWORD';
export const PASSWORD_REQUIREMENTS_MESSAGE = 'PASSWORD_REQUIREMENTS_MESSAGE';

// Auth components constants
export const NEW_PASSWORD = 'NEW_PASSWORD';
export const PLEASE_ENTER_YOUR_NEW_PASSWORD = 'PLEASE_ENTER_YOUR_NEW_PASSWORD';
export const SAVE = 'SAVE';
export const YOUR_ACCOUNT_EMAIL_ADDRESS = 'YOUR_ACCOUNT_EMAIL_ADDRESS';
export const REQUEST_NEW_PASSWORD = 'REQUEST_NEW_PASSWORD';
export const PRIMARY_SUBSCRIBERS_MESSAGE = 'PRIMARY_SUBSCRIBERS_MESSAGE';
export const FOR_ADDITIONAL_QUESTIONS = 'FOR_ADDITIONAL_QUESTIONS';
export const SUPPORT_EMAIL = 'SUPPORT_EMAIL';
export const UNIFIED_PORTAL_CREDENTIALS_MESSAGE =
  'UNIFIED_PORTAL_CREDENTIALS_MESSAGE';
export const CHECK_EMAIL_INBOX_MESSAGE = 'CHECK_EMAIL_INBOX_MESSAGE';
export const PLEASE_ENTER_YOUR_FIRST_NAME = 'PLEASE_ENTER_YOUR_FIRST_NAME';
export const PLEASE_ENTER_YOUR_LAST_NAME = 'PLEASE_ENTER_YOUR_LAST_NAME';
export const GET_STARTED = 'GET_STARTED';

// Medical plan field description constants
export const INDIVIDUAL_DEDUCTIBLE_DESCRIPTION =
  'INDIVIDUAL_DEDUCTIBLE_DESCRIPTION';
export const OFFICE_VISIT_DESCRIPTION = 'OFFICE_VISIT_DESCRIPTION';
export const SPECIALIST_VISIT_DESCRIPTION = 'SPECIALIST_VISIT_DESCRIPTION';
export const PREVENTIVE_CARE_DESCRIPTION = 'PREVENTIVE_CARE_DESCRIPTION';
export const EMERGENCY_ROOM_DESCRIPTION = 'EMERGENCY_ROOM_DESCRIPTION';
export const URGENT_CARE_DESCRIPTION = 'URGENT_CARE_DESCRIPTION';
export const DIAGNOSTIC_LAB_DESCRIPTION = 'DIAGNOSTIC_LAB_DESCRIPTION';
export const HOSPITAL_INPATIENT_DESCRIPTION = 'HOSPITAL_INPATIENT_DESCRIPTION';
export const HOSPITAL_OUTPATIENT_DESCRIPTION =
  'HOSPITAL_OUTPATIENT_DESCRIPTION';
export const CHIROPRACTIC_CARE_DESCRIPTION = 'CHIROPRACTIC_CARE_DESCRIPTION';
export const ACUPUNCTURE_CARE_DESCRIPTION = 'ACUPUNCTURE_CARE_DESCRIPTION';
export const RETAIL_TIER_1A_DESCRIPTION = 'RETAIL_TIER_1A_DESCRIPTION';
export const RETAIL_TIER_1B_DESCRIPTION = 'RETAIL_TIER_1B_DESCRIPTION';
export const MAIL_ORDER_PHARMACY_DESCRIPTION =
  'MAIL_ORDER_PHARMACY_DESCRIPTION';
export const SEE_SBC = 'SEE_SBC';

// Plan Type Info Drawer Constants
export const WHAT_IS_PPO = 'WHAT_IS_PPO';
export const WHAT_IS_POS = 'WHAT_IS_POS';
export const WHAT_IS_OAP = 'WHAT_IS_OAP';
export const WHAT_IS_EPO = 'WHAT_IS_EPO';
export const WHAT_IS_HMO = 'WHAT_IS_HMO';
export const WHAT_IS_HSA_ELIGIBLE_PLAN = 'WHAT_IS_HSA_ELIGIBLE_PLAN';
export const PPO_DESCRIPTION_1 = 'PPO_DESCRIPTION_1';
export const PPO_DESCRIPTION_2 = 'PPO_DESCRIPTION_2';
export const POS_DESCRIPTION = 'POS_DESCRIPTION';
export const OAP_DESCRIPTION = 'OAP_DESCRIPTION';
export const EPO_DESCRIPTION = 'EPO_DESCRIPTION';
export const HMO_DESCRIPTION_1 = 'HMO_DESCRIPTION_1';
export const HMO_DESCRIPTION_2 = 'HMO_DESCRIPTION_2';
export const HSA_DESCRIPTION_1 = 'HSA_DESCRIPTION_1';
export const HSA_DESCRIPTION_2 = 'HSA_DESCRIPTION_2';
export const LEARN_MORE_ABOUT_HSAS = 'LEARN_MORE_ABOUT_HSAS';
export const LEARN_MORE_ABOUT_PLAN_TYPE = 'LEARN_MORE_ABOUT_PLAN_TYPE';
export const HOW_OTHER_PLANS_COMPARE = 'HOW_OTHER_PLANS_COMPARE';
export const HEALTH_MAINTENANCE_ORGANIZATION =
  'HEALTH_MAINTENANCE_ORGANIZATION';
export const PREFERRED_PROVIDER_ORGANIZATION =
  'PREFERRED_PROVIDER_ORGANIZATION';
export const EXCLUSIVE_PROVIDER_ORGANIZATION =
  'EXCLUSIVE_PROVIDER_ORGANIZATION';
export const POINT_OF_SERVICE = 'POINT_OF_SERVICE';
export const SELF_REFERRAL = 'SELF_REFERRAL';
export const PRIMARY_DOC_REFERRAL = 'PRIMARY_DOC_REFERRAL';
export const NO_COINSURANCE = 'NO_COINSURANCE';
export const NO_DEDUCTIBLE = 'NO_DEDUCTIBLE';
export const OUT_OF_NETWORK_COVERAGE = 'OUT_OF_NETWORK_COVERAGE';
export const PLAN_COMPARISON_DESCRIPTION = 'PLAN_COMPARISON_DESCRIPTION';
export const OAP_FOOTNOTE_DESCRIPTION = 'OAP_FOOTNOTE_DESCRIPTION';

// Annual Cost Breakdown Constants
export const BASED_ON = 'BASED_ON';
export const PREMIUM = 'PREMIUM';
export const ANNUAL_EMPLOYER_CONTRIBUTION = 'ANNUAL_EMPLOYER_CONTRIBUTION';
export const ANNUAL_EMPLOYER_ALLOWANCE = 'ANNUAL_EMPLOYER_ALLOWANCE';
export const ANNUAL_PREMIUM = 'ANNUAL_PREMIUM';
export const OOP_MAX = 'OOP_MAX';
export const COPAYS = 'COPAYS';
export const COINSURANCE = 'COINSURANCE';
export const YOU_PAY = 'YOU_PAY';
export const OOP_MAX_EXCEEDED_MESSAGE = 'OOP_MAX_EXCEEDED_MESSAGE';
export const FOR_IN_NETWORK_SERVICES = 'FOR_IN_NETWORK_SERVICES';
export const FOR_INDIVIDUAL = 'FOR_INDIVIDUAL';
export const FOR_FAMILIES = 'FOR_FAMILIES';

// AI Assistant Constants
export const AI_ASSISTANT_INITIALIZE_TEXT = 'AI_ASSISTANT_INITIALIZE_TEXT';
export const AI_ASSISTANT_INITIALIZE_WARNING =
  'AI_ASSISTANT_INITIALIZE_WARNING';
export const AI_PLAN_HEADER_TEXT = 'AI_PLAN_HEADER_TEXT';
export const AI_SELECTION_PLAN_ASSISTANCE_TEXT =
  'AI_SELECTION_PLAN_ASSISTANCE_TEXT';
export const AI_GENERAL_HEADER_TEXT = 'AI_GENERAL_HEADER_TEXT';
export const AI_SELECTION_GENERAL_ASSISTANT_TEXT =
  'AI_SELECTION_GENERAL_ASSISTANT_TEXT';
export const AI_HELP_HEADER_TEXT = 'AI_HELP_HEADER_TEXT';
export const AI_PLAN_ASSISTANT_TEXT = 'AI_PLAN_ASSISTANT_TEXT';
export const AI_GENERAL_ASSISTANT_TEXT = 'AI_GENERAL_ASSISTANT_TEXT';
export const AI_PLAN_DOCUMENT_NOT_FOUND = 'AI_PLAN_DOCUMENT_NOT_FOUND';
export const AI_ASSISTANT_COMMON_ERROR = 'AI_ASSISTANT_COMMON_ERROR';
export const AI_PLAN_CHANGE_POPOVER_TEXT = 'AI_PLAN_CHANGE_POPOVER_TEXT';
export const AI_PLAN_ASSISTANCE_MODAL_TITLE = 'AI_PLAN_ASSISTANCE_MODAL_TITLE';
export const AI_PLAN_ASSISTANCE_MODAL_DESCRIPTION =
  'AI_PLAN_ASSISTANCE_MODAL_DESCRIPTION';
export const AI_CHOOSE_PLAN = 'AI_CHOOSE_PLAN';
export const AI_CONTINUE = 'AI_CONTINUE';
export const AI_COPY = 'AI_COPY';
export const AI_NEW_CHAT = 'AI_NEW_CHAT';
export const AI_PLAN_NAME = 'AI_PLAN_NAME';
export const AI_ASSISTANT = 'AI_ASSISTANT';
export const VIEW_ID_CARDS = 'VIEW_ID_CARDS';

// Additional fieldDescription constants from metadataNew.ts
export const OUT_OF_POCKET_MAX_FAMILY_DESCRIPTION =
  'OUT_OF_POCKET_MAX_FAMILY_DESCRIPTION';
export const IND_WITHIN_FAMILY_OOP_MAX_DESCRIPTION =
  'IND_WITHIN_FAMILY_OOP_MAX_DESCRIPTION';
export const SPECIALIST_VISIT_DESCRIPTION_NEW =
  'SPECIALIST_VISIT_DESCRIPTION_NEW';
export const VIRTUAL_CARE_VISIT_DESCRIPTION = 'VIRTUAL_CARE_VISIT_DESCRIPTION';
export const MAJOR_DENTAL_CARE_DESCRIPTION = 'MAJOR_DENTAL_CARE_DESCRIPTION';
export const ENDODONTIC_CARE_DESCRIPTION = 'ENDODONTIC_CARE_DESCRIPTION';
export const PERIODONTIC_CARE_DESCRIPTION = 'PERIODONTIC_CARE_DESCRIPTION';
export const WAITING_PERIOD_DESCRIPTION = 'WAITING_PERIOD_DESCRIPTION';
export const IMPLANTS_DESCRIPTION = 'IMPLANTS_DESCRIPTION';
export const OUT_OF_NETWORK_REIMBURSEMENT_DESCRIPTION =
  'OUT_OF_NETWORK_REIMBURSEMENT_DESCRIPTION';
export const EYE_EXAM_DESCRIPTION = 'EYE_EXAM_DESCRIPTION';
export const LENSES_DESCRIPTION = 'LENSES_DESCRIPTION';
export const FRAMES_DESCRIPTION = 'FRAMES_DESCRIPTION';
export const VISION_EXAM_DESCRIPTION = 'VISION_EXAM_DESCRIPTION';
export const MATERIALS_COPAY_DESCRIPTION = 'MATERIALS_COPAY_DESCRIPTION';
export const EYEGLASS_LENSES_SINGLE_DESCRIPTION =
  'EYEGLASS_LENSES_SINGLE_DESCRIPTION';
export const EYEGLASS_LENSES_BIFOCAL_DESCRIPTION =
  'EYEGLASS_LENSES_BIFOCAL_DESCRIPTION';
export const EYEGLASS_LENSES_TRIFOCAL_DESCRIPTION =
  'EYEGLASS_LENSES_TRIFOCAL_DESCRIPTION';
export const EYEGLASS_LENSES_LENTICULAR_DESCRIPTION =
  'EYEGLASS_LENSES_LENTICULAR_DESCRIPTION';
export const ELECTIVE_CONTACTS_DESCRIPTION = 'ELECTIVE_CONTACTS_DESCRIPTION';
export const MEDICALLY_NECESSARY_CONTACTS_DESCRIPTION =
  'MEDICALLY_NECESSARY_CONTACTS_DESCRIPTION';

// Missing fieldDescription constants from metadataNew.ts
export const COINSURANCE_DESCRIPTION = 'COINSURANCE_DESCRIPTION';
export const COMPLEX_IMAGING_DESCRIPTION = 'COMPLEX_IMAGING_DESCRIPTION';
export const RX_DEDUCTIBLE_DESCRIPTION = 'RX_DEDUCTIBLE_DESCRIPTION';
export const RX_OUT_OF_POCKET_MAX_DESCRIPTION =
  'RX_OUT_OF_POCKET_MAX_DESCRIPTION';

// Additional missing fieldDescription constants from metadataNew.ts
export const DENTAL_ANNUAL_MAXIMUM_DESCRIPTION =
  'DENTAL_ANNUAL_MAXIMUM_DESCRIPTION';
export const DENTAL_INDIVIDUAL_DEDUCTIBLE_DESCRIPTION =
  'DENTAL_INDIVIDUAL_DEDUCTIBLE_DESCRIPTION';
export const ORTHODONTIA_LIFETIME_MAX_DESCRIPTION =
  'ORTHODONTIA_LIFETIME_MAX_DESCRIPTION';
export const DENTAL_PREVENTIVE_CARE_DESCRIPTION =
  'DENTAL_PREVENTIVE_CARE_DESCRIPTION';
export const DENTAL_BASIC_CARE_DESCRIPTION = 'DENTAL_BASIC_CARE_DESCRIPTION';

// IDCard component constants
export const YOU_HAVE_WAIVED_PLANS_FOR_THIS_BENEFIT =
  'YOU_HAVE_WAIVED_PLANS_FOR_THIS_BENEFIT';
export const BENEFITS_ARE_NOT_OFFERED_CURRENTLY =
  'BENEFITS_ARE_NOT_OFFERED_CURRENTLY';
export const ID_CARD_NAME = 'ID_CARD_NAME';
export const ID_CARD_PRIMARY_SUBSCRIBER = 'ID_CARD_PRIMARY_SUBSCRIBER';
export const ID_CARD_GROUP_ID = 'ID_CARD_GROUP_ID';
export const ID_CARD_DOB = 'ID_CARD_DOB';
export const ID_CARD_EFFECTIVE_DATE = 'ID_CARD_EFFECTIVE_DATE';
export const RX_BIN = 'RX_BIN';
export const RX_PCN = 'RX_PCN';
export const RX_GROUP = 'RX_GROUP';
export const ID_CARD_MEMBERS_AND_PROVIDERS = 'ID_CARD_MEMBERS_AND_PROVIDERS';
export const NETWORK_PROVIDERS_MUST_CALL = 'NETWORK_PROVIDERS_MUST_CALL';
export const ID_CARD_CARRIER_PHONE = 'ID_CARD_CARRIER_PHONE';
export const ADD_ID = 'ADD_ID';
export const ID_CARD_PHONE = 'ID_CARD_PHONE';
export const ID_CARD_RX_BIN = 'ID_CARD_RX_BIN';
export const ID_CARD_RX_PCN = 'ID_CARD_RX_PCN';
export const ID_CARD_RX_GROUP = 'ID_CARD_RX_GROUP';
export const HAVE_CODE = 'HAVE_CODE';
export const CURRENT = 'CURRENT';
export const SUBSCRIBER = 'SUBSCRIBER';
export const SHOW_FRONT_OF_ID_CARD = 'SHOW_FRONT_OF_ID_CARD';
export const INFO = 'INFO';
export const FREQUENCIES_TEXT = 'FREQUENCIES_TEXT';
export const SERVICES_TEXT = 'SERVICES_TEXT';
export const COMPARE = 'COMPARE';

// Coverage tier labels
export const COVERAGE_JUST_YOU = 'COVERAGE_JUST_YOU';
export const COVERAGE_YOU_SPOUSE = 'COVERAGE_YOU_SPOUSE';
export const COVERAGE_YOU_CHILDREN = 'COVERAGE_YOU_CHILDREN';
export const COVERAGE_YOU_FAMILY = 'COVERAGE_YOU_FAMILY';
export const COVERAGE_YOU_SPOUSE_OR_CHILDREN =
  'COVERAGE_YOU_SPOUSE_OR_CHILDREN';

// Plan Recommender strings
export const STEP = 'STEP';
export const QUESTIONS = 'QUESTIONS';
export const YOUR_RECOMMENDATION = 'YOUR_RECOMMENDATION';

// Frequency labels
export const FREQUENCY_MONTHLY = 'FREQUENCY_MONTHLY';
export const FREQUENCY_SEMI_MONTHLY = 'FREQUENCY_SEMI_MONTHLY';
export const FREQUENCY_WEEKLY = 'FREQUENCY_WEEKLY';
export const FREQUENCY_BI_WEEKLY = 'FREQUENCY_BI_WEEKLY';
export const FREQUENCY_QUARTERLY = 'FREQUENCY_QUARTERLY';
export const FREQUENCY_ANNUALLY = 'FREQUENCY_ANNUALLY';
export const FREQUENCY_PER_DAY = 'FREQUENCY_PER_DAY';
export const FREQUENCY_PER_SERVICE = 'FREQUENCY_PER_SERVICE';
export const FREQUENCY_PER_ADMISSION = 'FREQUENCY_PER_ADMISSION';
export const FREQUENCY_PER_TRIP = 'FREQUENCY_PER_TRIP';
export const FREQUENCY_PER_WEEK = 'FREQUENCY_PER_WEEK';
export const FREQUENCY_PER_MONTH = 'FREQUENCY_PER_MONTH';
export const FREQUENCY_PER_YEAR = 'FREQUENCY_PER_YEAR';
export const FREQUENCY_PER_PROCEDURE = 'FREQUENCY_PER_PROCEDURE';
export const FREQUENCY_PER_SCRIPT = 'FREQUENCY_PER_SCRIPT';
export const FREQUENCY_PER_ALLOWANCE = 'FREQUENCY_PER_ALLOWANCE';
export const FREQUENCY_NO_INFO = 'FREQUENCY_NO_INFO';
export const FREQUENCY_PER_ITEM = 'FREQUENCY_PER_ITEM';
export const FREQUENCY_EVERY_OTHER_YEAR = 'FREQUENCY_EVERY_OTHER_YEAR';
export const FREQUENCY_PER_VISIT = 'FREQUENCY_PER_VISIT';

// Cost label
export const YOUR_COST = 'YOUR_COST';
export const COST = 'COST';

export const FILTER_OPTIONS_TEXT = 'FILTER_OPTIONS_TEXT';
export const PLAN_RECOMMENDER = 'PLAN_RECOMMENDER';
export const EDIT_TIER_NAMES = 'EDIT_TIER_NAMES';
export const BENEFITS_CONSULTATION = 'BENEFITS_CONSULTATION';
export const PLAN_RECOMMENDER_TITLE = 'PLAN_RECOMMENDER_TITLE';
export const PLAN_RECOMMENDER_SUBTITLE = 'PLAN_RECOMMENDER_SUBTITLE';
export const PLAN_RECOMMENDER_SUBTITLE_2 = 'PLAN_RECOMMENDER_SUBTITLE_2';

// Plan Recommender Question Constants
export const PR_LOCATION_TITLE = 'PR_LOCATION_TITLE';
export const PR_COVERAGE_TITLE = 'PR_COVERAGE_TITLE';
export const PR_COVERAGE_FOOTER = 'PR_COVERAGE_FOOTER';
export const PR_PROCEDURES_TITLE = 'PR_PROCEDURES_TITLE';
export const PR_PROCEDURES_SUBTITLE = 'PR_PROCEDURES_SUBTITLE';
export const PR_DOCTOR_VISITS_TITLE = 'PR_DOCTOR_VISITS_TITLE';
export const PR_DOCTOR_VISITS_SUBTITLE = 'PR_DOCTOR_VISITS_SUBTITLE';
export const PR_DOCTOR_PREFERENCE_TITLE = 'PR_DOCTOR_PREFERENCE_TITLE';
export const PR_PRESCRIPTIONS_TITLE = 'PR_PRESCRIPTIONS_TITLE';
export const PR_PRESCRIPTIONS_SUBTITLE = 'PR_PRESCRIPTIONS_SUBTITLE';

// Plan Recommender Option Constants
export const PR_JUST_YOU = 'PR_JUST_YOU';
export const PR_YOU_SPOUSE_PARTNER = 'PR_YOU_SPOUSE_PARTNER';
export const PR_YOU_CHILDREN = 'PR_YOU_CHILDREN';
export const PR_YOU_FAMILY = 'PR_YOU_FAMILY';
export const PR_PREGNANCY = 'PR_PREGNANCY';
export const PR_MAJOR_SURGERY = 'PR_MAJOR_SURGERY';
export const PR_MINOR_SURGERY = 'PR_MINOR_SURGERY';
export const PR_NONE = 'PR_NONE';
export const PR_IN_NETWORK_ONLY = 'PR_IN_NETWORK_ONLY';
export const PR_OUT_NETWORK_ALSO = 'PR_OUT_NETWORK_ALSO';
export const PR_LOWER_COST = 'PR_LOWER_COST';
export const PR_DOCTORS_TO_CHOOSE = 'PR_DOCTORS_TO_CHOOSE';

export const CUSTOM_PAGE_NOT_FOUND = 'CUSTOM_PAGE_NOT_FOUND';
export const CUSTOM_PAGE_SECTION_NOT_FOUND = 'CUSTOM_PAGE_SECTION_NOT_FOUND';
export const CUSTOM_PAGE_SECTION_NOT_FOUND_MORE_INFO =
  'CUSTOM_PAGE_SECTION_NOT_FOUND_MORE_INFO';

// Plan Recommender Slider Constants
export const PR_PRIMARY_DOCTOR_VISITS = 'PR_PRIMARY_DOCTOR_VISITS';
export const PR_PRIMARY_DOCTOR_INFO = 'PR_PRIMARY_DOCTOR_INFO';
export const PR_SPECIALIST_VISITS = 'PR_SPECIALIST_VISITS';
export const PR_SPECIALIST_INFO = 'PR_SPECIALIST_INFO';
export const PR_NONE_LABEL = 'PR_NONE_LABEL';
export const PR_FREQUENTLY_LABEL = 'PR_FREQUENTLY_LABEL';

// Plan Recommender Prescription Constants
export const PR_LOW_COST = 'PR_LOW_COST';
export const PR_LOW_COST_SUBTITLE = 'PR_LOW_COST_SUBTITLE';
export const PR_MEDIUM_COST = 'PR_MEDIUM_COST';
export const PR_MEDIUM_COST_SUBTITLE = 'PR_MEDIUM_COST_SUBTITLE';
export const PR_HIGH_COST = 'PR_HIGH_COST';
export const PR_HIGH_COST_SUBTITLE = 'PR_HIGH_COST_SUBTITLE';
export const PR_SPECIALTY_COST = 'PR_SPECIALTY_COST';
export const PR_SPECIALTY_COST_SUBTITLE = 'PR_SPECIALTY_COST_SUBTITLE';

// Plan Recommender Button and UI Text Constants
export const PR_PER_YEAR = 'PR_PER_YEAR';
export const PR_SKIP_PRESCRIPTIONS = 'PR_SKIP_PRESCRIPTIONS';
export const PR_VIEW_RECOMMENDATIONS = 'PR_VIEW_RECOMMENDATIONS';
export const PR_EDIT_YOUR_ANSWERS = 'PR_EDIT_YOUR_ANSWERS';
export const PR_UPDATE = 'PR_UPDATE';

// PlanRecommenderPlans constants
export const PR_BASED_ON_COVERING_BENEFITS = 'PR_BASED_ON_COVERING_BENEFITS';
export const PR_EDIT_RESPONSES = 'PR_EDIT_RESPONSES';
export const PR_MORE_PLANS = 'PR_MORE_PLANS';
export const PR_DOWNLOAD_RESULTS = 'PR_DOWNLOAD_RESULTS';
export const PR_RECOMMENDED_PLAN = 'PR_RECOMMENDED_PLAN';
export const PR_RECOMMENDED_PLANS = 'PR_RECOMMENDED_PLANS';

// Coverage types
export const PR_COVERAGE_JUST_YOU = 'PR_COVERAGE_JUST_YOU';
export const PR_COVERAGE_YOU_PARTNER = 'PR_COVERAGE_YOU_PARTNER';
export const PR_COVERAGE_YOU_CHILDREN = 'PR_COVERAGE_YOU_CHILDREN';
export const PR_COVERAGE_YOU_FAMILY = 'PR_COVERAGE_YOU_FAMILY';

// Doctor visits frequency - granular for proper styling
export const PR_NOT_UNDERLINED = 'PR_NOT_UNDERLINED';
export const PR_VISITING_THE_DOCTOR = 'PR_VISITING_THE_DOCTOR';
export const PR_RARELY = 'PR_RARELY';
export const PR_OCCASIONALLY = 'PR_OCCASIONALLY';
export const PR_OFTEN = 'PR_OFTEN';
export const PR_FREQUENTLY = 'PR_FREQUENTLY';

// Specialist visits frequency - granular for proper styling
export const PR_NOT_UNDERLINED_SPECIALIST = 'PR_NOT_UNDERLINED_SPECIALIST';
export const PR_VISITING_A_SPECIALIST = 'PR_VISITING_A_SPECIALIST';

// Procedures - granular for proper styling
export const PR_NOT_UNDERLINED_PROCEDURES = 'PR_NOT_UNDERLINED_PROCEDURES';
export const PR_PLANNING_A = 'PR_PLANNING_A';
export const PR_PREGNANCY_OR_PROCEDURES = 'PR_PREGNANCY_OR_PROCEDURES';
export const PR_PLANNING_PREGNANCY_PROCEDURES =
  'PR_PLANNING_PREGNANCY_PROCEDURES';

// Doctor preference - granular for proper styling
export const PR_USING_A = 'PR_USING_A';
export const PR_NARROW_NETWORK = 'PR_NARROW_NETWORK';
export const PR_WIDE_NETWORK = 'PR_WIDE_NETWORK';
export const PR_KAISER = 'PR_KAISER';

// Prescriptions
export const PR_NOT_TAKING_PRESCRIPTIONS = 'PR_NOT_TAKING_PRESCRIPTIONS';
export const PR_USING_COST_DRUGS = 'PR_USING_COST_DRUGS';
export const PR_AND_USING = 'PR_AND_USING';
export const PR_WE_RECOMMEND = 'PR_WE_RECOMMEND';
export const PR_PLAN = 'PR_PLAN';
export const PR_PLANS = 'PR_PLANS';
export const PR_FOR_YOU = 'PR_FOR_YOU';
export const PR_NO_RECOMMENDATIONS = 'PR_NO_RECOMMENDATIONS';
export const PR_PREMIUM = 'PR_PREMIUM';
export const BENEFIT_PERCENTAGE = 'BENEFIT_PERCENTAGE';
export const MAXIMUM_WEEKLY_BENEFIT = 'MAXIMUM_WEEKLY_BENEFIT';
export const MAXIMUM_MONTHLY_BENEFIT = 'MAXIMUM_MONTHLY_BENEFIT';
export const ELIMINATION_PERIOD = 'ELIMINATION_PERIOD';
export const MAXIMUM_BENEFIT_DURATION = 'MAXIMUM_BENEFIT_DURATION';
export const EMPLOYER_CONTRIBUTION_PER = 'EMPLOYER_CONTRIBUTION_PER';
export const PR_PLAN_NETWORK = 'PR_PLAN_NETWORK';
export const PR_DEDUCTIBLE = 'PR_DEDUCTIBLE';
export const PR_OUT_OF_POCKET_MAX = 'PR_OUT_OF_POCKET_MAX';
export const PR_OFFICE_VISIT = 'PR_OFFICE_VISIT';
export const PR_SPECIALIST_VISIT = 'PR_SPECIALIST_VISIT';
export const PR_RETAIL_TIER = 'PR_RETAIL_TIER';
export const PR_HSA_CONTRIBUTION_HRA_ALLOWANCE =
  'PR_HSA_CONTRIBUTION_HRA_ALLOWANCE';
export const PR_EST_ANNUAL_COST = 'PR_EST_ANNUAL_COST';
export const PR_EST_ANNUAL_COST_BREAKDOWN = 'PR_EST_ANNUAL_COST_BREAKDOWN';
export const PR_UNABLE_TO_RECOMMEND = 'PR_UNABLE_TO_RECOMMEND';
export const PR_EDIT_REFINE_RESPONSES = 'PR_EDIT_REFINE_RESPONSES';
export const PR_RECOMMENDATION = 'PR_RECOMMENDATION';
export const PR_INFO = 'PR_INFO';
export const PR_PLAN_DETAILS = 'PR_PLAN_DETAILS';
export const PR_HSA = 'PR_HSA';
export const PR_DISCLAIMER = 'PR_DISCLAIMER';

// HomeTextWrapper constants
export const MANAGE_AND_ENROLL_IN_BENEFITS = 'MANAGE_AND_ENROLL_IN_BENEFITS';
export const VIEW_BENEFITS_GUIDE_IN_SPANISH = 'VIEW_BENEFITS_GUIDE_IN_SPANISH';
export const MEDICAL_PLAN_RECOMMENDER = 'MEDICAL_PLAN_RECOMMENDER';
export const HOME_TEXT_WRAPPER = 'HOME_TEXT_WRAPPER';

// Language constants object
export const languageConstants: Record<
  string,
  Record<'ENGLISH' | 'SPANISH', string>
> = {
  [HOME]: {
    ENGLISH: 'Home',
    SPANISH: 'Inicio',
  },
  [NEW_HIRE_CHECKLIST]: {
    ENGLISH: 'New Hire Checklist',
    SPANISH: 'Lista de verificación para nuevos empleados',
  },
  [HOW_INSURANCE_WORKS]: {
    ENGLISH: 'How Insurance Works',
    SPANISH: 'Cómo funciona el seguro',
  },
  [DATES_AND_ELIGIBILITY]: {
    ENGLISH: 'Dates and Eligibility',
    SPANISH: 'Fechas y elegibilidad',
  },
  [BENEFITS_WELLNESS]: {
    ENGLISH: 'Benefits & Wellness',
    SPANISH: 'Beneficios y bienestar',
  },
  [TAX_ADVANTAGED_ACCTS]: {
    ENGLISH: 'Tax Advantaged Accts',
    SPANISH: 'Cuentas con ventajas fiscales',
  },
  [FOUR_O_ONE_K]: {
    ENGLISH: '401(k)',
    SPANISH: '401(k)',
  },
  [HOLIDAYS_TIME_OFF]: {
    ENGLISH: 'Holidays & Time Off',
    SPANISH: 'Días festivos y tiempo libre',
  },
  [FAMILY_LEAVE]: {
    ENGLISH: 'Family & Leave',
    SPANISH: 'Familia y licencias',
  },
  [ADDITIONAL_PERKS]: {
    ENGLISH: 'Additional Perks',
    SPANISH: 'Beneficios adicionales',
  },
  [RESOURCES]: {
    ENGLISH: 'Resources',
    SPANISH: 'Recursos',
  },
  [DISCLOSURES]: {
    ENGLISH: 'Disclosures',
    SPANISH: 'Divulgaciones',
  },
  [TELEHEALTH_RX_DELIVERY]: {
    ENGLISH: 'Telehealth/Rx Delivery',
    SPANISH: 'Telesalud/Entrega de Rx',
  },
  [LIFE_AND_DISABILITY]: {
    ENGLISH: 'Life & Disability',
    SPANISH: 'Vida y Discapacidad',
  },
  [VOLUNTARY_BENEFITS]: {
    ENGLISH: 'Worksite',
    SPANISH: 'Lugar de trabajo',
  },
  [VOLUNTARY]: {
    ENGLISH: 'VOLUNTARY',
    SPANISH: 'VOLUNTARIO',
  },
  [WORKSITE]: {
    ENGLISH: 'Worksite',
    SPANISH: 'Lugar de trabajo',
  },
  [WELLBEING]: {
    ENGLISH: 'Wellbeing',
    SPANISH: 'Bienestar',
  },
  [COMMUTER_GENERIC]: {
    ENGLISH: 'Commuter',
    SPANISH: 'Transporte',
  },
  [CUSTOM_PAGES]: {
    ENGLISH: 'Custom Pages',
    SPANISH: 'Páginas personalizadas',
  },
  [STATUS]: {
    ENGLISH: 'Status:',
    SPANISH: 'Estado:',
  },
  [ITS_QUIET_IN_HERE]: {
    ENGLISH: "It's quiet in here",
    SPANISH: 'Está tranquilo aquí',
  },
  [NO_DISCLOSURES_MESSAGE]: {
    ENGLISH:
      'No disclosures have been added to this guide. Reach out to your administrator for more information.',
    SPANISH:
      'No se han agregado divulgaciones a esta guía. Comuníquese con su administrador para obtener más información.',
  },
  [NO_PLANS_CONTACT_ADMIN]: {
    ENGLISH:
      'Please contact your system administrator to enable plans for this benefit',
    SPANISH:
      'Póngase en contacto con el administrador del sistema para habilitar planes para este beneficio',
  },
  [PAGE_NO_LONGER_AVAILABLE]: {
    ENGLISH: 'This page is no longer available.',
    SPANISH: 'Esta página ya no está disponible.',
  },
  [CONTACT_SYSTEM_ADMINISTRATOR]: {
    ENGLISH: 'Please contact your system administrator.',
    SPANISH: 'Póngase en contacto con el administrador del sistema.',
  },
  [BENEFITS_GUIDE_UNDERGOING_UPDATES]: {
    ENGLISH: 'This microsite is currently undergoing updates.',
    SPANISH: 'Esta guía de beneficios está siendo actualizada actualmente.',
  },
  [CHECK_BACK_LATER_CONTACT_ADMIN]: {
    ENGLISH: 'Please check back later or contact your system administrator.',
    SPANISH:
      'Vuelva a consultar más tarde o póngase en contacto con el administrador del sistema.',
  },
  [BENEFITS_GUIDE_NO_LONGER_AVAILABLE]: {
    ENGLISH: 'This microsite is no longer available.',
    SPANISH: 'Esta guía de beneficios ya no está disponible.',
  },
  [NO_ACCESS_CONTACT_BROKER]: {
    ENGLISH: 'You dont have access to this, please reach out to your Broker.',
    SPANISH: 'No tienes acceso a esto, por favor contacta a tu Corredor.',
  },
  [BENEFIT_GUIDE_NO_LONGER_AVAILABLE]: {
    ENGLISH: 'This microsite is no longer available.',
    SPANISH: 'Esta guía de beneficios ya no está disponible.',
  },
  [VIEW]: {
    ENGLISH: 'View',
    SPANISH: 'Ver',
  },
  [PREVIEW]: {
    ENGLISH: 'Preview',
    SPANISH: 'Vista previa',
  },
  [HOW_DOES_A_DEDUCTIBLE_WORK]: {
    ENGLISH: 'How does a Deductible Work?',
    SPANISH: '¿Cómo funciona un deducible?',
  },
  [WHAT_COUNTS_TOWARDS_A_DEDUCTIBLE]: {
    ENGLISH: 'What Counts Towards a Deductible?',
    SPANISH: '¿Qué se aplica al deducible?',
  },
  [WHAT_IS_COINSURANCE]: {
    ENGLISH: 'What is Coinsurance?',
    SPANISH: '¿Qué es el coseguro?',
  },
  [WHAT_COUNTS_TOWARDS_AN_OUT_OF_POCKET_LIMIT]: {
    ENGLISH: 'What Counts Towards an Out-of-Pocket Limit?',
    SPANISH: '¿Qué se aplica al límite de desembolso máximo?',
  },
  [WHAT_IS_IN_NETWORK_VS_OUT_OF_NETWORK]: {
    ENGLISH: 'What is In-Network vs. Out-of-Network?',
    SPANISH: '¿Qué significa dentro de la red vs. fuera de la red?',
  },
  [WHAT_HAPPENS_IF_I_GO_OUT_OF_NETWORK]: {
    ENGLISH: 'What Happens If I Go Out-of-Network?',
    SPANISH: '¿Qué sucede si voy fuera de la red?',
  },
  [CHANGING_MEDICAL_CARRIERS]: {
    ENGLISH: 'Changing Medical Carriers',
    SPANISH: 'Cambio de proveedor médico',
  },
  [PRIOR_AUTHORIZATION_FOR_PRESCRIPTIONS]: {
    ENGLISH: 'Prior Authorization for Prescriptions',
    SPANISH: 'Autorización previa para recetas médicas',
  },
  [IMPORTANT_DATES]: {
    ENGLISH: 'Important Dates',
    SPANISH: 'Fechas importantes',
  },
  [PLAN_EFFECTIVE_DATES]: {
    ENGLISH: 'Plan Effective Dates:',
    SPANISH: 'Fechas de vigencia del plan:',
  },
  [PLAN_EFFECTIVE_DATE]: {
    ENGLISH: 'Plan Effective Date:',
    SPANISH: 'Fecha de vigencia del plan:',
  },
  [EFFECTIVE_FROM]: {
    ENGLISH: 'Effective',
    SPANISH: 'Vigente desde el',
  },
  [NO_END_DATE]: {
    ENGLISH: 'no end date',
    SPANISH: 'sin fecha de finalización',
  },
  [OPEN_ENROLLMENT_DATE]: {
    ENGLISH: 'Open Enrollment Date:',
    SPANISH: 'Fecha de inscripción abierta:',
  },
  [ELIGIBILITY]: {
    ENGLISH: 'Eligibility',
    SPANISH: 'Elegibilidad',
  },
  [RULES]: {
    ENGLISH: 'Rules',
    SPANISH: 'Reglas',
  },
  [QUALIFYING_LIFE_EVENTS]: {
    ENGLISH: 'Qualifying Life Events',
    SPANISH: 'Eventos de vida que califican',
  },
  [WAIVER_CREDIT]: {
    ENGLISH: 'Waiver Credit',
    SPANISH: 'Crédito por renuncia',
  },
  [ADD_CONTENT]: {
    ENGLISH: 'Add Content',
    SPANISH: 'Añadir contenido',
  },
  [IN_NETWORK]: {
    ENGLISH: 'In-Network',
    SPANISH: 'Dentro de la red',
  },
  [OUT_OF_NETWORK]: {
    ENGLISH: 'Out-of-Network',
    SPANISH: 'Fuera de la red',
  },
  [ADD_BENEFITS_CONSULT]: {
    ENGLISH: 'Add Benefits Consult',
    SPANISH: 'Añadir consulta de beneficios',
  },
  [EMPLOYER_CONSULTATION_CANNOT_BE_ENABLED_BECAUSE_THERE_ARE_TEXT]: {
    ENGLISH:
      'Employer Consultation cannot be enabled because there are no employer consultants assigned to this employer.',
    SPANISH:
      'La consulta del empleador no se puede habilitar porque no hay consultores del empleador asignados a este empleador.',
  },
  [ENABLE_DISABLE_BENEFITS_CONSULTATION]: {
    ENGLISH: 'Enable/Disable Benefits Consultation',
    SPANISH: 'Habilitar/deshabilitar la consulta de beneficios',
  },
  [DISPLAY_BROKER_BENEFITS_CONSULTATION]: {
    ENGLISH: 'Display Broker Benefits Consultation?',
    SPANISH: '¿Mostrar consulta de beneficios del corredor?',
  },
  [DISPLAY_EMPLOYER_BENEFITS_CONSULTATION]: {
    ENGLISH: 'Display Employer Benefits Consultation?',
    SPANISH: '¿Mostrar consulta de beneficios del empleador?',
  },
  [SETUP_BROKER_CONSULTANTS]: {
    ENGLISH: 'Setup Broker Consultants',
    SPANISH: 'Configurar consultores del corredor',
  },
  [SETUP_EMPLOYER_CONSULTANTS]: {
    ENGLISH: 'Setup Employer Consultants',
    SPANISH: 'Configurar consultores del empleador',
  },
  [WHO_IS_COVERED]: {
    ENGLISH: 'Who is covered',
    SPANISH: 'Quién está cubierto',
  },
  [JUST_YOU]: {
    ENGLISH: 'Just you',
    SPANISH: 'Solo tú',
  },
  [YOU_SPOUSE]: {
    ENGLISH: 'You + Spouse',
    SPANISH: 'Tú + Cónyuge',
  },
  [YOU_CHILD_REN]: {
    ENGLISH: 'You + Child(ren)',
    SPANISH: 'Tú + Hijo(s)',
  },
  [YOU_FAMILY]: {
    ENGLISH: 'You + Family',
    SPANISH: 'Tú + Familia',
  },
  [FILTER_OPTIONS]: {
    ENGLISH: 'Filter Options',
    SPANISH: 'Filtros',
  },
  [PLAN_PROVIDERS]: {
    ENGLISH: 'Plan Providers',
    SPANISH: 'Proveedores del plan',
  },
  [PLAN_TYPE]: {
    ENGLISH: 'Plan Type',
    SPANISH: 'Tipo de plan',
  },
  [PLAN_NAME]: {
    ENGLISH: 'Plan Name',
    SPANISH: 'Nombre del plan',
  },
  [YOUR_MONTHLY_COST]: {
    ENGLISH: 'Your Monthly Cost',
    SPANISH: 'Tu costo mensual',
  },
  [PLAN_NETWORK]: {
    ENGLISH: 'Plan Network',
    SPANISH: 'Red del plan',
  },
  [DENTAL_ANNUAL_MAXIMUM]: {
    ENGLISH: 'Annual Maximum (Per Person)',
    SPANISH: 'Máximo anual (por persona)',
  },
  [DEDUCTIBLES_AND_OOP_MAXIMUM]: {
    ENGLISH: 'Deductibles and OOP Maximum',
    SPANISH: 'Deducibles y máximo de desembolso',
  },
  [INDIVIDUAL_DEDUCTIBLE]: {
    ENGLISH: 'Individual Deductible',
    SPANISH: 'Deducible individual',
  },
  [FAMILY_DEDUCTIBLE]: {
    ENGLISH: 'Family Deductible',
    SPANISH: 'Deducible familiar',
  },
  [DEDUCTIBLE_IND_WITHIN_FAM]: {
    ENGLISH: 'Deductible (Ind within Fam)',
    SPANISH: 'Deducible (Ind. dentro de Fam.)',
  },
  [INDIVIDUAL_OUT_OF_POCKET_MAX]: {
    ENGLISH: 'Individual Out-of-Pocket Max',
    SPANISH: 'Desembolso máximo individual',
  },
  [FAMILY_OUT_OF_POCKET_MAX]: {
    ENGLISH: 'Family Out-of-Pocket Max',
    SPANISH: 'Desembolso máximo familiar',
  },
  [OUT_OF_POCKET_MAX_IND_WITHIN_FAM]: {
    ENGLISH: 'Out-of-Pocket Max (Ind within Fam)',
    SPANISH: 'Máximo (Ind. en Fam.)',
  },
  [SERVICES]: {
    ENGLISH: 'SERVICES',
    SPANISH: 'SERVICIOS',
  },
  [RX]: {
    ENGLISH: 'RX',
    SPANISH: 'RX',
  },
  [OFFICE_VISIT]: {
    ENGLISH: 'Office Visit',
    SPANISH: 'Consulta médica',
  },
  [SPECIALIST_VISIT]: {
    ENGLISH: 'Specialist Visit',
    SPANISH: 'Consulta con especialista',
  },
  [PREVENTIVE_CARE]: {
    ENGLISH: 'Preventive Care',
    SPANISH: 'Atención preventiva',
  },
  [EMERGENCY_ROOM]: {
    ENGLISH: 'Emergency Room',
    SPANISH: 'Sala de emergencias',
  },
  [MANAGE_AND_ENROLL_IN_BENEFITS]: {
    ENGLISH: 'Manage and Enroll in Benefits',
    SPANISH: 'Gestionar e inscribirse en Beneficios',
  },
  [VIEW_BENEFITS_GUIDE_IN_SPANISH]: {
    ENGLISH: 'Ver la Guía de Beneficios en Español',
    SPANISH: 'View English Microsite',
  },
  [MEDICAL_PLAN_RECOMMENDER]: {
    ENGLISH: 'Medical Plan Recommender',
    SPANISH: 'Recomendador de Planes Médicos',
  },
  [WATCH_OPEN_ENROLLMENT_MEETING]: {
    ENGLISH: 'Watch Open Enrollment Meeting',
    SPANISH: 'Ver la reunión de inscripción abierta',
  },
  [OPEN_ENROLLMENT_MEETING]: {
    ENGLISH: 'Open Enrollment Meeting',
    SPANISH: 'Reunión de Inscripción Abierta',
  },
  [EXPLORE_YOUR_BENEFITS_GUIDE]: {
    ENGLISH: 'Explore Your Microsite',
    SPANISH: 'Explore su Guía de Beneficios',
  },
  [BENEFITS_GUIDE]: {
    ENGLISH: 'Microsite',
    SPANISH: 'Guía de Beneficios',
  },
  // Default home page heading when the broker has not saved a custom one
  [LEARN_ABOUT_YOUR_BENEFITS]: {
    ENGLISH: 'Learn about your benefits',
    SPANISH: 'Infórmese sobre sus beneficios',
  },
  [HOME_TEXT_WRAPPER]: {
    ENGLISH: 'Home Text Wrapper',
    SPANISH: 'Envoltura de texto de inicio',
  },
  [DIAGNOSTIC_LAB_X_RAY]: {
    ENGLISH: 'Diagnostic Lab/ X-Ray',
    SPANISH: 'Lab diagnóstico/Rayos X',
  },
  [COMPLEX_IMAGING]: {
    ENGLISH: 'Complex Imaging',
    SPANISH: 'Imágenes complejas',
  },
  [URGENT_CARE]: {
    ENGLISH: 'Urgent Care',
    SPANISH: 'Atención de urgencia',
  },
  [VIRTUAL_CARE]: {
    ENGLISH: 'Virtual Care',
    SPANISH: 'Atención virtual',
  },
  [HOSPITAL_INPATIENT]: {
    ENGLISH: 'Hospital Inpatient',
    SPANISH: 'Hospital Interno',
  },
  [HOSPITAL_OUTPATIENT]: {
    ENGLISH: 'Hospital Outpatient',
    SPANISH: 'Hospital Externo',
  },
  [CHIROPRACTIC_CARE]: {
    ENGLISH: 'Chiropractic Care',
    SPANISH: 'Atención quiropráctica',
  },
  [ACUPUNCTURE_CARE]: {
    ENGLISH: 'Acupuncture Care',
    SPANISH: 'Atención de acupuntura',
  },
  [MENTAL_HEALTH_INPATIENT]: {
    ENGLISH: 'Mental Health (Inpatient)',
    SPANISH: 'Salud mental (paciente internado)',
  },
  [INFERTILITY_TREATMENT]: {
    ENGLISH: 'Infertility Treatment',
    SPANISH: 'Tratamiento de infertilidad',
  },
  [MENTAL_HEALTH_OUTPATIENT]: {
    ENGLISH: 'Mental Health (Outpatient)',
    SPANISH: 'Salud mental (paciente ambulatorio)',
  },
  [RETAIL_TIER_1]: {
    ENGLISH: 'Retail Tier 1',
    SPANISH: 'Farmacia Nivel 1',
  },
  [RETAIL_TIER_2]: {
    ENGLISH: 'Retail Tier 2',
    SPANISH: 'Farmacia Nivel 2',
  },
  [RETAIL_TIER_3]: {
    ENGLISH: 'Retail Tier 3',
    SPANISH: 'Farmacia Nivel 3',
  },
  [RETAIL_TIER_4]: {
    ENGLISH: 'Retail Tier 4',
    SPANISH: 'Farmacia Nivel 4',
  },
  [MAIL_ORDER_TIER_1]: {
    ENGLISH: 'Mail Order Tier 1',
    SPANISH: 'Pedido por correo Nivel 1',
  },
  [MAIL_ORDER_TIER_2]: {
    ENGLISH: 'Mail Order Tier 2',
    SPANISH: 'Pedido por correo Nivel 2',
  },
  [MAIL_ORDER_TIER_3]: {
    ENGLISH: 'Mail Order Tier 3',
    SPANISH: 'Pedido por correo Nivel 3',
  },
  [MAIL_ORDER_TIER_4]: {
    ENGLISH: 'Mail Order Tier 4',
    SPANISH: 'Pedido por correo Nivel 4',
  },
  [LEGAL_DISCLAIMER_TEXT]: {
    ENGLISH:
      'This Microsite offers a high-level overview of your available benefits. The official Plan Documents are what govern your official rights and coverage under each plan.',
    SPANISH:
      'Esta guía de beneficios ofrece un resumen general de los beneficios disponibles. Los documentos oficiales del plan son los que rigen sus derechos y cobertura oficiales bajo cada plan.',
  },
  [NOT_COVERED]: {
    ENGLISH: 'Not Covered',
    SPANISH: 'No cubierto',
  },
  [PER_SCRIPT]: {
    ENGLISH: 'Per Script',
    SPANISH: 'Por receta Medica',
  },
  [COVERS_YOU]: {
    ENGLISH: 'Covers you',
    SPANISH: 'Te cubre',
  },
  [PROVIDER_SEARCH]: {
    ENGLISH: 'Provider Search',
    SPANISH: 'Búsqueda de proveedores',
  },
  [SEARCH_INSTRUCTIONS]: {
    ENGLISH: 'Search Instructions',
    SPANISH: 'Instrucciones de búsqueda',
  },
  [NETWORK_NAME_FOR_PLAN]: {
    ENGLISH: 'The network name for this plan',
    SPANISH: 'El nombre de la red para este plan',
  },
  [SEARCH_PROVIDERS_ON_WEBSITE]: {
    ENGLISH: 'You can search for providers on',
    SPANISH: 'Puede buscar proveedores en el sitio web de',
  },
  [ADDITIONAL_INFORMATION]: {
    ENGLISH: 'Additional Information',
    SPANISH: 'Información adicional',
  },
  [SEARCH_ON_CARRIER_SITE]: {
    ENGLISH: 'Search on Carrier Site',
    SPANISH: 'Buscar en el sitio web de la compañía de seguros',
  },
  [VISITS_MAX]: {
    ENGLISH: 'visits max',
    SPANISH: 'visitas máx.',
  },
  [PER_PROCEDURE]: {
    ENGLISH: 'per procedure',
    SPANISH: 'por procedimiento',
  },
  [LIFETIME_MAX]: {
    ENGLISH: 'lifetime max',
    SPANISH: 'máximo de por vida',
  },
  [COVERED_UP_TO_COMBINED_ANNUAL_MAX]: {
    ENGLISH: 'covered up to combined annual max',
    SPANISH: 'cubierto hasta el máximo anual combinado',
  },
  [TELEHEALTH_SERVICES]: {
    ENGLISH: 'Telehealth Services',
    SPANISH: 'Servicios de telesalud',
  },
  [RX_DELIVERY]: {
    ENGLISH: 'Rx Delivery',
    SPANISH: 'Entrega de recetas (Rx)',
  },
  [RX_COUPONS]: {
    ENGLISH: 'Rx Coupons',
    SPANISH: 'Cupones de recetas (Rx)',
  },
  [PLAN_RESOURCES]: {
    ENGLISH: 'Plan Resources',
    SPANISH: 'Recursos del plan',
  },
  [ORTHODONTIA_MAXIMUM]: {
    ENGLISH: 'Orthodontia Maximum',
    SPANISH: 'Máximo de ortodoncia',
  },
  [BASIC_CARE]: {
    ENGLISH: 'Basic Care',
    SPANISH: 'Atención básica',
  },
  [MAJOR_CARE]: {
    ENGLISH: 'Major Care',
    SPANISH: 'Atención mayor',
  },
  [ENDODONTIC_CARE]: {
    ENGLISH: 'Endodontic Care',
    SPANISH: 'Atención endodóntica',
  },
  [PERIODONTIC_CARE]: {
    ENGLISH: 'Periodontic Care',
    SPANISH: 'Atención periodontal',
  },
  [IMPLANTS]: {
    ENGLISH: 'Implants',
    SPANISH: 'Implantes',
  },
  [WAITING_PERIOD]: {
    ENGLISH: 'Waiting Period',
    SPANISH: 'Período de espera',
  },
  [OUT_OF_NETWORK_REIMBURSEMENT]: {
    ENGLISH: 'Out-of-Network Reimbursement',
    SPANISH: 'Reembolso fuera de la red',
  },
  [EXAM_COPAY]: {
    ENGLISH: 'Exam Copay',
    SPANISH: 'Copago por examen',
  },
  [MATERIALS_COPAY]: {
    ENGLISH: 'Materials Copay',
    SPANISH: 'Copago de materiales',
  },
  [EYEGLASS_LENSES_SINGLE]: {
    ENGLISH: 'Eyeglass Lenses Single',
    SPANISH: 'Lentes monofocales',
  },
  [EYEGLASS_LENSES_BIFOCAL]: {
    ENGLISH: 'Eyeglass Lenses Bifocal',
    SPANISH: 'Lentes bifocales',
  },
  [EYEGLASS_LENSES_TRIFOCAL]: {
    ENGLISH: 'Eyeglass Lenses Trifocal',
    SPANISH: 'Lentes trifocales',
  },
  [EYEGLASS_LENSES_LENTICULAR]: {
    ENGLISH: 'Eyeglass Lenses Lenticular',
    SPANISH: 'Lentes lenticulares',
  },
  [FRAMES]: {
    ENGLISH: 'Frames',
    SPANISH: 'Monturas',
  },
  [ELECTIVE_CONTACTS]: {
    ENGLISH: 'Elective Contacts',
    SPANISH: 'Lentes de contacto electivos',
  },
  [MEDICALLY_NECESSARY_CONTACTS]: {
    ENGLISH: 'Medically Necessary Contacts',
    SPANISH: 'Lentes médicamente necesarios',
  },
  [LASIK]: {
    ENGLISH: 'Lasik',
    SPANISH: 'LASIK',
  },
  [ALLOWANCE_PER_YEAR]: {
    ENGLISH: 'Allowance Per year',
    SPANISH: 'Asignación por año',
  },
  [PER_YEAR]: {
    ENGLISH: 'Per year',
    SPANISH: 'Por año',
  },
  [BENEFIT]: {
    ENGLISH: 'Benefit',
    SPANISH: 'Beneficio',
  },
  [BENEFIT_MAXIMUM]: {
    ENGLISH: 'Benefit Maximum',
    SPANISH: 'Beneficio máximo',
  },
  [GUARANTEED_ISSUE]: {
    ENGLISH: 'Guaranteed Issue',
    SPANISH: 'Emisión garantizada',
  },
  [AGE_REDUCTION_SCHEDULE]: {
    ENGLISH: 'Age Reduction Schedule',
    SPANISH: 'Programa de reducción por edad',
  },
  [ACCELERATED_BENEFIT]: {
    ENGLISH: 'Accelerated Benefit',
    SPANISH: 'Beneficio acelerado',
  },
  [PORTABILITY]: {
    ENGLISH: 'Portability',
    SPANISH: 'Portabilidad',
  },
  [WAIVER_OF_PREMIUM]: {
    ENGLISH: 'Waiver of Premium',
    SPANISH: 'Exención de prima',
  },
  [VOLUME]: {
    ENGLISH: 'Volume',
    SPANISH: 'Volumen',
  },
  [LIFE_RATE_PER_1000]: {
    ENGLISH: 'Life Rate Per $1000',
    SPANISH: 'Tasa de vida por $1000',
  },
  [ADD_RATE_PER_1000]: {
    ENGLISH: 'ADD Rate per $1000',
    SPANISH: 'Tasa de Muerte y Desmembramiento Accidental (ADD) por $1000',
  },
  [PLAN_SUMMARY]: {
    ENGLISH: 'Plan Summary',
    SPANISH: 'Resumen del plan',
  },
  [PORTABILITY_CONVERSION_FORM]: {
    ENGLISH: 'Portability & Conversion Form',
    SPANISH: 'Formulario de portabilidad y conversión',
  },
  [COC_FILE]: {
    ENGLISH: 'COC File',
    SPANISH: 'Archivo del Certificado de Cobertura (COC)',
  },
  [PORTABILITY_VS_CONVERSION]: {
    ENGLISH: 'Portability vs conversion',
    SPANISH: 'Portabilidad vs. conversión',
  },
  [VISION]: {
    ENGLISH: 'Vision',
    SPANISH: 'Visión',
  },
  [FREQUENCIES]: {
    ENGLISH: 'FREQUENCIES',
    SPANISH: 'FRECUENCIAS',
  },
  [EYE_EXAM]: {
    ENGLISH: 'Eye Exam',
    SPANISH: 'Examen de la vista',
  },
  [LENSES]: {
    ENGLISH: 'Lenses',
    SPANISH: 'Lentes',
  },

  [EMPLOYEE]: {
    ENGLISH: 'Employee',
    SPANISH: 'Empleado',
  },
  [SPOUSE]: {
    ENGLISH: 'Spouse',
    SPANISH: 'Cónyuge',
  },
  [CHILD]: {
    ENGLISH: 'Child',
    SPANISH: 'Hijo(a)',
  },
  [PLAN_NAME_1]: {
    ENGLISH: 'Plan Name *',
    SPANISH: 'Nombre del plan *',
  },
  [EFFECTIVE_DATES]: {
    ENGLISH: 'Effective Dates *',
    SPANISH: 'Fechas de vigencia *',
  },
  [BENEFIT_CLASSES]: {
    ENGLISH: 'Benefit Classes *',
    SPANISH: 'Clases de beneficios *',
  },
  [CARRIER]: {
    ENGLISH: 'Carrier *',
    SPANISH: 'Aseguradora *',
  },
  [GROUP_ID_POLICY]: {
    ENGLISH: 'Group ID / Policy #',
    SPANISH: 'ID de grupo / N.º de póliza',
  },
  [PRE_EXISTING_CONDITIONS]: {
    ENGLISH: 'Pre Existing Conditions',
    SPANISH: 'Condiciones preexistentes',
  },
  [PLAN_INFORMATION]: {
    ENGLISH: 'Plan  information',
    SPANISH: 'Información del plan',
  },
  [PLAN_DESCRIPTION]: {
    ENGLISH: 'Plan Description',
    SPANISH: 'Descripción del plan',
  },
  [CHARACTER_LIMIT]: {
    ENGLISH: 'Character Limit',
    SPANISH: 'Límite de caracteres',
  },
  [GUARANTEE_ISSUE]: {
    ENGLISH: 'Guarantee Issue',
    SPANISH: 'Emisión garantizada',
  },
  [HOSPITAL_ADMISSION]: {
    ENGLISH: 'Hospital Admission',
    SPANISH: 'Admisión hospitalaria',
  },
  [HOSPITAL_CONFINEMENT_PER_DAY]: {
    ENGLISH: 'Hospital Confinement (per day)',
    SPANISH: 'Confinamiento hospitalario (por día)',
  },
  [ICU_ADMISSION]: {
    ENGLISH: 'ICU Admission',
    SPANISH: 'Admisión en UCI',
  },
  [ICU_CONFINEMENT_PER_DAY]: {
    ENGLISH: 'ICU Confinement (per day)',
    SPANISH: 'Confinamiento en UCI (por día)',
  },
  [TOTAL_COST]: {
    ENGLISH: 'Total Cost',
    SPANISH: 'Costo total',
  },
  [EMPLOYER_CONTRIBUTION_FREQUENCY]: {
    ENGLISH: 'Employer Contribution Frequency',
    SPANISH: 'Frecuencia de la contribución del empleador',
  },
  [EMPLOYER_CONTRIBUTION]: {
    ENGLISH: 'Employer Contribution',
    SPANISH: 'Contribución del empleador',
  },
  [MAX_YEARLY_CONTRIBUTION_MARRIED_FILING_SEPARATELY]: {
    ENGLISH: 'Max Yearly Contribution Married Filing Separately',
    SPANISH:
      'Contribución anual máxima para casados con declaración por separado',
  },
  [MAX_YEARLY_CONTRIBUTION_MARRIED_FILING_JOINTLY_OR_SINGLE_TEXT]: {
    ENGLISH: 'Max Yearly Contribution Married Filing Jointly or Single Parent',
    SPANISH:
      'Contribución anual máxima para casados con declaración conjunta o padre/madre soltero(a)',
  },
  [END_OF_YEAR_POLICY]: {
    ENGLISH: 'End of year policy',
    SPANISH: 'Política de fin de año',
  },
  [PLAN_DOCUMENT]: {
    ENGLISH: 'Plan document',
    SPANISH: 'Documento del plan',
  },
  [THINGS_TO_CONSIDER]: {
    ENGLISH: 'Things to consider',
    SPANISH: 'Cosas a considerar',
  },
  [EMPLOYEE_EE_CONTRIBUTION]: {
    ENGLISH: 'Employee EE Contribution',
    SPANISH: 'Contribución del empleado (solo empleado)',
  },
  [EMPLOYEE_ES_CONTRIBUTION]: {
    ENGLISH: 'Employee ES Contribution',
    SPANISH: 'Contribución del empleado (empleado + cónyuge)',
  },
  [EMPLOYEE_EC_CONTRIBUTION]: {
    ENGLISH: 'Employee EC Contribution',
    SPANISH: 'Contribución del empleado (empleado + hijo(s))',
  },
  [EMPLOYEE_EF_CONTRIBUTION]: {
    ENGLISH: 'Employee EF Contribution',
    SPANISH: 'Contribución del empleado (empleado + familia)',
  },
  [OTHER]: {
    ENGLISH: 'Other',
    SPANISH: 'Otro',
  },
  [FOUR_O_ONE_K_MATCH_POLICY]: {
    ENGLISH: '401(k) Match Policy',
    SPANISH: 'Política de contribución equivalente al 401(k)',
  },
  [ANNUAL_MAX_CONTRIBUTION]: {
    ENGLISH: 'Annual Max Contribution',
    SPANISH: 'Contribución máxima anual',
  },
  [ANNUAL_CATCHUP_CONTRIBUTION_50_OR_OLDER]: {
    ENGLISH: 'Annual Catchup Contribution 50 or Older',
    SPANISH: 'Contribución de actualización anual para mayores de 50 años',
  },
  [ANNUAL_MAX_CATCHUP_CONTRIBUTION]: {
    ENGLISH: 'Annual Max Catch-Up Contribution*',
    SPANISH: 'Contribución Máxima Anual de Actualización*',
  },
  [CATCHUP_CONTRIBUTION_DISCLAIMER]: {
    ENGLISH:
      '*Catch-up only for individuals who are age 50 or over at the end of the calendar year',
    SPANISH:
      '*Contribución de actualización solo para individuos de 50 años o más al final del año calendario',
  },
  [FOUR_O_ONE_K_ROLLOVER_FORM]: {
    ENGLISH: '401(k) Rollover Form',
    SPANISH: 'Formulario de transferencia (rollover) de 401(k)',
  },
  [CONTRIBUTIONS]: {
    ENGLISH: 'Contributions',
    SPANISH: 'Contribuciones',
  },
  [ADVANTAGES]: {
    ENGLISH: 'Advantages',
    SPANISH: 'Ventajas',
  },
  [OVERVIEW]: {
    ENGLISH: 'Overview',
    SPANISH: 'Resumen',
  },
  [EXPENSES]: {
    ENGLISH: 'Expenses',
    SPANISH: 'Gastos',
  },
  [CONSIDERATIONS]: {
    ENGLISH: 'Considerations',
    SPANISH: 'Consideraciones',
  },
  [CONTACT_SUPPORT_BUTTON]: {
    ENGLISH: 'Contact Support',
    SPANISH: 'Contactar Soporte',
  },
  [ADD_SUPPORT_BUTTON]: {
    ENGLISH: 'Add Support Button',
    SPANISH: 'Agregar Botón de Soporte',
  },
  [NEED_BENEFITS_ASSISTANCE]: {
    ENGLISH: 'Need Benefits Assistance?',
    SPANISH: '¿Necesita Asistencia con Beneficios?',
  },
  [SCHEDULE_BENEFITS_CONSULTATION]: {
    ENGLISH: 'Schedule a Benefits Consultation',
    SPANISH: 'Programar una Consulta de Beneficios',
  },
  [CONSULTATION]: {
    ENGLISH: 'Consultation',
    SPANISH: 'Consulta',
  },
  [SCHEDULE_A_CONSULTATION]: {
    ENGLISH: 'Schedule a Consultation',
    SPANISH: 'Programar una Consulta',
  },
  [ONE_ON_ONE_CONSULTATION]: {
    ENGLISH: 'One-on-one 20 min consultation',
    SPANISH: 'Consulta individual de 20 minutos',
  },
  [CONSULTATION_WITH_BROKER_REPRESENTATIVE]: {
    ENGLISH: 'Consultation with a Broker Representative',
    SPANISH: 'Consulta con un Representante del Corredor',
  },
  [CONSULTATION_WITH_YOUR_EMPLOYER]: {
    ENGLISH: 'Consultation with your Employer',
    SPANISH: 'Consulta con tu Empleador',
  },
  [BROKER_CONSULTATION_DESCRIPTION]: {
    ENGLISH:
      'Schedule a consultation with a Broker representative to discuss your complex benefits questions: How to pick a plan, how to file a Qualifying Life Event, and more.',
    SPANISH:
      'Programa una consulta con un representante del Corredor para discutir tus preguntas complejas sobre beneficios: Cómo elegir un plan, cómo presentar un Evento de Vida Calificante, y más.',
  },
  [EMPLOYER_CONSULTATION_DESCRIPTION]: {
    ENGLISH:
      'Schedule a consultation with an Employer representative to discuss your general benefits questions.',
    SPANISH:
      'Programa una consulta con un representante del Empleador para discutir tus preguntas generales sobre beneficios.',
  },
  [BOOK_CONSULTATION]: {
    ENGLISH: 'Book Consultation',
    SPANISH: 'Reservar Consulta',
  },
  [MOVE]: {
    ENGLISH: 'Move',
    SPANISH: 'Mover',
  },
  [BENEFIT_TOOLTIP]: {
    ENGLISH:
      "The total benefit amount before considering the policy's benefit maximum.",
    SPANISH:
      'El monto total del beneficio antes de considerar el máximo de beneficio de la póliza.',
  },
  [MAX_BENEFIT_TOOLTIP]: {
    ENGLISH: 'The maximum amount a carrier will pay out for this policy.',
    SPANISH: 'La cantidad máxima que una aseguradora pagará por esta póliza.',
  },
  [GUARANTEED_ISSUE_TOOLTIP]: {
    ENGLISH:
      'Guaranteed issue (GI) is the benefit amount automatically available without having to provide Evidence of Insurability (EOI). Carriers require EOI submission for any amount above the GI.',
    SPANISH:
      'La emisión garantizada (GI) es el monto del beneficio disponible automáticamente sin tener que proporcionar Evidencia de Asegurabilidad (EOI). Las aseguradoras requieren la presentación de EOI para cualquier cantidad por encima de la GI.',
  },
  [MAX_WEEKLY_BENEFIT_TOOLTIP]: {
    ENGLISH:
      'The maximum weekly benefit amount a carrier will pay out for this policy.',
    SPANISH:
      'La cantidad máxima de beneficio semanal que una aseguradora pagará por esta póliza.',
  },
  [MAX_MONTHLY_BENEFIT_TOOLTIP]: {
    ENGLISH:
      'The maximum monthly benefit amount a carrier will pay out for this policy.',
    SPANISH:
      'La cantidad máxima de beneficio mensual que una aseguradora pagará por esta póliza.',
  },
  [WAITING_PERIOD_TOOLTIP]: {
    ENGLISH:
      'The length of time you must be disabled before benefits are payable.',
    SPANISH:
      'El período de tiempo que debe estar discapacitado antes de que se paguen los beneficios.',
  },
  [MAX_BENEFIT_DURATION_TOOLTIP]: {
    ENGLISH:
      'The maximum length of time that you are eligible to receive the benefit.',
    SPANISH:
      'El período máximo de tiempo que es elegible para recibir el beneficio.',
  },
  [VOL_BENEFIT_TOOLTIP]: {
    ENGLISH: 'The benefit amount that can be elected.',
    SPANISH: 'El monto del beneficio que se puede elegir.',
  },
  [VOL_GUARANTEED_ISSUE_TOOLTIP]: {
    ENGLISH:
      'Guaranteed issue (GI) is the benefit amount automatically available without having to provide Evidence of Insurability (EOI). Carriers require EOI submission for any amount above the GI. Typically, the GI amount is only available the first chance you have to elect the benefit. Moving forward you will need to submit an EOI for any increase in coverage.',
    SPANISH:
      'La emisión garantizada (GI) es el monto del beneficio disponible automáticamente sin tener que proporcionar Evidencia de Asegurabilidad (EOI). Las aseguradoras requieren la presentación de EOI para cualquier cantidad por encima de la GI. Típicamente, el monto de GI solo está disponible la primera oportunidad que tiene para elegir el beneficio. En el futuro, necesitará presentar un EOI para cualquier aumento en la cobertura.',
  },
  [BACK_TO_EDITING]: {
    ENGLISH: 'Back to Editing',
    SPANISH: 'Volver a Editar',
  },
  [CLOSE]: {
    ENGLISH: 'Close',
    SPANISH: 'Cerrar',
  },
  [AUTH_ERROR_INVALID_DOMAIN]: {
    ENGLISH:
      'The details entered are not recognized. Please try using a work email or contact your HR.',
    SPANISH:
      'Los detalles ingresados no son reconocidos. Por favor intenta usar un correo electrónico de trabajo o contacta a tu Recursos Humanos.',
  },
  [AUTH_ERROR_PLAN_NOT_FOUND]: {
    ENGLISH: 'No plans found!',
    SPANISH: '¡No se encontraron planes!',
  },
  [AUTH_ERROR_TOKEN_NOT_FOUND]: {
    ENGLISH: 'Token not found.',
    SPANISH: 'Token no encontrado.',
  },
  [AUTH_ERROR_TOKEN_EXPIRED]: {
    ENGLISH:
      "This link has expired. In order to register this account. you'll need to re-send a registration invite to your email address.",
    SPANISH:
      'Este enlace ha expirado. Para registrar esta cuenta, necesitarás reenviar una invitación de registro a tu dirección de correo electrónico.',
  },
  [AUTH_ERROR_TOKEN_EXPIRED_RESET]: {
    ENGLISH:
      "This link has expired. In order to reset password for this account, you'll need to re-send a reset password invite to your email address.",
    SPANISH:
      'Este enlace ha expirado. Para restablecer la contraseña de esta cuenta, necesitarás reenviar una invitación de restablecimiento de contraseña a tu dirección de correo electrónico.',
  },
  [AUTH_ERROR_INVALID_EMAIL]: {
    ENGLISH:
      "Our system does not recognize the information you've entered. If you're looking to register, please",
    SPANISH:
      'Nuestro sistema no reconoce la información que has ingresado. Si buscas registrarte, por favor',
  },
  [AUTH_ERROR_LOGIN_EXISTS]: {
    ENGLISH:
      'An account already exists for this email address. Please log in to the application from the login page.',
    SPANISH:
      'Ya existe una cuenta para esta dirección de correo electrónico. Por favor inicia sesión en la aplicación desde la página de inicio de sesión.',
  },
  [AUTH_ERROR_TOKEN_CLAIMED]: {
    ENGLISH: 'Sorry, this token is already claimed.',
    SPANISH: 'Lo siento, este token ya ha sido reclamado.',
  },
  [AUTH_ERROR_INVALID_CREDENTIALS]: {
    ENGLISH:
      'This email and password combination does not match our records. Please check them and try again.',
    SPANISH:
      'Esta combinación de correo electrónico y contraseña no coincide con nuestros registros. Por favor revísalos e intenta de nuevo.',
  },
  [AUTH_ERROR_LOGIN_COMPROMISED]: {
    ENGLISH:
      'The password you are attempting to use was found to be present in a 3rd party database of compromised passwords.',
    SPANISH:
      'Se encontró que la contraseña que intentas usar está presente en una base de datos de terceros de contraseñas comprometidas.',
  },
  [AUTH_ERROR_PERMISSION_DENIED]: {
    ENGLISH: "You don't have sufficient permissions.",
    SPANISH: 'No tienes permisos suficientes.',
  },
  [AUTH_ERROR_INTERNAL_ERROR]: {
    ENGLISH: 'An unknown error has occurred. Please try again.',
    SPANISH: 'Ha ocurrido un error desconocido. Por favor intenta de nuevo.',
  },
  [AUTH_ERROR_EMPLOYEE_SIGN_ERROR]: {
    ENGLISH: 'An error occurred while signing up the employee.',
    SPANISH: 'Ocurrió un error al registrar al empleado.',
  },
  [AUTH_ERROR_PWDRESET_INFO]: {
    ENGLISH:
      "If an active account exists for {email}, we'll send a password reset link to that address. If you don't receive it within 5 minutes, check your spam folder. If it still doesn't arrive, verify the email address or contact your employer.",
    SPANISH:
      'Si existe una cuenta activa para {email}, enviaremos un enlace para restablecer la contraseña a esa dirección. Si no lo recibes en 5 minutos, revisa tu carpeta de spam. Si aún no llega, verifica la dirección de correo electrónico o contacta a tu empleador.',
  },
  [AUTH_ERROR_INVALID_LOGIN_TYPE]: {
    ENGLISH: 'Invalid login type. Please try a different email.',
    SPANISH:
      'Tipo de inicio de sesión inválido. Por favor intenta con un correo electrónico diferente.',
  },
  [AUTH_ERROR_UNKNOWN_ERROR]: {
    ENGLISH: 'An unknown error has occurred. Please try again.',
    SPANISH: 'Ha ocurrido un error desconocido. Por favor intenta de nuevo.',
  },
  [AUTH_ERROR_SSO_EXISTS]: {
    ENGLISH:
      'An account already exists for this email address. Please log in to the application from the login page.',
    SPANISH:
      'Ya existe una cuenta para esta dirección de correo electrónico. Por favor inicia sesión en la aplicación desde la página de inicio de sesión.',
  },
  [AUTH_ERROR_EMPLOYEE_NOT_FOUND]: {
    ENGLISH:
      "Our system does not recognize the information you've entered. If you're looking to register, please",
    SPANISH:
      'Nuestro sistema no reconoce la información que has ingresado. Si buscas registrarte, por favor',
  },
  [AUTH_ERROR_INACTIVE_USER]: {
    ENGLISH:
      "If an active account exists for {email}, we'll send a password reset link to that address. If you don't receive it within 5 minutes, check your spam folder. If it still doesn't arrive, verify the email address or contact your employer.",
    SPANISH:
      'Si existe una cuenta activa para {email}, enviaremos un enlace para restablecer la contraseña a esa dirección. Si no lo recibes en 5 minutos, revisa tu carpeta de spam. Si aún no llega, verifica la dirección de correo electrónico o contacta a tu empleador.',
  },
  [AUTH_ERROR_PLAN_NOT_MATCHED]: {
    ENGLISH:
      'Your ID cards for this Plan Year may not be reflected in this microsite.',
    SPANISH:
      'Tus tarjetas de identificación para este Año del Plan pueden no estar reflejadas en esta guía de beneficios.',
  },
  [ADDITIONAL_RESOURCES]: {
    ENGLISH: 'Additional Resources',
    SPANISH: 'Recursos adicionales',
  },
  [ADD_ADDITIONAL_RESOURCES]: {
    ENGLISH: 'Add Additional Resources',
    SPANISH: 'Añadir recursos adicionales',
  },
  [VIEW_MORE]: {
    ENGLISH: 'View More',
    SPANISH: 'Ver más',
  },
  [FIRST_TELL_US_WHERE_YOU_RE_LOCATED]: {
    ENGLISH: "First, tell us where you're located",
    SPANISH: 'Primero, dinos dónde te encuentras',
  },
  [HOW_MANY_PEOPLE_DO_YOU_WANT_TO_COVER]: {
    ENGLISH: 'How many people do you want to cover?',
    SPANISH: '¿A cuántas personas quieres cubrir?',
  },
  [JUST_YOU_1]: {
    ENGLISH: 'Just You',
    SPANISH: 'Solo a ti',
  },
  [YOU_SPOUSE_PARTNER]: {
    ENGLISH: 'You + Spouse/ Partner *',
    SPANISH: 'Tú + Cónyuge/Pareja *',
  },
  [YOU_CHILD_REN_1]: {
    ENGLISH: 'You + Child(ren)',
    SPANISH: 'Tú + Hijo(s)',
  },
  [YOU_FAMILY_1]: {
    ENGLISH: 'You + Family',
    SPANISH: 'Tú + Familia',
  },
  [PARTNER_COVERAGE_IS_DEPENDENT_ON_THE_EMPLOYER]: {
    ENGLISH: '*Partner coverage is dependent on the employer',
    SPANISH: '*La cobertura para la pareja depende del empleador',
  },
  [ARE_YOU_PLANNING_ON_ANY_OF_THE_FOLLOWING_TEXT]: {
    ENGLISH:
      'Are you planning on any of the following procedures during this year?',
    SPANISH:
      '¿Estás planeando alguno de los siguientes procedimientos durante este año?',
  },
  [YOU_CAN_CHOOSE_MORE_THAN_ONE]: {
    ENGLISH: 'You can choose more than one',
    SPANISH: 'Puedes elegir más de uno',
  },
  [HAVING_A_BABY]: {
    ENGLISH: 'Having a baby',
    SPANISH: 'Tener un bebé',
  },
  [MAJOR_SURGERY_INPATIENT]: {
    ENGLISH: 'Major Surgery (Inpatient)',
    SPANISH: 'Cirugía mayor (paciente internado)',
  },
  [MINOR_SURGERY_OUTPATIENT]: {
    ENGLISH: 'Minor Surgery (Outpatient)',
    SPANISH: 'Cirugía menor (paciente ambulatorio)',
  },
  [NONE]: {
    ENGLISH: 'None',
    SPANISH: 'Ninguno',
  },
  [HOW_OFTEN_DO_YOU_GO_TO_YOUR_DOCTOR_TEXT]: {
    ENGLISH: 'How often do you go to your doctor or specialist?',
    SPANISH: '¿Con qué frecuencia vas al médico o al especialista?',
  },
  [IF_YOU_ARE_COVERING_YOUR_SPOUSE_OR_CHILD_REN_TEXT]: {
    ENGLISH:
      'If you are covering your spouse or child(ren), estimate your annual total visits for everyone covered',
    SPANISH:
      'Si cubres a tu cónyuge o hijo(s), estima el total de visitas anuales para todos los cubiertos',
  },
  [PRIMARY_DOCTOR_VISITS_PER_YEAR]: {
    ENGLISH: 'Primary Doctor Visits Per Year',
    SPANISH: 'Visitas al médico de cabecera por año',
  },
  [FREQUENTLY]: {
    ENGLISH: 'Frequently',
    SPANISH: 'Frecuentemente',
  },
  [SPECIALIST_VISITS_PER_YEAR]: {
    ENGLISH: 'Specialist Visits Per Year',
    SPANISH: 'Visitas al especialista por año',
  },
  [WHAT_S_YOUR_PREFERENCE_WHEN_CHOOSING_A_DOCTOR]: {
    ENGLISH: "What's your preference when choosing a doctor?",
    SPANISH: '¿Cuál es tu preferencia al elegir un médico?',
  },
  [I_USE_IN_NETWORK_PROVIDERS_ONLY]: {
    ENGLISH: 'I use in-network providers only',
    SPANISH: 'Solo uso proveedores dentro de la red',
  },
  [I_USE_OUT_OF_NETWORK_PROVIDERS_ALSO]: {
    ENGLISH: 'I use out-of-network providers also',
    SPANISH: 'También uso proveedores fuera de la red',
  },
  [IF_YOU_ARE_TAKING_ANY_RECURRING_PRESCRIPTIONS_WHAT_TEXT]: {
    ENGLISH:
      'If you are taking any recurring prescriptions, what price category would they fall under?',
    SPANISH:
      'Si tomas alguna receta recurrente, ¿en qué categoría de precio entrarían?',
  },
  [ENTER_THE_NUMBER_OF_PRESCRIPTIONS_YOU_TAKE_ANNUALLY_TEXT]: {
    ENGLISH:
      'Enter the number of prescriptions you take annually for each pricing tier below',
    SPANISH:
      'Introduce el número de recetas que tomas anualmente para cada nivel de precios a continuación',
  },
  [LOW_COST]: {
    ENGLISH: 'Low cost',
    SPANISH: 'Bajo costo',
  },
  [MEDIUM_COST]: {
    ENGLISH: 'Medium cost',
    SPANISH: 'Costo medio',
  },
  [HIGH_COST]: {
    ENGLISH: 'High Cost',
    SPANISH: 'Alto costo',
  },
  [SPECIALITY_COST]: {
    ENGLISH: 'Speciality Cost',
    SPANISH: 'Costo de especialidad',
  },
  [PER_YEAR_1]: {
    ENGLISH: 'Per year',
    SPANISH: 'Por año',
  },
  [SKIP_I_M_NOT_TAKING_ANY_PRESCRIPTIONS]: {
    ENGLISH: 'Skip, I’m not taking any prescriptions',
    SPANISH: 'Omitir, no estoy tomando ninguna receta',
  },
  [VIEW_MY_RECOMMENDATIONS]: {
    ENGLISH: 'View my Recommendations',
    SPANISH: 'Ver mis recomendaciones',
  },
  [MONTHLY_PREMIUM]: {
    ENGLISH: 'Monthly Premium',
    SPANISH: 'Prima mensual',
  },
  [PLAN_NETWORK_1]: {
    ENGLISH: 'Plan Network',
    SPANISH: 'Red del plan',
  },
  [DEDUCTIBLE]: {
    ENGLISH: 'Deductible',
    SPANISH: 'Deducible',
  },
  [OUT_OF_POCKET_MAX]: {
    ENGLISH: 'Out-of-Pocket-Max',
    SPANISH: 'Desembolso máximo',
  },
  [OFFICE_VISIT_1]: {
    ENGLISH: 'Office Visit',
    SPANISH: 'Consulta médica',
  },
  [SPECIALIST_VISIT_1]: {
    ENGLISH: 'Specialist Visit',
    SPANISH: 'Consulta con especialista',
  },
  [RETAIL_TIER_1_1]: {
    ENGLISH: 'Retail Tier 1',
    SPANISH: 'Farmacia Nivel 1',
  },
  [RETAIL_TIER_2_1]: {
    ENGLISH: 'Retail Tier 2',
    SPANISH: 'Farmacia Nivel 2',
  },
  [RETAIL_TIER_3_1]: {
    ENGLISH: 'Retail Tier 3',
    SPANISH: 'Farmacia Nivel 3',
  },
  [RETAIL_TIER_4_1]: {
    ENGLISH: 'Retail Tier 4',
    SPANISH: 'Farmacia Nivel 4',
  },
  [RETAIL_TIER_5]: {
    ENGLISH: 'Retail Tier 5',
    SPANISH: 'Farmacia Nivel 5',
  },
  [HSA_CONTRIBUTION]: {
    ENGLISH: 'HSA Contribution /',
    SPANISH: 'Contribución a HSA /',
  },
  [HRA_ALLOWANCE]: {
    ENGLISH: 'HRA Allowance',
    SPANISH: 'Asignación de HRA',
  },
  [EST_ANNUAL_COST]: {
    ENGLISH: 'Est. Annual Cost',
    SPANISH: 'Costo anual est.',
  },
  [EST_ANNUAL_COST_BREAKDOWN]: {
    ENGLISH: 'Est. Annual Cost Breakdown',
    SPANISH: 'Desglose del costo anual est.',
  },
  [ANNUAL_PREMIUM_COST]: {
    ENGLISH: 'Annual Premium Cost',
    SPANISH: 'Costo anual de la prima',
  },
  [ESTIMATED_MEDICAL_COST]: {
    ENGLISH: 'Estimated Medical Cost',
    SPANISH: 'Costo médico estimado',
  },
  [ESTIMATED_ANNUAL_COST]: {
    ENGLISH: 'Estimated Annual Cost',
    SPANISH: 'Costo anual estimado',
  },
  [WE_RECOMMEND_THE_PLAN_NAME_FOR_YOU]: {
    ENGLISH: 'We recommend the <plan name> for you',
    SPANISH: 'Te recomendamos el plan <nombre del plan>',
  },
  [THIS_IS_BASED_ON_COVERING_BENEFITS_FOR_YOU_TEXT]: {
    ENGLISH:
      'This is based on covering benefits for you and child(ren), planning a pregnancy or procedures, not visiting the doctor, using a narrow network, and not taking any prescription drugs.',
    SPANISH:
      'Esto se basa en la cobertura de beneficios para ti y tu(s) hijo(s), la planificación de un embarazo o procedimientos, no visitar al médico, usar una red limitada y no tomar medicamentos recetados.',
  },
  [WHICH_MEDICAL_PLAN_DO_YOU_HAVE]: {
    ENGLISH: 'Which Medical Plan Do You Have?',
    SPANISH: '¿Qué plan médico tienes?',
  },
  [MEDICAL]: {
    ENGLISH: 'Medical',
    SPANISH: 'Médico',
  },
  [WAIVED]: {
    ENGLISH: 'Waived',
    SPANISH: 'Renunciado',
  },
  [MEMBER_ID]: {
    ENGLISH: 'Member ID #',
    SPANISH: 'Member ID #',
  },
  [WHICH_DENTAL_PLAN_DO_YOU_HAVE]: {
    ENGLISH: 'Which Dental Plan Do You Have?',
    SPANISH: '¿Qué plan dental tienes?',
  },
  [DENTAL]: {
    ENGLISH: 'Dental',
    SPANISH: 'Dental',
  },
  [THE_MEMBER_ID_CAN_BE_FOUND_AFTER_TEXT]: {
    ENGLISH:
      "The Member ID # can be found after registering for your carrier's website or by referencing your physical ID card. Your provider's office will typically need this number before you receive services to confirm your coverage.",
    SPANISH:
      'El n.º de identificación de miembro se puede encontrar después de registrarse en el sitio web de su aseguradora o consultando su tarjeta de identificación física. El consultorio de su proveedor generalmente necesitará este número antes de que reciba servicios para confirmar su cobertura.',
  },
  [YOUR_EMPLOYER_DOESN_T_OFFER_PLANS_FOR_THIS_BENEFIT_TEXT]: {
    ENGLISH: 'Your employer doesn’t offer plans for this benefit type.',
    SPANISH: 'Tu empleador no ofrece planes para este tipo de beneficio.',
  },
  [WHICH_VISION_PLAN_DO_YOU_HAVE]: {
    ENGLISH: 'Which Vision Plan Do You Have?',
    SPANISH: '¿Qué plan de visión tienes?',
  },

  [YOUR_MEDICAL_ID_CARD]: {
    ENGLISH: 'Your Medical ID card',
    SPANISH: 'Tu tarjeta de identificación médica',
  },
  [VIEWING]: {
    ENGLISH: 'Viewing',
    SPANISH: 'Viendo',
  },
  [PLAN_MEMBERS]: {
    ENGLISH: 'Plan Members',
    SPANISH: 'Miembros del plan',
  },
  [EFFECTIVE_DATE]: {
    ENGLISH: 'Effective Date',
    SPANISH: 'Fecha de vigencia',
  },
  [NAME]: {
    ENGLISH: 'Name',
    SPANISH: 'Nombre',
  },
  [PRIMARY_SUBSCRIBER]: {
    ENGLISH: 'Primary Subscriber',
    SPANISH: 'Abonado principal',
  },
  [GROUP_ID]: {
    ENGLISH: 'Group ID',
    SPANISH: 'ID de grupo',
  },
  [PHONE]: {
    ENGLISH: 'Phone',
    SPANISH: 'Teléfono',
  },
  [ACTIONS]: {
    ENGLISH: 'Actions',
    SPANISH: 'Acciones',
  },
  [PRINT_ID]: {
    ENGLISH: 'Print ID',
    SPANISH: 'Imprimir identificación',
  },
  [SHOW_BACK_OF_ID_CARD]: {
    ENGLISH: 'Show back of ID card',
    SPANISH: 'Mostrar reverso de la tarjeta de identificación',
  },
  [UPDATE_MY_PLANS]: {
    ENGLISH: 'Update My Plans',
    SPANISH: 'Actualizar mis planes',
  },
  [LOG_OUT]: {
    ENGLISH: 'Log Out',
    SPANISH: 'Cerrar sesión',
  },
  [DENTAL_BENEFITS_ARE_NOT_BEEN_OFFERED_CURRENTLY]: {
    ENGLISH: 'Dental Benefits are not been offered currently',
    SPANISH: 'Los beneficios dentales no se ofrecen actualmente.',
  },
  [MEMBERS_AND_PROVIDERS]: {
    ENGLISH: 'MEMBERS AND PROVIDERS',
    SPANISH: 'MIEMBROS Y PROVEEDORES',
  },
  [NETWORK_PROVIDERS_MUST_CALL_TO_REQUEST_PRIOR_APPROVAL_TEXT]: {
    ENGLISH:
      'Network providers must call to request prior approval and confirm eligibility',
    SPANISH:
      'Los proveedores de la red deben llamar para solicitar autorización previa y confirmar la elegibilidad',
  },
  [CARRIER_PHONE]: {
    ENGLISH: 'Carrier Phone #:',
    SPANISH: 'N.º de teléfono de la aseguradora:',
  },
  [VISION_BENEFITS_ARE_NOT_BEEN_OFFERED_CURRENTLY]: {
    ENGLISH: 'Vision Benefits are not been offered currently',
    SPANISH: 'Los beneficios de visión no se ofrecen actualmente.',
  },
  [YOUR_WAIVER_CREDIT]: {
    ENGLISH: 'Your waiver credit:',
    SPANISH: 'Su crédito de exención',
  },
  [PER_PAY_PERIOD]: {
    ENGLISH: 'per pay period',
    SPANISH: 'por período de pago',
  },
  [PER_MONTH]: {
    ENGLISH: 'per month',
    SPANISH: 'por mes',
  },
  [PER_QUARTER]: {
    ENGLISH: 'per quarter',
    SPANISH: 'por trimestre',
  },
  [PER_YEAR_2]: {
    ENGLISH: 'per year',
    SPANISH: 'por año',
  },
  [COMPARE_NOW]: {
    ENGLISH: 'Compare Now',
    SPANISH: 'Comparar ahora',
  },
  [CLEAR_COMPARISON]: {
    ENGLISH: 'Clear Comparison',
    SPANISH: 'Limpiar comparación',
  },
  [RETAIL_TIER_6]: {
    ENGLISH: 'Retail Tier 6',
    SPANISH: 'Farmacia Nivel 6',
  },
  [RETAIL_TIER_7]: {
    ENGLISH: 'Retail Tier 7',
    SPANISH: 'Farmacia Nivel 7',
  },
  [RETAIL_TIER_8]: {
    ENGLISH: 'Retail Tier 8',
    SPANISH: 'Farmacia Nivel 8',
  },
  [MAIL_ORDER_TIER_5]: {
    ENGLISH: 'Mail Order Tier 5',
    SPANISH: 'Pedido por correo Nivel 5',
  },
  [MAIL_ORDER_TIER_6]: {
    ENGLISH: 'Mail Order Tier 6',
    SPANISH: 'Pedido por correo Nivel 6',
  },
  [MAIL_ORDER_TIER_7]: {
    ENGLISH: 'Mail Order Tier 7',
    SPANISH: 'Pedido por correo Nivel 7',
  },
  [MAIL_ORDER_TIER_8]: {
    ENGLISH: 'Mail Order Tier 8',
    SPANISH: 'Pedido por correo Nivel 8',
  },
  [DEDUCTIBLES_OOP_MAXIMUM]: {
    ENGLISH: 'DEDUCTIBLES & OOP MAXIMUM',
    SPANISH: 'DEDUCIBLES Y MÁXIMO DE GASTOS DE BOLSILLO',
  },
  [DEDUCTIBLES_BENEFIT_MAXIMUMS]: {
    ENGLISH: 'DEDUCTIBLES & BENEFIT MAXIMUMS',
    SPANISH: 'DEDUCIBLES Y MÁXIMOS DE BENEFICIOS',
  },
  [MAX_YEARLY_CONTRIBUTION_INDIVIDUAL]: {
    ENGLISH: 'Max Yearly Contribution (Individual)',
    SPANISH: 'Contribución Anual Máxima (Individual)',
  },
  [MAX_YEARLY_CONTRIBUTION_FAMILY]: {
    ENGLISH: 'Max Yearly Contribution (Family)',
    SPANISH: 'Contribución Anual Máxima (Familia)',
  },
  [EMPLOYER_CONTRIBUTIONS_PER_MONTH]: {
    ENGLISH: 'Employer Contributions per Month',
    SPANISH: 'Contribuciones del Empleador por Mes',
  },
  [MAX_MONTHLY_CONTRIBUTION]: {
    ENGLISH: 'Max Monthly Contribution',
    SPANISH: 'Contribución Mensual Máxima',
  },
  [YOU_1]: {
    ENGLISH: 'You + 1',
    SPANISH: 'Usted + 1',
  },
  [YOU_2]: {
    ENGLISH: 'You + 2',
    SPANISH: 'Usted + 2',
  },
  [YOU_3]: {
    ENGLISH: 'You + 3',
    SPANISH: 'Usted + 3',
  },
  [YOU_4]: {
    ENGLISH: 'You + 4',
    SPANISH: 'Usted + 4',
  },
  [YOU_5]: {
    ENGLISH: 'You + 5',
    SPANISH: 'Usted + 5',
  },
  [YOU_6]: {
    ENGLISH: 'You + 6',
    SPANISH: 'Usted + 6',
  },
  [YOU_7]: {
    ENGLISH: 'You + 7',
    SPANISH: 'Usted + 7',
  },
  [YOU_8]: {
    ENGLISH: 'You + 8',
    SPANISH: 'Usted + 8',
  },
  [EMAIL_ADDRESS]: {
    ENGLISH: 'Email Address',
    SPANISH: 'Dirección de correo electrónico',
  },
  [PASSWORD]: {
    ENGLISH: 'Password',
    SPANISH: 'Contraseña',
  },
  [PLEASE_ENTER_YOUR_EMAIL]: {
    ENGLISH: 'Please enter your email',
    SPANISH: 'Por favor ingrese su correo electrónico',
  },
  [PLEASE_ENTER_YOUR_PASSWORD]: {
    ENGLISH: 'Please enter your password',
    SPANISH: 'Por favor ingrese su contraseña',
  },
  [LOG_IN]: {
    ENGLISH: 'Log In',
    SPANISH: 'Iniciar sesión',
  },
  [CONTINUE]: {
    ENGLISH: 'Continue',
    SPANISH: 'Continuar',
  },
  // AUTH_VIEW translations
  [AUTH_LOG_IN]: {
    ENGLISH: 'Log in',
    SPANISH: 'Iniciar sesión',
  },
  [AUTH_RESET_PASSWORD]: {
    ENGLISH: 'Reset Password',
    SPANISH: 'Restablecer contraseña',
  },
  [AUTH_REGISTER]: {
    ENGLISH: 'Register',
    SPANISH: 'Registrarse',
  },
  [AUTH_CHECK_YOUR_EMAIL]: {
    ENGLISH: 'Check Your Email',
    SPANISH: 'Revisa tu correo electrónico',
  },
  [AUTH_TROUBLE_LOGGING_IN]: {
    ENGLISH: 'Trouble Logging In ?',
    SPANISH: '¿Problemas para iniciar sesión?',
  },
  [AUTH_REGISTRATION_SUCCESS]: {
    ENGLISH: 'Registration Success',
    SPANISH: 'Registro exitoso',
  },
  [AUTH_TERMS_AND_CONDITIONS]: {
    ENGLISH: 'Terms and Conditions',
    SPANISH: 'Términos y condiciones',
  },
  // PLAN_VIEW translations
  [PLAN_YOUR_BENEFITS_AT_A_GLANCE]: {
    ENGLISH: 'Your Benefits at a Glance',
    SPANISH: 'Sus beneficios de un vistazo',
  },
  [PLAN_YOUR_BENEFITS_ARE_ON_THE_WAY]: {
    ENGLISH: 'Your Benefits are on the way!',
    SPANISH: '¡Sus beneficios están en camino!',
  },
  [PLAN_NEXT_YOULL_ENTER_AND_STORE]: {
    ENGLISH:
      "Next, you'll enter and store your benefits ID card information to quickly access it here.",
    SPANISH:
      'A continuación, ingresará y almacenará la información de su tarjeta de identificación de beneficios para acceder rápidamente aquí.',
  },
  [PLAN_YOUR_BENEFITS_TEAM_IS_WORKING]: {
    ENGLISH:
      'Your benefits team is working hard to bring your benefits to your Microsite. Please check back soon.',
    SPANISH:
      'Su equipo de beneficios está trabajando arduamente para traer sus beneficios a DBG. Por favor, vuelva pronto.',
  },
  [PLAN_WHICH_MEDICAL_PLAN_DO_YOU_HAVE]: {
    ENGLISH: 'Which Medical Plan Do You Have?',
    SPANISH: '¿Qué plan médico tiene?',
  },
  [PLAN_MEDICAL]: {
    ENGLISH: 'Medical',
    SPANISH: 'Médico',
  },
  [PLAN_YOUR_MEDICAL_ID_CARD]: {
    ENGLISH: 'Your Medical ID Card',
    SPANISH: 'Su tarjeta de identificación médica',
  },
  [PLAN_WHICH_DENTAL_PLAN_DO_YOU_HAVE]: {
    ENGLISH: 'Which Dental Plan Do You Have?',
    SPANISH: '¿Qué plan dental tiene?',
  },
  [PLAN_DENTAL]: {
    ENGLISH: 'Dental',
    SPANISH: 'Dental',
  },
  [PLAN_YOUR_DENTAL_ID_CARD]: {
    ENGLISH: 'Your Dental ID Card',
    SPANISH: 'Su tarjeta de identificación dental',
  },
  [PLAN_WHICH_VISION_PLAN_DO_YOU_HAVE]: {
    ENGLISH: 'Which Vision Plan Do You Have?',
    SPANISH: '¿Qué plan de visión tiene?',
  },
  [PLAN_VISION]: {
    ENGLISH: 'Vision',
    SPANISH: 'Visión',
  },
  [PLAN_YOUR_VISION_ID_CARD]: {
    ENGLISH: 'Your Vision ID Card',
    SPANISH: 'Su tarjeta de identificación de visión',
  },
  [PLAN_ID_CARD]: {
    ENGLISH: 'ID CARD',
    SPANISH: 'TARJETA DE IDENTIFICACIÓN',
  },
  // Register component translations
  [IMPORTANT_REGISTER_WITH_PRIMARY_EMAIL]: {
    ENGLISH: 'IMPORTANT: Register with your primary email address',
    SPANISH:
      'IMPORTANTE: Regístrese con su dirección de correo electrónico principal',
  },
  [WORK_EMAIL_ADDRESS]: {
    ENGLISH: 'Work Email Address',
    SPANISH: 'Dirección de correo electrónico del trabajo',
  },
  [REGISTERING_AS_EMPLOYER_ADMIN]: {
    ENGLISH:
      'You are registering as an employer admin. You will be able to login to unified portal with these same credentials',
    SPANISH:
      'Se está registrando como administrador del empleador. Podrá iniciar sesión en el portal unificado con estas mismas credenciales',
  },
  [INVALID_EMAIL_FORMAT]: {
    ENGLISH: 'Invalid email format',
    SPANISH: 'Formato de correo electrónico inválido',
  },
  [PLEASE_ENTER_YOUR_WORK_EMAIL]: {
    ENGLISH: 'Please enter your work email',
    SPANISH: 'Por favor ingrese su correo electrónico de trabajo',
  },
  [EMPLOYERS_WEBSITE]: {
    ENGLISH: "Employer's Website",
    SPANISH: 'Sitio web del empleador',
  },
  [PLEASE_ENTER_EMPLOYERS_DOMAIN]: {
    ENGLISH: 'Please enter a employers domain',
    SPANISH: 'Por favor ingrese el dominio del empleador',
  },
  [PLEASE_INCLUDE_VALID_WEBSITE_EXTENSION]: {
    ENGLISH:
      'Please include a valid website extension (Example: .com, .net, .org)',
    SPANISH:
      'Por favor incluya una extensión de sitio web válida (Ejemplo: .com, .net, .org)',
  },
  [HTTPS_WWW]: {
    ENGLISH: 'https://www.',
    SPANISH: 'https://www.',
  },
  [PASTE_CODE_FROM_PLANYEAR_EMAIL]: {
    ENGLISH: 'Paste your code from the PlanYear registration email below',
    SPANISH:
      'Pegue su código del correo electrónico de registro de PlanYear a continuación',
  },
  [CODE]: {
    ENGLISH: 'Code',
    SPANISH: 'Código',
  },
  [PLEASE_ENTER_VERIFICATION_CODE]: {
    ENGLISH: 'Please enter a verification code',
    SPANISH: 'Por favor ingrese un código de verificación',
  },
  [FIRST_NAME]: {
    ENGLISH: 'First Name',
    SPANISH: 'Nombre',
  },
  [LAST_NAME]: {
    ENGLISH: 'Last Name',
    SPANISH: 'Apellido',
  },
  [PLEASE_ENTER_CONFIRMATION_PASSWORD]: {
    ENGLISH: 'Please enter confirmation password',
    SPANISH: 'Por favor ingrese la contraseña de confirmación',
  },
  [PASSWORDS_DO_NOT_MATCH]: {
    ENGLISH: 'Passwords do not match',
    SPANISH: 'Las contraseñas no coinciden',
  },
  [REGISTER_ACCOUNT]: {
    ENGLISH: 'Register Account',
    SPANISH: 'Registrar cuenta',
  },
  [NEXT]: {
    ENGLISH: 'Next',
    SPANISH: 'Siguiente',
  },
  [BACK]: {
    ENGLISH: 'Back',
    SPANISH: 'Atrás',
  },
  [CANCEL]: {
    ENGLISH: 'Cancel',
    SPANISH: 'Cancelar',
  },
  [CREATE_PASSWORD]: {
    ENGLISH: 'Create Password',
    SPANISH: 'Crear contraseña',
  },
  [CONFIRM_PASSWORD]: {
    ENGLISH: 'Confirm Password',
    SPANISH: 'Confirmar contraseña',
  },
  [PASSWORD_REQUIREMENTS_MESSAGE]: {
    ENGLISH:
      'Please choose a different password with 8 or more characters, upper & lower case letters, and a special character.',
    SPANISH:
      'Por favor elija una contraseña diferente con 8 o más caracteres, letras mayúsculas y minúsculas, y un carácter especial.',
  },
  // Auth components translations
  [NEW_PASSWORD]: {
    ENGLISH: 'New Password',
    SPANISH: 'Nueva contraseña',
  },
  [PLEASE_ENTER_YOUR_NEW_PASSWORD]: {
    ENGLISH: 'Please enter your new password',
    SPANISH: 'Por favor ingrese su nueva contraseña',
  },
  [SAVE]: {
    ENGLISH: 'Save',
    SPANISH: 'Guardar',
  },
  [YOUR_ACCOUNT_EMAIL_ADDRESS]: {
    ENGLISH: 'Your Account Email Address',
    SPANISH: 'Su dirección de correo electrónico de cuenta',
  },
  [REQUEST_NEW_PASSWORD]: {
    ENGLISH: 'Request New Password',
    SPANISH: 'Solicitar nueva contraseña',
  },
  [PRIMARY_SUBSCRIBERS_MESSAGE]: {
    ENGLISH:
      'For primary subscribers, please use your work email address to log in or register for an account.',
    SPANISH:
      'Para suscriptores principales, por favor use su dirección de correo electrónico de trabajo para iniciar sesión o registrar una cuenta.',
  },
  [FOR_ADDITIONAL_QUESTIONS]: {
    ENGLISH: 'For additional questions, please contact',
    SPANISH: 'Para preguntas adicionales, por favor contacte',
  },
  [SUPPORT_EMAIL]: {
    ENGLISH: 'support@planyear.com',
    SPANISH: 'support@planyear.com',
  },
  [UNIFIED_PORTAL_CREDENTIALS_MESSAGE]: {
    ENGLISH:
      'You can now use your unified portal credentials to login to the app',
    SPANISH:
      'Ahora puede usar sus credenciales del portal unificado para iniciar sesión en la aplicación',
  },
  [CHECK_EMAIL_INBOX_MESSAGE]: {
    ENGLISH:
      'Please check your email inbox for a registration link to create an account.',
    SPANISH:
      'Por favor revise su bandeja de entrada de correo electrónico para un enlace de registro para crear una cuenta.',
  },
  [PLEASE_ENTER_YOUR_FIRST_NAME]: {
    ENGLISH: 'Please enter your first name',
    SPANISH: 'Por favor ingrese su nombre',
  },
  [PLEASE_ENTER_YOUR_LAST_NAME]: {
    ENGLISH: 'Please enter your last name',
    SPANISH: 'Por favor ingrese su apellido',
  },
  [GET_STARTED]: {
    ENGLISH: 'Get Started',
    SPANISH: 'Comenzar',
  },
  // IDCard component translations
  [YOU_HAVE_WAIVED_PLANS_FOR_THIS_BENEFIT]: {
    ENGLISH: 'You have waived plans for this benefit',
    SPANISH: 'Ha renunciado a los planes para este beneficio',
  },
  [BENEFITS_ARE_NOT_OFFERED_CURRENTLY]: {
    ENGLISH: 'Benefits are not been offered currently',
    SPANISH: 'Los beneficios no se ofrecen actualmente',
  },
  [ID_CARD_NAME]: {
    ENGLISH: 'Name',
    SPANISH: 'Nombre',
  },
  [ID_CARD_PRIMARY_SUBSCRIBER]: {
    ENGLISH: 'Primary Subscriber',
    SPANISH: 'Suscriptor principal',
  },
  [ID_CARD_GROUP_ID]: {
    ENGLISH: 'Group ID #',
    SPANISH: 'Grupo #',
  },
  [ID_CARD_DOB]: {
    ENGLISH: 'DOB',
    SPANISH: 'Fecha de nacimiento',
  },
  [ID_CARD_EFFECTIVE_DATE]: {
    ENGLISH: 'Effective Date',
    SPANISH: 'Fecha efectiva',
  },
  [RX_BIN]: {
    ENGLISH: 'Rx Bin #',
    SPANISH: 'Rx Bin #',
  },
  [RX_PCN]: {
    ENGLISH: 'Rx PCN #',
    SPANISH: 'Rx PCN #',
  },
  [RX_GROUP]: {
    ENGLISH: 'Rx Group #',
    SPANISH: 'Rx Grupo #',
  },
  [ID_CARD_MEMBERS_AND_PROVIDERS]: {
    ENGLISH: 'MEMBERS AND PROVIDERS',
    SPANISH: 'MIEMBROS Y PROVEEDORES',
  },
  [NETWORK_PROVIDERS_MUST_CALL]: {
    ENGLISH:
      'Network providers must call to request prior approval and confirm eligibility',
    SPANISH:
      'Los proveedores de la red deben llamar para solicitar aprobación previa y confirmar elegibilidad',
  },
  [ID_CARD_CARRIER_PHONE]: {
    ENGLISH: 'Carrier Phone #',
    SPANISH: 'Teléfono del operador #',
  },
  [ADD_ID]: {
    ENGLISH: 'Add ID',
    SPANISH: 'Añadir',
  },
  [ID_CARD_PHONE]: {
    ENGLISH: 'Phone',
    SPANISH: 'Teléfono',
  },
  [ID_CARD_RX_BIN]: {
    ENGLISH: 'Rx Bin #',
    SPANISH: 'Rx Bin #',
  },
  [ID_CARD_RX_PCN]: {
    ENGLISH: 'Rx PCN #',
    SPANISH: 'Rx PCN #',
  },
  [ID_CARD_RX_GROUP]: {
    ENGLISH: 'Rx Group #',
    SPANISH: 'Rx Grupo #',
  },
  [HAVE_CODE]: {
    ENGLISH: 'Have Code?',
    SPANISH: '¿Tienes código?',
  },
  [CURRENT]: {
    ENGLISH: '(Current)',
    SPANISH: '(Actual)',
  },
  [SUBSCRIBER]: {
    ENGLISH: 'Subscriber',
    SPANISH: 'Titular',
  },
  [SHOW_FRONT_OF_ID_CARD]: {
    ENGLISH: 'Show Front of ID Card',
    SPANISH: 'Mostrar Frente de la Tarjeta de ID',
  },
  [INFO]: {
    ENGLISH: 'Info',
    SPANISH: 'Info',
  },
  [FREQUENCIES_TEXT]: {
    ENGLISH: 'FREQUENCIES',
    SPANISH: 'FRECUENCIAS',
  },
  [SERVICES_TEXT]: {
    ENGLISH: 'SERVICES',
    SPANISH: 'SERVICIOS',
  },
  [COMPARE]: {
    ENGLISH: 'Compare',
    SPANISH: 'Comparar',
  },
  [COVERAGE_JUST_YOU]: {
    ENGLISH: 'Covers just you',
    SPANISH: 'Te cubre solo a ti',
  },
  [COVERAGE_YOU_SPOUSE]: {
    ENGLISH: 'Covers you + spouse',
    SPANISH: 'Te cubre a ti + cónyuge',
  },
  [COVERAGE_YOU_CHILDREN]: {
    ENGLISH: 'Covers you + child(ren)',
    SPANISH: 'Te cubre a ti + hijo(s)',
  },
  [COVERAGE_YOU_FAMILY]: {
    ENGLISH: 'Covers you + family',
    SPANISH: 'Te cubre a ti + familia',
  },
  [COVERAGE_YOU_SPOUSE_OR_CHILDREN]: {
    ENGLISH: 'Covers you + spouse / you + child(ren)',
    SPANISH: 'Te cubre a ti + cónyuge / ti + hijo(s)',
  },
  [FILTER_OPTIONS_TEXT]: {
    ENGLISH: 'Filters Options',
    SPANISH: 'Filtros',
  },
  [PLAN_RECOMMENDER]: {
    ENGLISH: 'Plan Recommender',
    SPANISH: 'Recomendador de Planes',
  },
  [STEP]: {
    ENGLISH: 'Step',
    SPANISH: 'Paso',
  },
  [QUESTIONS]: {
    ENGLISH: 'Questions',
    SPANISH: 'Preguntas',
  },
  [YOUR_RECOMMENDATION]: {
    ENGLISH: 'Your Recommendation',
    SPANISH: 'Tu Recomendación',
  },
  [FREQUENCY_MONTHLY]: {
    ENGLISH: 'Monthly',
    SPANISH: 'Mensual',
  },
  [FREQUENCY_SEMI_MONTHLY]: {
    ENGLISH: 'Semi-Monthly',
    SPANISH: 'Quincenal',
  },
  [FREQUENCY_WEEKLY]: {
    ENGLISH: 'Weekly',
    SPANISH: 'Semanal',
  },
  [FREQUENCY_BI_WEEKLY]: {
    ENGLISH: 'Bi-Weekly',
    SPANISH: 'Bisemanal',
  },
  [FREQUENCY_QUARTERLY]: {
    ENGLISH: 'Quarter',
    SPANISH: 'Trimestre',
  },
  [FREQUENCY_ANNUALLY]: {
    ENGLISH: 'Year',
    SPANISH: 'Año',
  },
  [YOUR_COST]: {
    ENGLISH: 'Your',
    SPANISH: 'Tu',
  },
  [COST]: {
    ENGLISH: 'Cost',
    SPANISH: 'Costo',
  },
  [EDIT_TIER_NAMES]: {
    ENGLISH: 'Edit Tier Names',
    SPANISH: 'Editar Nombres de Niveles',
  },
  [BENEFITS_CONSULTATION]: {
    ENGLISH: 'Benefits Consultation',
    SPANISH: 'Consulta de Beneficios',
  },
  [PLAN_RECOMMENDER_TITLE]: {
    ENGLISH: 'Your Go-To Plan Recommender Assistant',
    SPANISH: 'Tu Asistente Recomendador de Planes',
  },
  [PLAN_RECOMMENDER_SUBTITLE]: {
    ENGLISH:
      'Picking benefits can be tricky. Try out the plan recommender to see which plans are best suited for you.',
    SPANISH:
      'Elegir beneficios puede ser complicado. Prueba el recomendador de planes para ver cuáles son los mejores para ti.',
  },
  [PLAN_RECOMMENDER_SUBTITLE_2]: {
    ENGLISH: "Just answer a few questions, and we'll do the rest.",
    SPANISH: 'Solo responde unas pocas preguntas y nosotros haremos el resto.',
  },
  // Plan Recommender Question Translations
  [PR_LOCATION_TITLE]: {
    ENGLISH: "First, tell us where you're located",
    SPANISH: 'Primero, dinos dónde te encuentras',
  },
  [PR_COVERAGE_TITLE]: {
    ENGLISH: 'How many people do you want to cover?',
    SPANISH: '¿A cuántas personas quieres cubrir?',
  },
  [PR_COVERAGE_FOOTER]: {
    ENGLISH: '*Partner coverage is dependent on the employer',
    SPANISH: '*La cobertura de pareja depende del empleador',
  },
  [PR_PROCEDURES_TITLE]: {
    ENGLISH:
      'Are you planning on any of the following procedures during this year?',
    SPANISH:
      '¿Planeas alguno de los siguientes procedimientos durante este año?',
  },
  [PR_PROCEDURES_SUBTITLE]: {
    ENGLISH: 'You can choose more than one',
    SPANISH: 'Puedes elegir más de uno',
  },
  [PR_DOCTOR_VISITS_TITLE]: {
    ENGLISH: 'How often do you go to your doctor or specialist?',
    SPANISH: '¿Con qué frecuencia vas al médico o especialista?',
  },
  [PR_DOCTOR_VISITS_SUBTITLE]: {
    ENGLISH:
      'If you are covering your spouse or child(ren), estimate your annual total visits for everyone covered',
    SPANISH:
      'Si cubres a tu cónyuge o hijos, estima el total anual de visitas para todos los cubiertos',
  },
  [PR_DOCTOR_PREFERENCE_TITLE]: {
    ENGLISH: "What's your preference when choosing a doctor?",
    SPANISH: '¿Cuál es tu preferencia al elegir un médico?',
  },
  [PR_PRESCRIPTIONS_TITLE]: {
    ENGLISH:
      'If you are taking any recurring prescriptions, what price category would they fall under?',
    SPANISH:
      'Si tomas medicamentos recurrentes, ¿en qué categoría de precio estarían?',
  },
  [PR_PRESCRIPTIONS_SUBTITLE]: {
    ENGLISH:
      'Enter the number of prescriptions you take annually for each pricing tier below',
    SPANISH:
      'Ingresa el número de medicamentos que tomas anualmente para cada nivel de precio',
  },
  // Plan Recommender Option Translations
  [PR_JUST_YOU]: {
    ENGLISH: 'Just You',
    SPANISH: 'Solo Tú',
  },
  [PR_YOU_SPOUSE_PARTNER]: {
    ENGLISH: 'You + Spouse / Partner*',
    SPANISH: 'Tú + Cónyuge / Pareja*',
  },
  [PR_YOU_CHILDREN]: {
    ENGLISH: 'You + Child(ren)',
    SPANISH: 'Tú + Hijos',
  },
  [PR_YOU_FAMILY]: {
    ENGLISH: 'You + Family',
    SPANISH: 'Tú + Familia',
  },
  [PR_PREGNANCY]: {
    ENGLISH: 'Pregnancy',
    SPANISH: 'Embarazo',
  },
  [PR_MAJOR_SURGERY]: {
    ENGLISH: 'Major Surgery (Inpatient)',
    SPANISH: 'Cirugía Mayor (Hospitalización)',
  },
  [PR_MINOR_SURGERY]: {
    ENGLISH: 'Minor Surgery (Outpatient)',
    SPANISH: 'Cirugía Menor (Ambulatoria)',
  },
  [PR_NONE]: {
    ENGLISH: 'None',
    SPANISH: 'Ninguno',
  },
  [PR_IN_NETWORK_ONLY]: {
    ENGLISH: 'I use in-network providers only',
    SPANISH: 'Solo uso proveedores dentro de la red',
  },
  [PR_OUT_NETWORK_ALSO]: {
    ENGLISH: 'I use out-of-network providers also',
    SPANISH: 'También uso proveedores fuera de la red',
  },
  [PR_LOWER_COST]: {
    ENGLISH: 'lower cost',
    SPANISH: 'menor costo',
  },
  [PR_DOCTORS_TO_CHOOSE]: {
    ENGLISH: 'doctors to choose from',
    SPANISH: 'médicos para elegir',
  },
  // Plan Recommender Slider Translations
  [PR_PRIMARY_DOCTOR_VISITS]: {
    ENGLISH: 'Primary doctor visits per year',
    SPANISH: 'Visitas al médico primario por año',
  },
  [PR_PRIMARY_DOCTOR_INFO]: {
    ENGLISH:
      "Primary doctors are doctors who have been trained to be a patient's first point of entry into the health care system.",
    SPANISH:
      'Los médicos primarios son médicos entrenados para ser el primer punto de entrada del paciente al sistema de salud.',
  },
  [PR_SPECIALIST_VISITS]: {
    ENGLISH: 'Specialist visits per year',
    SPANISH: 'Visitas a especialistas por año',
  },
  [PR_SPECIALIST_INFO]: {
    ENGLISH:
      'Specialty doctors have training in a specific area of medicine. This allows them to treat complex health problems that primary care doctors may not be able to.',
    SPANISH:
      'Los médicos especialistas tienen entrenamiento en un área específica de medicina. Esto les permite tratar problemas de salud complejos que los médicos de atención primaria pueden no poder tratar.',
  },
  [PR_NONE_LABEL]: {
    ENGLISH: 'None',
    SPANISH: 'Ninguno',
  },
  [PR_FREQUENTLY_LABEL]: {
    ENGLISH: 'Frequently',
    SPANISH: 'Frecuentemente',
  },
  // Plan Recommender Prescription Translations
  [PR_LOW_COST]: {
    ENGLISH: 'Low Cost',
    SPANISH: 'Costo Bajo',
  },
  [PR_LOW_COST_SUBTITLE]: {
    ENGLISH: '(~$20/Rx)',
    SPANISH: '(~$20/Rx)',
  },
  [PR_MEDIUM_COST]: {
    ENGLISH: 'Medium Cost',
    SPANISH: 'Costo Medio',
  },
  [PR_MEDIUM_COST_SUBTITLE]: {
    ENGLISH: '(~$35/Rx)',
    SPANISH: '(~$35/Rx)',
  },
  [PR_HIGH_COST]: {
    ENGLISH: 'High Cost',
    SPANISH: 'Costo Alto',
  },
  [PR_HIGH_COST_SUBTITLE]: {
    ENGLISH: '(~$50/Rx)',
    SPANISH: '(~$50/Rx)',
  },
  [PR_SPECIALTY_COST]: {
    ENGLISH: 'Specialty Cost',
    SPANISH: 'Costo Especializado',
  },
  [PR_SPECIALTY_COST_SUBTITLE]: {
    ENGLISH: '(30% up to $250)',
    SPANISH: '(30% hasta $250)',
  },
  // Plan Recommender Button and UI Text Translations

  [PR_PER_YEAR]: {
    ENGLISH: 'Per Year',
    SPANISH: 'Por Año',
  },
  [PR_SKIP_PRESCRIPTIONS]: {
    ENGLISH: "Skip, I'm not taking any prescriptions",
    SPANISH: 'Omitir, no tomo ningún medicamento',
  },
  [PR_VIEW_RECOMMENDATIONS]: {
    ENGLISH: 'View My Recommendations',
    SPANISH: 'Ver Mis Recomendaciones',
  },
  [PR_EDIT_YOUR_ANSWERS]: {
    ENGLISH: 'Edit Your Answers',
    SPANISH: 'Editar Tus Respuestas',
  },
  [PR_UPDATE]: {
    ENGLISH: 'Update',
    SPANISH: 'Actualizar',
  },
  [PR_BASED_ON_COVERING_BENEFITS]: {
    ENGLISH: 'This is based on covering benefits for',
    SPANISH: 'Esto se basa en cubrir beneficios para',
  },
  [PR_EDIT_RESPONSES]: {
    ENGLISH: 'Edit Responses',
    SPANISH: 'Editar Respuestas',
  },
  [PR_MORE_PLANS]: {
    ENGLISH: 'more plans',
    SPANISH: 'más planes',
  },
  [PR_DOWNLOAD_RESULTS]: {
    ENGLISH: 'Download Results',
    SPANISH: 'Descargar Resultados',
  },
  [PR_RECOMMENDED_PLAN]: {
    ENGLISH: 'Recommended Plan',
    SPANISH: 'Plan Recomendado',
  },
  [PR_RECOMMENDED_PLANS]: {
    ENGLISH: 'Recommended Plans',
    SPANISH: 'Planes Recomendados',
  },
  [PR_COVERAGE_JUST_YOU]: {
    ENGLISH: 'just you,',
    SPANISH: 'solo tú,',
  },
  [PR_COVERAGE_YOU_PARTNER]: {
    ENGLISH: 'you and your partner,',
    SPANISH: 'tú y tu pareja,',
  },
  [PR_COVERAGE_YOU_CHILDREN]: {
    ENGLISH: 'you and child(ren),',
    SPANISH: 'tú y tus hijos,',
  },
  [PR_COVERAGE_YOU_FAMILY]: {
    ENGLISH: 'you and your family,',
    SPANISH: 'tú y tu familia,',
  },
  [PR_NOT_UNDERLINED]: {
    ENGLISH: 'not',
    SPANISH: 'no',
  },
  [PR_VISITING_THE_DOCTOR]: {
    ENGLISH: 'visiting the doctor,',
    SPANISH: 'visitando al médico,',
  },
  [PR_RARELY]: {
    ENGLISH: 'rarely',
    SPANISH: 'raramente',
  },
  [PR_OCCASIONALLY]: {
    ENGLISH: 'occasionally',
    SPANISH: 'ocasionalmente',
  },
  [PR_OFTEN]: {
    ENGLISH: 'often',
    SPANISH: 'frecuentemente',
  },
  [PR_FREQUENTLY]: {
    ENGLISH: 'frequently',
    SPANISH: 'muy frecuentemente',
  },
  [PR_NOT_UNDERLINED_SPECIALIST]: {
    ENGLISH: 'not',
    SPANISH: 'no',
  },
  [PR_VISITING_A_SPECIALIST]: {
    ENGLISH: 'visiting a specialist,',
    SPANISH: 'visitando a un especialista,',
  },
  [PR_NOT_UNDERLINED_PROCEDURES]: {
    ENGLISH: 'not',
    SPANISH: 'no',
  },
  [PR_PLANNING_A]: {
    ENGLISH: 'planning a',
    SPANISH: 'planeando un',
  },
  [PR_PREGNANCY_OR_PROCEDURES]: {
    ENGLISH: 'pregnancy or procedures',
    SPANISH: 'embarazo o procedimientos',
  },
  [PR_PLANNING_PREGNANCY_PROCEDURES]: {
    ENGLISH: 'planning a pregnancy or any procedures,',
    SPANISH: 'planeando un embarazo o procedimientos,',
  },
  [PR_USING_A]: {
    ENGLISH: 'using a',
    SPANISH: 'usando una',
  },
  [PR_NARROW_NETWORK]: {
    ENGLISH: 'narrow network',
    SPANISH: 'red limitada',
  },
  [PR_WIDE_NETWORK]: {
    ENGLISH: 'wide network',
    SPANISH: 'red amplia',
  },
  [PR_KAISER]: {
    ENGLISH: 'Kaiser',
    SPANISH: 'Kaiser',
  },
  [PR_NOT_TAKING_PRESCRIPTIONS]: {
    ENGLISH: 'not taking any prescription drugs.',
    SPANISH: 'no tomando ningún medicamento recetado.',
  },
  [PR_USING_COST_DRUGS]: {
    ENGLISH: 'cost drugs',
    SPANISH: 'medicamentos de costo',
  },
  [PR_AND_USING]: {
    ENGLISH: 'and using',
    SPANISH: 'y usando',
  },
  [PR_WE_RECOMMEND]: {
    ENGLISH: 'We recommend the',
    SPANISH: 'Recomendamos el',
  },
  [PR_PLAN]: {
    ENGLISH: 'plan',
    SPANISH: 'plan',
  },
  [PR_PLANS]: {
    ENGLISH: 'plans',
    SPANISH: 'planes',
  },
  [PR_FOR_YOU]: {
    ENGLISH: 'for you!',
    SPANISH: '¡para ti!',
  },
  [PR_NO_RECOMMENDATIONS]: {
    ENGLISH: "Sorry we don't have any recommendations for you!",
    SPANISH: '¡Lo sentimos, no tenemos recomendaciones para ti!',
  },
  [PR_PREMIUM]: {
    ENGLISH: 'Premium',
    SPANISH: 'Prima',
  },
  [BENEFIT_PERCENTAGE]: {
    ENGLISH: 'Benefit Percentage',
    SPANISH: 'Porcentaje de beneficio',
  },
  [MAXIMUM_WEEKLY_BENEFIT]: {
    ENGLISH: 'Maximum Weekly Benefit',
    SPANISH: 'Beneficio semanal máximo',
  },
  [MAXIMUM_MONTHLY_BENEFIT]: {
    ENGLISH: 'Maximum Monthly Benefit',
    SPANISH: 'Beneficio mensual máximo',
  },
  [ELIMINATION_PERIOD]: {
    ENGLISH: 'Elimination Period',
    SPANISH: 'Periodo de Eliminación',
  },
  [MAXIMUM_BENEFIT_DURATION]: {
    ENGLISH: 'Maximum Benefit Duration',
    SPANISH: 'Duración máxima del beneficio',
  },
  [EMPLOYER_CONTRIBUTION_PER]: {
    ENGLISH: 'Employer Contribution per',
    SPANISH: 'Contribución del empleador por',
  },
  [PR_PLAN_NETWORK]: {
    ENGLISH: 'Plan Network',
    SPANISH: 'Red del Plan',
  },
  [PR_DEDUCTIBLE]: {
    ENGLISH: 'Deductible',
    SPANISH: 'Deducible',
  },
  [PR_OUT_OF_POCKET_MAX]: {
    ENGLISH: 'Out-of-Pocket-Max',
    SPANISH: 'Máximo de Bolsillo',
  },
  [PR_OFFICE_VISIT]: {
    ENGLISH: 'Office Visit',
    SPANISH: 'Visita al Consultorio',
  },
  [PR_SPECIALIST_VISIT]: {
    ENGLISH: 'Specialist Visit',
    SPANISH: 'Visita al Especialista',
  },
  [PR_RETAIL_TIER]: {
    ENGLISH: 'Retail Tier',
    SPANISH: 'Nivel de Farmacia',
  },
  [PR_HSA_CONTRIBUTION_HRA_ALLOWANCE]: {
    ENGLISH: 'HSA Contribution / HRA Allowance',
    SPANISH: 'Contribución HSA / Asignación HRA',
  },
  [PR_EST_ANNUAL_COST]: {
    ENGLISH: 'Est. Annual Cost',
    SPANISH: 'Costo Anual Est.',
  },
  [PR_EST_ANNUAL_COST_BREAKDOWN]: {
    ENGLISH: 'Est. Annual Cost Breakdown',
    SPANISH: 'Desglose de Costo Anual Est.',
  },
  [PR_UNABLE_TO_RECOMMEND]: {
    ENGLISH:
      "Sorry, we're unable to make any recommendations. You may need to edit and refine your responses.",
    SPANISH:
      'Lo sentimos, no podemos hacer recomendaciones. Es posible que necesites editar y refinar tus respuestas.',
  },
  [PR_EDIT_REFINE_RESPONSES]: {
    ENGLISH: 'Edit Responses',
    SPANISH: 'Editar Respuestas',
  },
  [PR_RECOMMENDATION]: {
    ENGLISH: 'Recommendation',
    SPANISH: 'Recomendación',
  },
  [PR_INFO]: {
    ENGLISH: 'Info',
    SPANISH: 'Información',
  },
  [PR_PLAN_DETAILS]: {
    ENGLISH: 'Plan Details',
    SPANISH: 'Detalles del Plan',
  },
  [PR_HSA]: {
    ENGLISH: 'HSA',
    SPANISH: 'HSA',
  },
  [PR_DISCLAIMER]: {
    ENGLISH:
      'Plan recommendations are based on the information you provide and are meant as a guide to help you compare options. Your official coverage and rights are governed by the Plan Documents.',
    SPANISH:
      'Las recomendaciones de planes se basan en la información que proporciona y están destinadas como una guía para ayudarlo a comparar opciones. Su cobertura oficial y derechos están regidos por los Documentos del Plan.',
  },
  [INDIVIDUAL_DEDUCTIBLE_DESCRIPTION]: {
    ENGLISH:
      'Generally, this is a fixed amount you pay out-of-pocket before insurance starts to share the cost of covered expenses. Note that preventive care is typically covered 100% by insurance regardless of where you stand with your deductible.',
    SPANISH:
      'Generalmente, esta es una cantidad fija que paga de su bolsillo antes de que el seguro comience a compartir el costo de los gastos cubiertos. Tenga en cuenta que la atención preventiva generalmente está cubierta al 100% por el seguro, independientemente de dónde se encuentre con su deducible.',
  },
  [OFFICE_VISIT_DESCRIPTION]: {
    ENGLISH:
      'Cost of an outpatient appointment to see a general health care provider, especially a family physician, internist, or pediatrician, usually as part of regular, non-emergency care.',
    SPANISH:
      'Costo de una cita ambulatoria para ver a un proveedor de atención médica general, especialmente un médico de familia, internista o pediatra, generalmente como parte de la atención regular, no de emergencia.',
  },
  [SPECIALIST_VISIT_DESCRIPTION]: {
    ENGLISH:
      "If your plan requires a referral and you don't get one first, your insurance won't cover the cost to see the specialist. Most HMO plans require a referral from your primary care physician before you can see any other health care professional (except in an emergency).",
    SPANISH:
      'Si su plan requiere una referencia y no obtiene una primero, su seguro no cubrirá el costo de ver al especialista. La mayoría de los planes HMO requieren una referencia de su médico de atención primaria antes de que pueda ver a cualquier otro profesional de la salud (excepto en una emergencia).',
  },
  [PREVENTIVE_CARE_DESCRIPTION]: {
    ENGLISH:
      'Preventive care typically includes annual check-ups, flu shots, vaccinations, as well as certain tests and screenings.',
    SPANISH:
      'La atención preventiva generalmente incluye chequeos anuales, vacunas contra la gripe, vacunas, así como ciertas pruebas y exámenes de detección.',
  },
  [EMERGENCY_ROOM_DESCRIPTION]: {
    ENGLISH:
      "An emergency room provides treatment for an acute injury or illness that poses an immediate risk to a person's life or long-term health.",
    SPANISH:
      'Una sala de emergencias proporciona tratamiento para una lesión o enfermedad aguda que representa un riesgo inmediato para la vida o la salud a largo plazo de una persona.',
  },
  [URGENT_CARE_DESCRIPTION]: {
    ENGLISH:
      'An urgent care situation is one that requires prompt medical attention, generally within 24 to 48 hours, but is not a medical emergency.',
    SPANISH:
      'Una situación de atención urgente es una que requiere atención médica inmediata, generalmente dentro de 24 a 48 horas, pero no es una emergencia médica.',
  },
  [DIAGNOSTIC_LAB_DESCRIPTION]: {
    ENGLISH:
      "Services that are not considered an emergency may require precertification (pre-authorization). It's generally required for expensive radiology services such as ultrasounds, CAT scans, and MRIs. While your medical provider obtains this from the insurance carrier, it's your responsibility to make sure it gets done.",
    SPANISH:
      'Los servicios que no se consideran una emergencia pueden requerir precertificación (preautorización). Generalmente se requiere para servicios de radiología costosos como ultrasonidos, tomografías computarizadas y resonancias magnéticas. Aunque su proveedor médico obtiene esto del asegurador, es su responsabilidad asegurarse de que se haga.',
  },
  [HOSPITAL_INPATIENT_DESCRIPTION]: {
    ENGLISH:
      'The cost associated with being admitted to the hospital to receive inpatient services. The expectation is the patient will occupy a bed and remain at least overnight.',
    SPANISH:
      'El costo asociado con ser admitido al hospital para recibir servicios hospitalarios. La expectativa es que el paciente ocupará una cama y permanecerá al menos durante la noche.',
  },
  [HOSPITAL_OUTPATIENT_DESCRIPTION]: {
    ENGLISH:
      'The cost associated with outpatient services. The expectation is the patient will not be admitted to the hospital overnight.',
    SPANISH:
      'El costo asociado con los servicios ambulatorios. La expectativa es que el paciente no será admitido al hospital durante la noche.',
  },
  [CHIROPRACTIC_CARE_DESCRIPTION]: {
    ENGLISH:
      'Chiropractic care is covered under most health insurance plans. Some plans may have visit limits, dollar limits or referral requirements.',
    SPANISH:
      'La atención quiropráctica está cubierta bajo la mayoría de los planes de seguro de salud. Algunos planes pueden tener límites de visitas, límites en dólares o requisitos de referencia.',
  },
  [ACUPUNCTURE_CARE_DESCRIPTION]: {
    ENGLISH:
      'Some health plans cover acupuncture when it is medically necessary and prescribed by your doctor.',
    SPANISH:
      'Algunos planes de salud cubren la acupuntura cuando es médicamente necesaria y prescrita por su médico.',
  },
  [RETAIL_TIER_1A_DESCRIPTION]: {
    ENGLISH: 'Typically lower cost generic drugs.',
    SPANISH: 'Típicamente medicamentos genéricos de menor costo.',
  },
  [RETAIL_TIER_1B_DESCRIPTION]: {
    ENGLISH: 'Generic drugs.',
    SPANISH: 'Medicamentos genéricos.',
  },
  [MAIL_ORDER_PHARMACY_DESCRIPTION]: {
    ENGLISH:
      "Using your carrier's mail order pharmacy may save you time and money. For details, check your carrier's Summary of Benefits and Coverage (SBC).",
    SPANISH:
      'Usar la farmacia de pedidos por correo de su asegurador puede ahorrarle tiempo y dinero. Para obtener detalles, consulte el Resumen de Beneficios y Cobertura (SBC) de su asegurador.',
  },
  [SEE_SBC]: {
    ENGLISH: 'See SBC',
    SPANISH: 'Ver SBC',
  },
  [WHAT_IS_PPO]: {
    ENGLISH: 'What is a PPO?',
    SPANISH: '¿Qué es un PPO?',
  },
  [WHAT_IS_POS]: {
    ENGLISH: 'What is a POS?',
    SPANISH: '¿Qué es un POS?',
  },
  [WHAT_IS_OAP]: {
    ENGLISH: 'What is an OAP?',
    SPANISH: '¿Qué es un OAP?',
  },
  [WHAT_IS_EPO]: {
    ENGLISH: 'What is an EPO?',
    SPANISH: '¿Qué es un EPO?',
  },
  [WHAT_IS_HMO]: {
    ENGLISH: 'What is an HMO?',
    SPANISH: '¿Qué es un HMO?',
  },
  [WHAT_IS_HSA_ELIGIBLE_PLAN]: {
    ENGLISH: 'What is an HSA-Eligible Plan?',
    SPANISH: '¿Qué es un Plan Elegible para HSA?',
  },
  [PPO_DESCRIPTION_1]: {
    ENGLISH:
      'A PPO, or Preferred Provider Organization provides a wider degree of choice. Insurance carriers make agreements with medical providers every year on participating in these PPO networks to provide consumers a wider range of choice on healthcare.',
    SPANISH:
      'Un PPO, u Organización de Proveedores Preferidos, proporciona un mayor grado de elección. Las aseguradoras hacen acuerdos con proveedores médicos cada año para participar en estas redes PPO y brindar a los consumidores una gama más amplia de opciones en atención médica.',
  },
  [PPO_DESCRIPTION_2]: {
    ENGLISH:
      'With a PPO, the network is wider and no physician referral is required to go see a specialist. If you need to go outside of a PPO network, the insurer will still provide some coverage, but your out-of-network coverage will result in higher out-of-pocket costs.',
    SPANISH:
      'Con un PPO, la red es más amplia y no se requiere una referencia médica para ver a un especialista. Si necesita salir de una red PPO, la aseguradora aún proporcionará cierta cobertura, pero su cobertura fuera de la red resultará en costos de bolsillo más altos.',
  },
  [POS_DESCRIPTION]: {
    ENGLISH:
      'A POS, or Point of Service plan, combines features of both HMO and PPO plans to offer flexibility and cost savings. Unlike PPO plans, POS plans require you to choose a PCP and obtain referrals for specialist visits.',
    SPANISH:
      'Un plan POS, o Punto de Servicio, combina características de los planes HMO y PPO para ofrecer flexibilidad y ahorro de costos. A diferencia de los planes PPO, los planes POS requieren que elija un PCP y obtenga referencias para visitas de especialistas.',
  },
  [OAP_DESCRIPTION]: {
    ENGLISH:
      "An OAP or Open Access Plus provides a hybrid of an HMO and a PPO. On the one hand, like a PPO, you do not need a physician's referral to go see a specialist. On the other hand, like an HMO, you must stay within the network.",
    SPANISH:
      'Un OAP o Acceso Abierto Plus proporciona un híbrido de un HMO y un PPO. Por un lado, como un PPO, no necesita una referencia médica para ver a un especialista. Por otro lado, como un HMO, debe permanecer dentro de la red.',
  },
  [EPO_DESCRIPTION]: {
    ENGLISH:
      "An EPO or Exclusive Provider Organization provides a hybrid of an HMO and a PPO. On the one hand, like a PPO, you do not need a physician's referral to go see a specialist. On the other hand, like an HMO, you must stay within the network.",
    SPANISH:
      'Un EPO u Organización de Proveedores Exclusivos proporciona un híbrido de un HMO y un PPO. Por un lado, como un PPO, no necesita una referencia médica para ver a un especialista. Por otro lado, como un HMO, debe permanecer dentro de la red.',
  },
  [HMO_DESCRIPTION_1]: {
    ENGLISH:
      'A Health Maintenance Organization, or HMO plan, is a fully integrated health plan that includes doctors, pharmacies and administrative functions all within a single network. You pick a primary care doctor who serves as a primary point of contact. When necessary, you are required to get a referral from your primary care physician to see a specialist within the HMO network, such as a dermatologist.',
    SPANISH:
      'Una Organización de Mantenimiento de la Salud, o plan HMO, es un plan de salud completamente integrado que incluye médicos, farmacias y funciones administrativas, todo dentro de una sola red. Usted elige un médico de atención primaria que sirve como punto de contacto principal. Cuando sea necesario, se le requiere obtener una referencia de su médico de atención primaria para ver a un especialista dentro de la red HMO, como un dermatólogo.',
  },
  [HMO_DESCRIPTION_2]: {
    ENGLISH:
      'One of the primary reasons employees like HMOs is because they serve as a single provider for everything. Because of this, HMOs typically have lower administrative costs associated with running their networks.',
    SPANISH:
      'Una de las razones principales por las que a los empleados les gustan los HMO es porque sirven como un solo proveedor para todo. Debido a esto, los HMO típicamente tienen costos administrativos más bajos asociados con el funcionamiento de sus redes.',
  },
  [HSA_DESCRIPTION_1]: {
    ENGLISH:
      "An HSA-eligible plan is a High-Deductible Health Plan (HDHP) that can be paired with a Health Savings Account (HSA). An HDHP can be an HMO, PPO, or EPO. The key difference is how you share in health care costs. An HDHP has lower premiums, but you pay all costs out-of-pocket (including prescriptions) until you meet the plan's deductible. Once you meet the deductible, the plan shares costs (copays or coinsurance kicks in).",
    SPANISH:
      'Un plan elegible para HSA es un Plan de Salud con Deducible Alto (HDHP) que se puede combinar con una Cuenta de Ahorros para la Salud (HSA). Un HDHP puede ser un HMO, PPO o EPO. La diferencia clave es cómo comparte los costos de atención médica. Un HDHP tiene primas más bajas, pero usted paga todos los costos de su bolsillo (incluidas las recetas) hasta que cumpla con el deducible del plan. Una vez que cumpla con el deducible, el plan comparte los costos (entran en vigor los copagos o el coseguro).',
  },
  [HSA_DESCRIPTION_2]: {
    ENGLISH:
      'The HSA serves as a "health 401(k)" you can use to offset your out-of-pocket costs now—or let it build to pay for future health care costs after your retire. An HSA is a personal bank account, and the money is yours to keep even if you change employers. HSA funds are always yours to spend on qualified medical expenses (you just can\'t *contribute* to an HSA unless you have an HDHP). HSAs funds rollover year-to-year, and they have a triple tax advantage (contributions are not federally taxed, funds grow tax-free, and funds used to pay for qualified medical expenses are not taxed).',
    SPANISH:
      'La HSA sirve como un "401(k) de salud" que puede usar para compensar sus costos de bolsillo ahora, o dejar que se acumule para pagar los costos de atención médica futuros después de jubilarse. Una HSA es una cuenta bancaria personal, y el dinero es suyo para mantener incluso si cambia de empleadores. Los fondos HSA son siempre suyos para gastar en gastos médicos calificados (simplemente no puede *contribuir* a una HSA a menos que tenga un HDHP). Los fondos HSA se transfieren año tras año, y tienen una triple ventaja fiscal (las contribuciones no están gravadas federalmente, los fondos crecen libres de impuestos, y los fondos utilizados para pagar gastos médicos calificados no están gravados).',
  },
  [LEARN_MORE_ABOUT_HSAS]: {
    ENGLISH: 'Learn More About HSAs',
    SPANISH: 'Aprenda Más Sobre las HSA',
  },
  [LEARN_MORE_ABOUT_PLAN_TYPE]: {
    ENGLISH: 'Learn More About {planType}s',
    SPANISH: 'Aprenda Más Sobre los {planType}',
  },
  [HOW_OTHER_PLANS_COMPARE]: {
    ENGLISH: 'How Other Plans Compare',
    SPANISH: 'Cómo Se Comparan Otros Planes',
  },
  [HEALTH_MAINTENANCE_ORGANIZATION]: {
    ENGLISH: 'Health Maintenance Organization',
    SPANISH: 'Organización de Mantenimiento de la Salud',
  },
  [PREFERRED_PROVIDER_ORGANIZATION]: {
    ENGLISH: 'Preferred Provider Organization',
    SPANISH: 'Organización de Proveedores Preferidos',
  },
  [EXCLUSIVE_PROVIDER_ORGANIZATION]: {
    ENGLISH: 'Exclusive Provider Organization',
    SPANISH: 'Organización de Proveedores Exclusivos',
  },
  [POINT_OF_SERVICE]: {
    ENGLISH: 'Point of Service',
    SPANISH: 'Punto de Servicio',
  },
  [SELF_REFERRAL]: {
    ENGLISH: 'Self Referral',
    SPANISH: 'Auto Referencia',
  },
  [PRIMARY_DOC_REFERRAL]: {
    ENGLISH: 'Primary Doc Referral',
    SPANISH: 'Referencia del Médico Primario',
  },
  [NO_COINSURANCE]: {
    ENGLISH: 'No Coinsurance',
    SPANISH: 'Sin Coseguro',
  },
  [NO_DEDUCTIBLE]: {
    ENGLISH: 'No Deductible',
    SPANISH: 'Sin Deducible',
  },
  [OUT_OF_NETWORK_COVERAGE]: {
    ENGLISH: 'Out-of-Network Coverage',
    SPANISH: 'Cobertura Fuera de la Red',
  },
  [PLAN_COMPARISON_DESCRIPTION]: {
    ENGLISH:
      'Knowing the difference between plan types and their networks can help you choose the best plan for your needs and preferences.',
    SPANISH:
      'Conocer la diferencia entre los tipos de planes y sus redes puede ayudarle a elegir el mejor plan para sus necesidades y preferencias.',
  },
  [OAP_FOOTNOTE_DESCRIPTION]: {
    ENGLISH:
      '* OAP is similar to an EPO, with one major difference: out-of-network coverage is included at a higher out-of-pocket cost.',
    SPANISH:
      '* OAP es similar a un EPO, con una diferencia importante: la cobertura fuera de la red está incluida a un costo de bolsillo más alto.',
  },
  [BASED_ON]: {
    ENGLISH: 'BASED ON:',
    SPANISH: 'BASADO EN:',
  },
  [PREMIUM]: {
    ENGLISH: 'Premium',
    SPANISH: 'Prima',
  },
  [ANNUAL_EMPLOYER_CONTRIBUTION]: {
    ENGLISH: 'Annual Employer Contribution',
    SPANISH: 'Contribución Anual del Empleador',
  },
  [ANNUAL_EMPLOYER_ALLOWANCE]: {
    ENGLISH:
      'Annual employer allowance of up to {individual} for individual or {family} for families.',
    SPANISH:
      'Asignación anual del empleador de hasta {individual} para individuales o {family} para familias.',
  },
  [ANNUAL_PREMIUM]: {
    ENGLISH: 'Annual Premium',
    SPANISH: 'Prima Anual',
  },
  [OOP_MAX]: {
    ENGLISH: 'OOP MAX',
    SPANISH: 'MÁXIMO DE BOLSILLO',
  },
  [COPAYS]: {
    ENGLISH: 'Copays',
    SPANISH: 'Copagos',
  },
  [COINSURANCE]: {
    ENGLISH: 'Coinsurance',
    SPANISH: 'Coseguro',
  },
  [YOU_PAY]: {
    ENGLISH: 'You pay:',
    SPANISH: 'Usted paga:',
  },
  [OOP_MAX_EXCEEDED_MESSAGE]: {
    ENGLISH:
      '*Your above costs exceed your out-of-pocket max, so the most you will pay is {amount} for in-network services.',
    SPANISH:
      '*Sus costos anteriores exceden su máximo de bolsillo, por lo que lo máximo que pagará es {amount} por servicios dentro de la red.',
  },
  [FOR_IN_NETWORK_SERVICES]: {
    ENGLISH: 'for in-network services.',
    SPANISH: 'por servicios dentro de la red.',
  },
  [FOR_INDIVIDUAL]: {
    ENGLISH: 'for individual',
    SPANISH: 'para individual',
  },
  [FOR_FAMILIES]: {
    ENGLISH: 'for families',
    SPANISH: 'para familias',
  },
  [AI_ASSISTANT_INITIALIZE_TEXT]: {
    ENGLISH: 'Talk with SAGE',
    SPANISH: 'Hablar con SAGE',
  },
  [AI_ASSISTANT_INITIALIZE_WARNING]: {
    ENGLISH: 'SAGE can make mistakes. Consider checking important information.',
    SPANISH:
      'SAGE puede cometer errores. Considere verificar información importante.',
  },
  [AI_PLAN_HEADER_TEXT]: {
    ENGLISH: 'Plan Assistance',
    SPANISH: 'Asistencia de Planes',
  },
  [AI_SELECTION_PLAN_ASSISTANCE_TEXT]: {
    ENGLISH: 'Use SAGE to inquire about any plans from this microsite.',
    SPANISH:
      'Use SAGE para consultar sobre cualquier plan de esta guía de beneficios.',
  },
  [AI_GENERAL_HEADER_TEXT]: {
    ENGLISH: 'General Questions',
    SPANISH: 'Preguntas Generales',
  },
  [AI_SELECTION_GENERAL_ASSISTANT_TEXT]: {
    ENGLISH: 'Have a general question outside of specific plans? Ask anything.',
    SPANISH:
      '¿Tiene una pregunta general fuera de planes específicos? Pregunte cualquier cosa.',
  },
  [AI_HELP_HEADER_TEXT]: {
    ENGLISH: 'How can I help you today?',
    SPANISH: '¿Cómo puedo ayudarte hoy?',
  },
  [AI_PLAN_ASSISTANT_TEXT]: {
    ENGLISH: 'What would you like to know about these plans?',
    SPANISH: '¿Qué te gustaría saber sobre estos planes?',
  },
  [AI_GENERAL_ASSISTANT_TEXT]: {
    ENGLISH: 'Have a general question? Ask me anything.',
    SPANISH: '¿Tienes una pregunta general? Pregúntame cualquier cosa.',
  },
  [AI_PLAN_DOCUMENT_NOT_FOUND]: {
    ENGLISH:
      'Selected plan has no associated document. Please select another plan.',
    SPANISH:
      'El plan seleccionado no tiene documento asociado. Por favor seleccione otro plan.',
  },
  [AI_ASSISTANT_COMMON_ERROR]: {
    ENGLISH:
      "Sorry, I'm unable to retrieve the information you're looking for at the moment. Please try again later or refine your query.",
    SPANISH:
      'Lo siento, no puedo obtener la información que buscas en este momento. Por favor intenta de nuevo más tarde o refina tu consulta.',
  },
  [AI_PLAN_CHANGE_POPOVER_TEXT]: {
    ENGLISH: 'Start a new chat to change the plan',
    SPANISH: 'Inicia un nuevo chat para cambiar el plan',
  },
  [AI_PLAN_ASSISTANCE_MODAL_TITLE]: {
    ENGLISH: 'Plan Assistance',
    SPANISH: 'Asistencia de Planes',
  },
  [AI_PLAN_ASSISTANCE_MODAL_DESCRIPTION]: {
    ENGLISH:
      'SAGE is available to assist with any inquiries regarding a particular plans from this microsite.',
    SPANISH:
      'SAGE está disponible para ayudar con cualquier consulta sobre planes particulares de esta guía de beneficios.',
  },
  [AI_CHOOSE_PLAN]: {
    ENGLISH: 'Choose Plan',
    SPANISH: 'Elegir Plan',
  },
  [AI_CONTINUE]: {
    ENGLISH: 'Continue',
    SPANISH: 'Continuar',
  },
  [AI_COPY]: {
    ENGLISH: 'Copy',
    SPANISH: 'Copiar',
  },
  [AI_NEW_CHAT]: {
    ENGLISH: 'New Chat',
    SPANISH: 'Nuevo Chat',
  },
  [AI_PLAN_NAME]: {
    ENGLISH: 'Plan Name:',
    SPANISH: 'Nombre del Plan:',
  },
  [AI_ASSISTANT]: {
    ENGLISH: 'SAGE',
    SPANISH: 'SAGE',
  },
  [VIEW_ID_CARDS]: {
    ENGLISH: 'View ID Cards',
    SPANISH: 'Ver Tarjetas de ID',
  },
  [OUT_OF_POCKET_MAX_FAMILY_DESCRIPTION]: {
    ENGLISH:
      'The most you have to pay for covered services and prescriptions in a plan year.',
    SPANISH:
      'Lo máximo que tiene que pagar por servicios cubiertos y recetas en un año del plan.',
  },
  [IND_WITHIN_FAMILY_OOP_MAX_DESCRIPTION]: {
    ENGLISH:
      "The maximum amount each family member pays for covered services in a year, contributing to the family's total out-of-pocket limit.",
    SPANISH:
      'La cantidad máxima que cada miembro de la familia paga por servicios cubiertos en un año, contribuyendo al límite total de gastos de bolsillo de la familia.',
  },
  [SPECIALIST_VISIT_DESCRIPTION_NEW]: {
    ENGLISH:
      'A specialist focuses on a specific area of medicine. Examples include dermatologists, cardiologists, psychiatrists, surgeons, etc. Some plan types require a referral from your primary care physician for the specialist visit to be covered.',
    SPANISH:
      'Un especialista se enfoca en un área específica de la medicina. Los ejemplos incluyen dermatólogos, cardiólogos, psiquiatras, cirujanos, etc. Algunos tipos de planes requieren una referencia de su médico de atención primaria para que la visita al especialista esté cubierta.',
  },
  [VIRTUAL_CARE_VISIT_DESCRIPTION]: {
    ENGLISH:
      'Cost of an outpatient appointment to see a general health care provider, especially a family physician, internist, or pediatrician, usually as part of regular, non-emergency care.',
    SPANISH:
      'Costo de una cita ambulatoria para ver a un proveedor de atención médica general, especialmente un médico de familia, internista o pediatra, generalmente como parte de la atención regular, no de emergencia.',
  },
  [MAJOR_DENTAL_CARE_DESCRIPTION]: {
    ENGLISH:
      'Procedures dealing with the restoration of teeth. This could include inlays, crowns, veneers, bridges, root canals, oral surgery, etc.',
    SPANISH:
      'Procedimientos que se ocupan de la restauración de dientes. Esto podría incluir incrustaciones, coronas, carillas, puentes, endodoncias, cirugía oral, etc.',
  },
  [ENDODONTIC_CARE_DESCRIPTION]: {
    ENGLISH: 'Endodontic care',
    SPANISH: 'Atención endodóntica',
  },
  [PERIODONTIC_CARE_DESCRIPTION]: {
    ENGLISH: 'Periodontic care',
    SPANISH: 'Atención periodontal',
  },
  [WAITING_PERIOD_DESCRIPTION]: {
    ENGLISH: 'Waiting period',
    SPANISH: 'Período de espera',
  },
  [IMPLANTS_DESCRIPTION]: {
    ENGLISH: 'Implants',
    SPANISH: 'Implantes',
  },
  [OUT_OF_NETWORK_REIMBURSEMENT_DESCRIPTION]: {
    ENGLISH: 'Out of network reimbursement',
    SPANISH: 'Reembolso fuera de la red',
  },
  [EYE_EXAM_DESCRIPTION]: {
    ENGLISH: 'Eye exam',
    SPANISH: 'Examen de la vista',
  },
  [LENSES_DESCRIPTION]: {
    ENGLISH: 'Lenses',
    SPANISH: 'Lentes',
  },
  [FRAMES_DESCRIPTION]: {
    ENGLISH: 'Frames',
    SPANISH: 'Monturas',
  },
  [VISION_EXAM_DESCRIPTION]: {
    ENGLISH:
      'A standard eye exam involves a series of tests to evaluate your vision and check for eye diseases.',
    SPANISH:
      'Un examen de la vista estándar involucra una serie de pruebas para evaluar su visión y verificar enfermedades oculares.',
  },
  [MATERIALS_COPAY_DESCRIPTION]: {
    ENGLISH: 'Materials copay',
    SPANISH: 'Copago de materiales',
  },
  [EYEGLASS_LENSES_SINGLE_DESCRIPTION]: {
    ENGLISH: 'Eyeglass lenses single',
    SPANISH: 'Lentes de anteojos simples',
  },
  [EYEGLASS_LENSES_BIFOCAL_DESCRIPTION]: {
    ENGLISH: 'Eyeglass lenses bifocal',
    SPANISH: 'Lentes de anteojos bifocales',
  },
  [EYEGLASS_LENSES_TRIFOCAL_DESCRIPTION]: {
    ENGLISH: 'Eyeglass lenses trifocal',
    SPANISH: 'Lentes de anteojos trifocales',
  },
  [EYEGLASS_LENSES_LENTICULAR_DESCRIPTION]: {
    ENGLISH: 'Eyeglass lenses lenticular',
    SPANISH: 'Lentes de anteojos lenticulares',
  },
  [ELECTIVE_CONTACTS_DESCRIPTION]: {
    ENGLISH: 'Elective contacts',
    SPANISH: 'Lentes de contacto electivos',
  },
  [MEDICALLY_NECESSARY_CONTACTS_DESCRIPTION]: {
    ENGLISH: 'Medically necessary contacts',
    SPANISH: 'Lentes de contacto médicamente necesarios',
  },
  [COINSURANCE_DESCRIPTION]: {
    ENGLISH:
      'The percentage you pay for covered services after meeting your deductible. Example, if your co-insurance is 20%, then you pay 20%, your plan pays 80% of the cost.',
    SPANISH:
      'El porcentaje que paga por los servicios cubiertos después de cumplir con su deducible. Por ejemplo, si su coseguro es del 20%, entonces usted paga el 20%, su plan paga el 80% del costo.',
  },
  [COMPLEX_IMAGING_DESCRIPTION]: {
    ENGLISH: 'Services for advanced imaging, including CT, PET, or MRI scans.',
    SPANISH:
      'Servicios para imágenes avanzadas, incluyendo tomografías computarizadas, PET o resonancias magnéticas.',
  },
  [RX_DEDUCTIBLE_DESCRIPTION]: {
    ENGLISH:
      'Rx deductible is a fixed amount you pay out-of-pocket before insurance starts to share the cost of covered prescription medications.',
    SPANISH:
      'El deducible de medicamentos recetados es una cantidad fija que paga de su bolsillo antes de que el seguro comience a compartir el costo de los medicamentos recetados cubiertos.',
  },
  [RX_OUT_OF_POCKET_MAX_DESCRIPTION]: {
    ENGLISH:
      'The most you have to pay for covered prescription medications in a plan year.',
    SPANISH:
      'Lo máximo que tiene que pagar por medicamentos recetados cubiertos en un año del plan.',
  },
  [DENTAL_ANNUAL_MAXIMUM_DESCRIPTION]: {
    ENGLISH:
      'This is the maximum dollar amount a dental benefit plan will pay toward the cost of dental care within a the plan year. The patient is personally responsible for paying costs above the annual maximum.',
    SPANISH:
      'Esta es la cantidad máxima en dólares que un plan de beneficios dentales pagará hacia el costo de la atención dental dentro del año del plan. El paciente es personalmente responsable de pagar los costos por encima del máximo anual.',
  },
  [DENTAL_INDIVIDUAL_DEDUCTIBLE_DESCRIPTION]: {
    ENGLISH:
      'This is a fixed amount you pay out-of-pocket before insurance starts to share the cost of covered expenses.',
    SPANISH:
      'Esta es una cantidad fija que paga de su bolsillo antes de que el seguro comience a compartir el costo de los gastos cubiertos.',
  },
  [ORTHODONTIA_LIFETIME_MAX_DESCRIPTION]: {
    ENGLISH:
      'Orthodontic coverage typically involves a Lifetime Maximum (LTM) benefit. This is the most money the dental plan will pay for dental care for the employee (or family) for the life of the plan.',
    SPANISH:
      'La cobertura de ortodoncia típicamente involucra un beneficio de Máximo de por Vida (LTM). Esta es la mayor cantidad de dinero que el plan dental pagará por atención dental para el empleado (o familia) durante la vida del plan.',
  },
  [DENTAL_PREVENTIVE_CARE_DESCRIPTION]: {
    ENGLISH:
      'Preventive services are associated with the prevention of disease through educational and protective measures (such as routine office visits, cleanings, check-ups, etc). Diagnostic may include x-rays, bitewing, full-mouth, or intraoral occlusal film.',
    SPANISH:
      'Los servicios preventivos están asociados con la prevención de enfermedades a través de medidas educativas y protectoras (como visitas rutinarias al consultorio, limpiezas, chequeos, etc). El diagnóstico puede incluir rayos X, bitewing, boca completa o película oclusal intraoral.',
  },
  [DENTAL_BASIC_CARE_DESCRIPTION]: {
    ENGLISH:
      'Procedures to repair and restore individual teeth due to decay, trauma, impaired function, attrition, abrasion, erosion, etc.',
    SPANISH:
      'Procedimientos para reparar y restaurar dientes individuales debido a caries, trauma, función deteriorada, atrición, abrasión, erosión, etc.',
  },
  [CUSTOM_PAGE_NOT_FOUND]: {
    ENGLISH: 'This page is no longer available.',
    SPANISH: 'Esta página ya no está disponible.',
  },
  [CUSTOM_PAGE_SECTION_NOT_FOUND]: {
    ENGLISH: 'This section is empty.',
    SPANISH: 'Esta sección está vacía.',
  },
  [CUSTOM_PAGE_SECTION_NOT_FOUND_MORE_INFO]: {
    ENGLISH: 'For more details, please check with your administrator.',
    SPANISH: 'Para más detalles, por favor consulte con su administrador.',
  },
  [FREQUENCY_PER_DAY]: {
    ENGLISH: 'Per day',
    SPANISH: 'por día',
  },
  [FREQUENCY_PER_VISIT]: {
    ENGLISH: 'Per visit',
    SPANISH: 'por visita',
  },
  [FREQUENCY_PER_SERVICE]: {
    ENGLISH: 'Per service',
    SPANISH: 'por servicio',
  },
  [FREQUENCY_PER_ADMISSION]: {
    ENGLISH: 'Per admission',
    SPANISH: 'por admisión',
  },
  [FREQUENCY_PER_TRIP]: {
    ENGLISH: 'Per trip',
    SPANISH: 'por viaje',
  },
  [FREQUENCY_PER_WEEK]: {
    ENGLISH: 'Per week',
    SPANISH: 'por semana',
  },
  [FREQUENCY_PER_MONTH]: {
    ENGLISH: 'Per month',
    SPANISH: 'por mes',
  },
  [FREQUENCY_PER_YEAR]: {
    ENGLISH: 'Per year',
    SPANISH: 'por año',
  },
  [FREQUENCY_PER_PROCEDURE]: {
    ENGLISH: 'Per procedure',
    SPANISH: 'por procedimiento',
  },
  [FREQUENCY_PER_SCRIPT]: {
    ENGLISH: 'Per prescription',
    SPANISH: 'por receta médica',
  },
  [FREQUENCY_PER_ALLOWANCE]: {
    ENGLISH: 'Per allowance',
    SPANISH: 'por asignación',
  },
  [FREQUENCY_NO_INFO]: {
    ENGLISH: '',
    SPANISH: '',
  },
  [FREQUENCY_PER_ITEM]: {
    ENGLISH: 'Per item',
    SPANISH: 'por artículo',
  },
  [FREQUENCY_EVERY_OTHER_YEAR]: {
    ENGLISH: 'Every other year',
    SPANISH: 'cada dos años',
  },
  [AGE_BAND]: {
    ENGLISH: AGE_BAND_LABEL,
    SPANISH: 'Por bandas de edad',
  },
};

export const COVERAGE_TYPE_KEYS = {
  EE: JUST_YOU,
  ES: YOU_SPOUSE,
  EC: YOU_CHILD_REN,
  EF: YOU_FAMILY,
};

// Frequency mapping for FREQUENCIES[key].label
export const FREQUENCY_KEYS = {
  MONTHLY: FREQUENCY_MONTHLY,
  SEMI_MONTHLY: FREQUENCY_SEMI_MONTHLY,
  WEEKLY: FREQUENCY_WEEKLY,
  BI_WEEKLY: FREQUENCY_BI_WEEKLY,
  ANNUALLY: FREQUENCY_ANNUALLY,
  QUARTERLY: FREQUENCY_QUARTERLY,
};

export const CARD_FREQUENCY_KEYS = {
  PER_DAY: FREQUENCY_PER_DAY,
  PER_VISIT: FREQUENCY_PER_VISIT,
  PER_SERVICE: FREQUENCY_PER_SERVICE,
  PER_ADMISSION: FREQUENCY_PER_ADMISSION,
  PER_TRIP: FREQUENCY_PER_TRIP,
  PER_WEEK: FREQUENCY_PER_WEEK,
  PER_MONTH: FREQUENCY_PER_MONTH,
  PER_YEAR: FREQUENCY_PER_YEAR,
  PER_PROCEDURE: FREQUENCY_PER_PROCEDURE,
  PER_SCRIPT: FREQUENCY_PER_SCRIPT,
  PER_ALLOWANCE: FREQUENCY_PER_ALLOWANCE,
  NO_INFO: FREQUENCY_NO_INFO,
  PER_ITEM: FREQUENCY_PER_ITEM,
  EVERY_OTHER_YEAR: FREQUENCY_EVERY_OTHER_YEAR,
};

export const FIELD_KEYS = {
  acupuncture: ACUPUNCTURE_CARE,
  basicDentalCare: BASIC_CARE,
  basicDentalCareChild: BASIC_CARE,
  calendarYearMax: DENTAL_ANNUAL_MAXIMUM,
  chiropracticCare: CHIROPRACTIC_CARE,
  complexImaging: COMPLEX_IMAGING,
  dentalCheckUpChild: BASIC_CARE,
  electiveContacts: ELECTIVE_CONTACTS,
  emergencyRoom: EMERGENCY_ROOM,
  endodonticCare: ENDODONTIC_CARE,
  exam: EXAM_COPAY,
  eyeExam: EYE_EXAM,
  eyeGlassLensesBifocal: EYEGLASS_LENSES_BIFOCAL,
  eyeGlassLensesLenticular: EYEGLASS_LENSES_LENTICULAR,
  eyeGlassLensesSingle: EYEGLASS_LENSES_SINGLE,
  eyeGlassLensesTrifocal: EYEGLASS_LENSES_TRIFOCAL,
  frames: FRAMES,
  implants: IMPLANTS,
  indWithinFamilyDeductible: DEDUCTIBLE_IND_WITHIN_FAM,
  inpatient: HOSPITAL_INPATIENT,
  labXray: DIAGNOSTIC_LAB_X_RAY,
  lenses: LENSES,
  majorDentalCare: MAJOR_CARE,
  materialsCopay: MATERIALS_COPAY,
  medicallyNeccessaryContacts: MEDICALLY_NECESSARY_CONTACTS,
  monthlyCost: YOUR_MONTHLY_COST,
  officeVisit: OFFICE_VISIT,
  orthodontiaLifetimeMax: ORTHODONTIA_MAXIMUM,
  outOfNetworkReimbursement: OUT_OF_NETWORK_REIMBURSEMENT,
  outPatient: HOSPITAL_OUTPATIENT,
  periodonticCare: PERIODONTIC_CARE,
  planNetwork: PLAN_NETWORK,
  preventive: PREVENTIVE_CARE,
  preventiveCare: PREVENTIVE_CARE,
  routineDentalService: BASIC_CARE,
  specialistVisit: SPECIALIST_VISIT,
  title: PLAN_NAME,
  urgentCare: URGENT_CARE,
  virtualCareVisit: VIRTUAL_CARE,
  waitingPeriod: WAITING_PERIOD,
  individualDeductible: INDIVIDUAL_DEDUCTIBLE,
  familyDeductible: FAMILY_DEDUCTIBLE,
  individualWithinFamilyDeductible: DEDUCTIBLE_IND_WITHIN_FAM,
  individualWithinFamilyOutOfPocketMax: OUT_OF_POCKET_MAX_IND_WITHIN_FAM,
  familyOutOfPocketMax: FAMILY_OUT_OF_POCKET_MAX,
  individualOutOfPocketMax: INDIVIDUAL_OUT_OF_POCKET_MAX,
  hospitalInpatient: HOSPITAL_INPATIENT,
  hospitalOutpatient: HOSPITAL_OUTPATIENT,
  acupunctureCare: ACUPUNCTURE_CARE,
  coInsurance: COINSURANCE,
};

export const FIELD_DESCRIPTION_KEYS = {
  individualDeductible: INDIVIDUAL_DEDUCTIBLE_DESCRIPTION,
  officeVisit: OFFICE_VISIT_DESCRIPTION,
  specialistVisit: SPECIALIST_VISIT_DESCRIPTION,
  preventiveCare: PREVENTIVE_CARE_DESCRIPTION,
  emergencyRoom: EMERGENCY_ROOM_DESCRIPTION,
  urgentCare: URGENT_CARE_DESCRIPTION,
  coInsurance: COINSURANCE_DESCRIPTION,
  diagnosticLab: DIAGNOSTIC_LAB_DESCRIPTION,
  hospitalInpatient: HOSPITAL_INPATIENT_DESCRIPTION,
  hospitalOutpatient: HOSPITAL_OUTPATIENT_DESCRIPTION,
  chiropracticCare: CHIROPRACTIC_CARE_DESCRIPTION,
  acupunctureCare: ACUPUNCTURE_CARE_DESCRIPTION,
  acupuncture: ACUPUNCTURE_CARE_DESCRIPTION,
  basicDentalCare: DENTAL_BASIC_CARE_DESCRIPTION,
  basicDentalCareChild: DENTAL_BASIC_CARE_DESCRIPTION,
  calendarYearMax: DENTAL_ANNUAL_MAXIMUM_DESCRIPTION,
  complexImaging: COMPLEX_IMAGING_DESCRIPTION,
  electiveContacts: ELECTIVE_CONTACTS_DESCRIPTION,
  endodonticCare: ENDODONTIC_CARE_DESCRIPTION,
  exam: VISION_EXAM_DESCRIPTION,
  eyeExam: EYE_EXAM_DESCRIPTION,
  eyeGlassLensesBifocal: EYEGLASS_LENSES_BIFOCAL_DESCRIPTION,
  eyeGlassLensesLenticular: EYEGLASS_LENSES_LENTICULAR_DESCRIPTION,
  eyeGlassLensesSingle: EYEGLASS_LENSES_SINGLE_DESCRIPTION,
  eyeGlassLensesTrifocal: EYEGLASS_LENSES_TRIFOCAL_DESCRIPTION,
  frames: FRAMES_DESCRIPTION,
  implants: IMPLANTS_DESCRIPTION,
  inpatient: HOSPITAL_INPATIENT_DESCRIPTION,
  labXray: DIAGNOSTIC_LAB_DESCRIPTION,
  lenses: LENSES_DESCRIPTION,
  majorDentalCare: MAJOR_DENTAL_CARE_DESCRIPTION,
  materialsCopay: MATERIALS_COPAY_DESCRIPTION,
  medicallyNeccessaryContacts: MEDICALLY_NECESSARY_CONTACTS_DESCRIPTION,
  orthodontiaLifetimeMax: ORTHODONTIA_LIFETIME_MAX_DESCRIPTION,
  outOfNetworkReimbursement: OUT_OF_NETWORK_REIMBURSEMENT_DESCRIPTION,
  outPatient: HOSPITAL_OUTPATIENT_DESCRIPTION,
  periodonticCare: PERIODONTIC_CARE_DESCRIPTION,
  preventive: PREVENTIVE_CARE_DESCRIPTION,
  virtualCareVisit: VIRTUAL_CARE_VISIT_DESCRIPTION,
  waitingPeriod: WAITING_PERIOD_DESCRIPTION,
  individualWithinFamilyOutOfPocketMax: IND_WITHIN_FAMILY_OOP_MAX_DESCRIPTION,
  familyOutOfPocketMax: OUT_OF_POCKET_MAX_FAMILY_DESCRIPTION,
  individualOutOfPocketMax: OUT_OF_POCKET_MAX_FAMILY_DESCRIPTION,
};

export const SPECIALIZED_FIELD_KEYS = {
  deductibleCost: {
    family: FAMILY_DEDUCTIBLE,
    individual: INDIVIDUAL_DEDUCTIBLE,
  },
  deductibles: {
    family: FAMILY_DEDUCTIBLE,
    individual: INDIVIDUAL_DEDUCTIBLE,
  },
  outOfPocket: {
    family: FAMILY_OUT_OF_POCKET_MAX,
    individual: INDIVIDUAL_OUT_OF_POCKET_MAX,
  },
  orthodontiaLifetimeMax: {
    family: ORTHODONTIA_MAXIMUM,
    individual: ORTHODONTIA_MAXIMUM,
  },
  calendarYearMax: {
    family: DENTAL_ANNUAL_MAXIMUM,
    individual: DENTAL_ANNUAL_MAXIMUM,
  },
  indWithinFamilyOOPMax: {
    individual: OUT_OF_POCKET_MAX_IND_WITHIN_FAM,
    family: OUT_OF_POCKET_MAX_IND_WITHIN_FAM,
  },
  indWithinFamilyDeductible: {
    individual: DEDUCTIBLE_IND_WITHIN_FAM,
    family: DEDUCTIBLE_IND_WITHIN_FAM,
  },
  outOfPocketMax: {
    family: FAMILY_OUT_OF_POCKET_MAX,
    individual: INDIVIDUAL_OUT_OF_POCKET_MAX,
  },
  rxDeductibles: {
    family: FAMILY_DEDUCTIBLE,
    individual: INDIVIDUAL_DEDUCTIBLE,
  },
  rxOOP: {
    family: FAMILY_OUT_OF_POCKET_MAX,
    individual: INDIVIDUAL_OUT_OF_POCKET_MAX,
  },
};

export const SPECIALIZED_FIELD_DESCRIPTION_KEYS = {
  deductibleCost: {
    family: INDIVIDUAL_DEDUCTIBLE_DESCRIPTION,
    individual: DENTAL_INDIVIDUAL_DEDUCTIBLE_DESCRIPTION,
  },
  indWithinFamilyOOPMax: {
    individual: IND_WITHIN_FAMILY_OOP_MAX_DESCRIPTION,
    family: IND_WITHIN_FAMILY_OOP_MAX_DESCRIPTION,
  },
  outOfPocketMax: {
    family: OUT_OF_POCKET_MAX_FAMILY_DESCRIPTION,
    individual: OUT_OF_POCKET_MAX_FAMILY_DESCRIPTION,
  },
  rxDeductibles: {
    family: RX_DEDUCTIBLE_DESCRIPTION,
    individual: RX_DEDUCTIBLE_DESCRIPTION,
  },
  rxOOP: {
    family: RX_OUT_OF_POCKET_MAX_DESCRIPTION,
    individual: RX_OUT_OF_POCKET_MAX_DESCRIPTION,
  },
};

export const RX_TIER_FIELD_KEYS = {
  mailRxCost: {
    TIER_1: MAIL_ORDER_TIER_1,
    TIER_2: MAIL_ORDER_TIER_2,
    TIER_3: MAIL_ORDER_TIER_3,
    TIER_4: MAIL_ORDER_TIER_4,
    TIER_5: MAIL_ORDER_TIER_5,
    TIER_6: MAIL_ORDER_TIER_6,
    TIER_7: MAIL_ORDER_TIER_7,
    TIER_8: MAIL_ORDER_TIER_8,
  },
  rxCost: {
    TIER_1: RETAIL_TIER_1,
    TIER_2: RETAIL_TIER_2,
    TIER_3: RETAIL_TIER_3,
    TIER_4: RETAIL_TIER_4,
    TIER_5: RETAIL_TIER_5,
    TIER_6: RETAIL_TIER_6,
    TIER_7: RETAIL_TIER_7,
    TIER_8: RETAIL_TIER_8,
  },
};

export const RX_TIER_FIELD_DESCRIPTION_KEYS = {
  mailRxCost: {
    TIER_1: MAIL_ORDER_PHARMACY_DESCRIPTION,
    TIER_2: MAIL_ORDER_PHARMACY_DESCRIPTION,
    TIER_3: MAIL_ORDER_PHARMACY_DESCRIPTION,
    TIER_4: MAIL_ORDER_PHARMACY_DESCRIPTION,
    TIER_5: MAIL_ORDER_PHARMACY_DESCRIPTION,
    TIER_6: MAIL_ORDER_PHARMACY_DESCRIPTION,
    TIER_7: MAIL_ORDER_PHARMACY_DESCRIPTION,
    TIER_8: MAIL_ORDER_PHARMACY_DESCRIPTION,
  },
};

export const HEADER_KEYS = {
  'DEDUCTIBLES & BENEFIT MAXIMUMS': DEDUCTIBLES_BENEFIT_MAXIMUMS,
  'DEDUCTIBLES & OOP MAXIMUM': DEDUCTIBLES_AND_OOP_MAXIMUM,
  FREQUENCIES: FREQUENCIES,
  SERVICES: SERVICES,
  RX: RX,
};

// Mapping of section codes to language constant keys
export const SECTION_KEYS: { [key: string]: string } = {
  [SectionName.FOUR_ONE_K_OVERVIEW_TEXT]: OVERVIEW,
  [SectionName.FOUR_ONE_K_CONTRIBUTIONS_TEXT]: CONTRIBUTIONS,
  [SectionName.FOUR_ONE_K_ADVANTAGES_TEXT]: ADVANTAGES,
  [SectionName.HSA_OVERVIEW_TEXT]: OVERVIEW,
  [SectionName.HSA_ELIGIBILITY_TEXT]: ELIGIBILITY,
  [SectionName.HSA_EXPENSES_TEXT]: EXPENSES,
  [SectionName.HSA_ADVANTAGES_TEXT]: ADVANTAGES,
  [SectionName.HSA_CONSIDERATIONS_TEXT]: CONSIDERATIONS,
  [SectionName.HRA_OVERVIEW_TEXT]: OVERVIEW,
  [SectionName.HRA_ELIGIBILITY_TEXT]: ELIGIBILITY,
  [SectionName.HRA_EXPENSES_TEXT]: EXPENSES,
  [SectionName.HRA_ADVANTAGES_TEXT]: ADVANTAGES,
  [SectionName.HRA_CONSIDERATIONS_TEXT]: CONSIDERATIONS,
  [SectionName.COMMUTER_OVERVIEW_TEXT]: OVERVIEW,
  [SectionName.COMMUTER_ELIGIBILITY_TEXT]: ELIGIBILITY,
  [SectionName.COMMUTER_EXPENSES_TEXT]: EXPENSES,
  [SectionName.COMMUTER_ADVANTAGES_TEXT]: ADVANTAGES,
  [SectionName.COMMUTER_CONSIDERATIONS_TEXT]: CONSIDERATIONS,
  [SectionName.FSA_OVERVIEW_TEXT]: OVERVIEW,
  [SectionName.FSA_ELIGIBILITY_TEXT]: ELIGIBILITY,
  [SectionName.FSA_EXPENSES_TEXT]: EXPENSES,
  [SectionName.FSA_ADVANTAGES_TEXT]: ADVANTAGES,
  [SectionName.FSA_CONSIDERATIONS_TEXT]: CONSIDERATIONS,
  [SectionName.LIMITED_FSA_OVERVIEW_TEXT]: OVERVIEW,
  [SectionName.LIMITED_FSA_ELIGIBILITY_TEXT]: ELIGIBILITY,
  [SectionName.LIMITED_FSA_EXPENSES_TEXT]: EXPENSES,
  [SectionName.LIMITED_FSA_ADVANTAGES_TEXT]: ADVANTAGES,
  [SectionName.LIMITED_FSA_CONSIDERATIONS_TEXT]: CONSIDERATIONS,
  [SectionName.DCAP_FSA_OVERVIEW_TEXT]: OVERVIEW,
  [SectionName.DCAP_FSA_ELIGIBILITY_TEXT]: ELIGIBILITY,
  [SectionName.DCAP_FSA_EXPENSES_TEXT]: EXPENSES,
  [SectionName.DCAP_FSA_ADVANTAGES_TEXT]: ADVANTAGES,
  [SectionName.DCAP_FSA_CONSIDERATIONS_TEXT]: CONSIDERATIONS,
};

// HIW Section Title Keys Mapping
export const HIW_SECTION_KEYS: { [key: string]: any } = {
  [SectionName.HIW_HOW_DOES_A_DEDUCTIBLE_WORK]: HOW_DOES_A_DEDUCTIBLE_WORK,
  [SectionName.HIW_WHAT_COUNTS_TOWARDS_A_DEDUCTIBLE]:
    WHAT_COUNTS_TOWARDS_A_DEDUCTIBLE,
  [SectionName.HIW_WHAT_IS_COINSURANCE]: WHAT_IS_COINSURANCE,
  [SectionName.HIW_COUNTS_TOWARDS_AN_OUT_OF_POCKET_LIMIT]:
    WHAT_COUNTS_TOWARDS_AN_OUT_OF_POCKET_LIMIT,
  [SectionName.HIW_WHAT_IS_IN_NETWORK_VS_OUT_NETWORK]:
    WHAT_IS_IN_NETWORK_VS_OUT_OF_NETWORK,
  [SectionName.HIW_WHAT_HAPPENS_IF_I_GO_OUT_OF_NETWORK]:
    WHAT_HAPPENS_IF_I_GO_OUT_OF_NETWORK,
  [SectionName.HIW_CHANGING_MEDICAL_CARRIERS]: CHANGING_MEDICAL_CARRIERS,
  [SectionName.HIW_PRIOR_AUTHORIZATION_OF_PRESCRIPTION]:
    PRIOR_AUTHORIZATION_FOR_PRESCRIPTIONS,
};

// Internationalized route titles mapping
export const internationalizedRouteTitles: Record<string, string> = {
  HOME: HOME,
  NEW_HIRE_CHECKLIST: NEW_HIRE_CHECKLIST,
  HOW_INSURANCE_WORKS: HOW_INSURANCE_WORKS,
  DATES_AND_ELIGIBILITY: DATES_AND_ELIGIBILITY,
  BENEFITS_WELLNESS: BENEFITS_WELLNESS,
  MEDICAL: MEDICAL,
  TELEHEALTH: TELEHEALTH_RX_DELIVERY,
  DENTAL: DENTAL,
  VISION: VISION,
  LIFE_AND_DISABILITY: LIFE_AND_DISABILITY,
  VOLUNTARY_BENEFITS: VOLUNTARY_BENEFITS,
  WORKSITE: WORKSITE,
  WELLBEING: WELLBEING,
  TAX_ADVANTAGED: TAX_ADVANTAGED_ACCTS,
  HRA: 'HRA',
  FSA: 'FSA',
  HSA: 'HSA',
  COMMUTER_GENERIC: COMMUTER_GENERIC,
  FOUR_O_ONE_K: FOUR_O_ONE_K,
  HOLIDAYS_AND_TIME_OFF: HOLIDAYS_TIME_OFF,
  FAMILY_LEAVE: FAMILY_LEAVE,
  ADDITIONAL_PERKS: ADDITIONAL_PERKS,
  RESOURCES: RESOURCES,
  DISCLOSURES: DISCLOSURES,
  CUSTOM_PAGES: CUSTOM_PAGES,
};

// Mapping of Life & Disability Card tooltip keys to language constant keys
export const LIFE_AND_DISABILITY_CARD_TOOLTIP_KEY: { [key: string]: string } = {
  benefit: BENEFIT_TOOLTIP,
  maxBenefit: MAX_BENEFIT_TOOLTIP,
  guaranteedIssue: GUARANTEED_ISSUE_TOOLTIP,
  maxWeeklyBenefit: MAX_WEEKLY_BENEFIT_TOOLTIP,
  maxMonthlyBenefit: MAX_MONTHLY_BENEFIT_TOOLTIP,
  waitingPeriod: WAITING_PERIOD_TOOLTIP,
  maxBenefitDuration: MAX_BENEFIT_DURATION_TOOLTIP,
  volBenefit: VOL_BENEFIT_TOOLTIP,
  volGuaranteedIssue: VOL_GUARANTEED_ISSUE_TOOLTIP,
};
